/**
 * WARNING: This file is auto-generated
 *
 * DO NOT UPDATE MANUALLY!
 */

/* eslint-disable */

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: any; output: any };
  Decimal: { input: any; output: any };
  EmailAddress: { input: any; output: any };
  JSON: { input: any; output: any };
  Url: { input: any; output: any };
  UserFileUploadS3TempUrl: { input: any; output: any };
};

/** Autogenerated input type of AcceptTerms */
export type AcceptTermsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AcceptTerms */
export type AcceptTermsPayload = {
  readonly __typename?: 'AcceptTermsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The user that accepted the terms. */
  readonly me?: Maybe<User>;
};

/** Registration balance and usage for Advanced plans */
export type AdvancedRegistrationsUsage = {
  readonly __typename?: 'AdvancedRegistrationsUsage';
  /** The number of included registrations. */
  readonly included: Scalars['Int']['output'];
  /** The number of used registrations. */
  readonly used: Scalars['Int']['output'];
};

/** Registration balance and usage for Appsumo plans. */
export type AppsumoRegistrationsUsage = {
  readonly __typename?: 'AppsumoRegistrationsUsage';
  /** The number of included free registrations. */
  readonly includedFree: Scalars['Int']['output'];
  /** The number of included paid registrations. */
  readonly includedPaid: Scalars['Int']['output'];
  /** The number of used free registrations. */
  readonly usedFree: Scalars['Int']['output'];
  /** The number of used paid registrations. */
  readonly usedPaid: Scalars['Int']['output'];
};

/** PaymentPlan value objects containing attendees stats. */
export type AttendeesStats = BaseAttendeesStats | EssentialsAttendeesStats;

/** Attendees stats where no plans is defined */
export type BaseAttendeesStats = {
  readonly __typename?: 'BaseAttendeesStats';
  /** attendees allowance per event. */
  readonly name?: Maybe<Scalars['Int']['output']>;
};

/** Registration usage when no plan is defined */
export type BaseRegistrationsUsage = {
  readonly __typename?: 'BaseRegistrationsUsage';
  /** dummy field. */
  readonly name?: Maybe<Scalars['Int']['output']>;
};

/** Currency codes. */
export enum CurrencyCode {
  /** United Arab Emirates Dirham. */
  Aed = 'AED',
  /** Afghan Afghani. */
  Afn = 'AFN',
  /** Albanian Lek. */
  All = 'ALL',
  /** Armenian Dram. */
  Amd = 'AMD',
  /** Netherlands Antillean Gulden. */
  Ang = 'ANG',
  /** Angolan Kwanza. */
  Aoa = 'AOA',
  /** Argentine Peso. */
  Ars = 'ARS',
  /** Australian Dollar. */
  Aud = 'AUD',
  /** Aruban Florin. */
  Awg = 'AWG',
  /** Azerbaijani Manat. */
  Azn = 'AZN',
  /** Bosnia and Herzegovina Convertible Mark. */
  Bam = 'BAM',
  /** Barbadian Dollar. */
  Bbd = 'BBD',
  /** Bangladeshi Taka. */
  Bdt = 'BDT',
  /** Bulgarian Lev. */
  Bgn = 'BGN',
  /** Burundian Franc. */
  Bif = 'BIF',
  /** Bermudian Dollar. */
  Bmd = 'BMD',
  /** Brunei Dollar. */
  Bnd = 'BND',
  /** Bolivian Boliviano. */
  Bob = 'BOB',
  /** Brazilian Real. */
  Brl = 'BRL',
  /** Bahamian Dollar. */
  Bsd = 'BSD',
  /** Botswana Pula. */
  Bwp = 'BWP',
  /** Belize Dollar. */
  Bzd = 'BZD',
  /** Canadian Dollar. */
  Cad = 'CAD',
  /** Congolese Franc. */
  Cdf = 'CDF',
  /** Swiss Franc. */
  Chf = 'CHF',
  /** Chilean Peso. */
  Clp = 'CLP',
  /** Chinese Renminbi Yuan. */
  Cny = 'CNY',
  /** Colombian Peso. */
  Cop = 'COP',
  /** Costa Rican Colón. */
  Crc = 'CRC',
  /** Cape Verdean Escudo. */
  Cve = 'CVE',
  /** Czech Koruna. */
  Czk = 'CZK',
  /** Djiboutian Franc. */
  Djf = 'DJF',
  /** Danish Krone. */
  Dkk = 'DKK',
  /** Dominican Peso. */
  Dop = 'DOP',
  /** Algerian Dinar. */
  Dzd = 'DZD',
  /** Egyptian Pound. */
  Egp = 'EGP',
  /** Ethiopian Birr. */
  Etb = 'ETB',
  /** Euro. */
  Eur = 'EUR',
  /** Fijian Dollar. */
  Fjd = 'FJD',
  /** Falkland Pound. */
  Fkp = 'FKP',
  /** British Pound. */
  Gbp = 'GBP',
  /** Georgian Lari. */
  Gel = 'GEL',
  /** Gibraltar Pound. */
  Gip = 'GIP',
  /** Gambian Dalasi. */
  Gmd = 'GMD',
  /** Guinean Franc. */
  Gnf = 'GNF',
  /** Guatemalan Quetzal. */
  Gtq = 'GTQ',
  /** Guyanese Dollar. */
  Gyd = 'GYD',
  /** Hong Kong Dollar. */
  Hkd = 'HKD',
  /** Honduran Lempira. */
  Hnl = 'HNL',
  /** Croatian Kuna. */
  Hrk = 'HRK',
  /** Haitian Gourde. */
  Htg = 'HTG',
  /** Hungarian Forint. */
  Huf = 'HUF',
  /** Indonesian Rupiah. */
  Idr = 'IDR',
  /** Israeli New Sheqel. */
  Ils = 'ILS',
  /** Indian Rupee. */
  Inr = 'INR',
  /** Icelandic Króna. */
  Isk = 'ISK',
  /** Jamaican Dollar. */
  Jmd = 'JMD',
  /** Japanese Yen. */
  Jpy = 'JPY',
  /** Kenyan Shilling. */
  Kes = 'KES',
  /** Kyrgyzstani Som. */
  Kgs = 'KGS',
  /** Cambodian Riel. */
  Khr = 'KHR',
  /** Comorian Franc. */
  Kmf = 'KMF',
  /** South Korean Won. */
  Krw = 'KRW',
  /** Cayman Islands Dollar. */
  Kyd = 'KYD',
  /** Kazakhstani Tenge. */
  Kzt = 'KZT',
  /** Lao Kip. */
  Lak = 'LAK',
  /** Lebanese Pound. */
  Lbp = 'LBP',
  /** Sri Lankan Rupee. */
  Lkr = 'LKR',
  /** Liberian Dollar. */
  Lrd = 'LRD',
  /** Lesotho Loti. */
  Lsl = 'LSL',
  /** Moroccan Dirham. */
  Mad = 'MAD',
  /** Moldovan Leu. */
  Mdl = 'MDL',
  /** Malagasy Ariary. */
  Mga = 'MGA',
  /** Macedonian Denar. */
  Mkd = 'MKD',
  /** Myanmar Kyat. */
  Mmk = 'MMK',
  /** Mongolian Tögrög. */
  Mnt = 'MNT',
  /** Macanese Pataca. */
  Mop = 'MOP',
  /** Mauritanian Ouguiya. */
  Mro = 'MRO',
  /** Mauritian Rupee. */
  Mur = 'MUR',
  /** Maldivian Rufiyaa. */
  Mvr = 'MVR',
  /** Malawian Kwacha. */
  Mwk = 'MWK',
  /** Mexican Peso. */
  Mxn = 'MXN',
  /** Malaysian Ringgit. */
  Myr = 'MYR',
  /** Mozambican Metical. */
  Mzn = 'MZN',
  /** Namibian Dollar. */
  Nad = 'NAD',
  /** Nigerian Naira. */
  Ngn = 'NGN',
  /** Nicaraguan Córdoba. */
  Nio = 'NIO',
  /** Norwegian Krone. */
  Nok = 'NOK',
  /** Nepalese Rupee. */
  Npr = 'NPR',
  /** New Zealand Dollar. */
  Nzd = 'NZD',
  /** Panamanian Balboa. */
  Pab = 'PAB',
  /** Peruvian Sol. */
  Pen = 'PEN',
  /** Papua New Guinean Kina. */
  Pgk = 'PGK',
  /** Philippine Peso. */
  Php = 'PHP',
  /** Pakistani Rupee. */
  Pkr = 'PKR',
  /** Polish Złoty. */
  Pln = 'PLN',
  /** Paraguayan Guaraní. */
  Pyg = 'PYG',
  /** Qatari Riyal. */
  Qar = 'QAR',
  /** Romanian Leu. */
  Ron = 'RON',
  /** Serbian Dinar. */
  Rsd = 'RSD',
  /** Russian Ruble. */
  Rub = 'RUB',
  /** Rwandan Franc. */
  Rwf = 'RWF',
  /** Saudi Riyal. */
  Sar = 'SAR',
  /** Solomon Islands Dollar. */
  Sbd = 'SBD',
  /** Seychellois Rupee. */
  Scr = 'SCR',
  /** Swedish Krona. */
  Sek = 'SEK',
  /** Singapore Dollar. */
  Sgd = 'SGD',
  /** Saint Helenian Pound. */
  Shp = 'SHP',
  /** Sierra Leonean Leone. */
  Sll = 'SLL',
  /** Somali Shilling. */
  Sos = 'SOS',
  /** Surinamese Dollar. */
  Srd = 'SRD',
  /** São Tomé and Príncipe Dobra. */
  Std = 'STD',
  /** Swazi Lilangeni. */
  Szl = 'SZL',
  /** Thai Baht. */
  Thb = 'THB',
  /** Tajikistani Somoni. */
  Tjs = 'TJS',
  /** Tongan Paʻanga. */
  Top = 'TOP',
  /** Turkish Lira. */
  Try = 'TRY',
  /** Trinidad and Tobago Dollar. */
  Ttd = 'TTD',
  /** New Taiwan Dollar. */
  Twd = 'TWD',
  /** Tanzanian Shilling. */
  Tzs = 'TZS',
  /** Ukrainian Hryvnia. */
  Uah = 'UAH',
  /** Ugandan Shilling. */
  Ugx = 'UGX',
  /** United States Dollar. */
  Usd = 'USD',
  /** Uruguayan Peso. */
  Uyu = 'UYU',
  /** Uzbekistan Som. */
  Uzs = 'UZS',
  /** Vietnamese Đồng. */
  Vnd = 'VND',
  /** Vanuatu Vatu. */
  Vuv = 'VUV',
  /** Samoan Tala. */
  Wst = 'WST',
  /** Central African Cfa Franc. */
  Xaf = 'XAF',
  /** East Caribbean Dollar. */
  Xcd = 'XCD',
  /** West African Cfa Franc. */
  Xof = 'XOF',
  /** Cfp Franc. */
  Xpf = 'XPF',
  /** Yemeni Rial. */
  Yer = 'YER',
  /** South African Rand. */
  Zar = 'ZAR',
  /** Zambian Kwacha. */
  Zmw = 'ZMW',
}

/** Represents an error in the input of a mutation. */
export type DisplayableError = {
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** An event section for duplication. */
export type DuplicatableEventSection = {
  readonly __typename?: 'DuplicatableEventSection';
  /**
   * The availability of the event section to be duplicated. If
   * unavailable, a reason is provided.
   */
  readonly availability: DuplicatableEventSectionAvailability;
  /** Name of the duplicatable event section. */
  readonly name: DuplicatableEventSectionName;
};

/**
 * Represents the availability of an event section to be duplicated.
 * Unavailable event sections contain a message specifying the reason why
 * they're unavailable.
 */
export type DuplicatableEventSectionAvailability = {
  readonly __typename?: 'DuplicatableEventSectionAvailability';
  /** The duplicatable event section availability code. */
  readonly code: DuplicatableEventSectionAvailabilityCode;
  /** The reason why the event section is unavailable for duplication. */
  readonly message?: Maybe<Scalars['String']['output']>;
};

/** Duplicatable event section availability codes. */
export enum DuplicatableEventSectionAvailabilityCode {
  /** Event section is available for duplication. */
  AvailableForDuplication = 'AVAILABLE_FOR_DUPLICATION',
  /**
   * Event section is unavailable either due to not being available
   * in the original event or not being supported by the organization's
   * current payment plan.
   */
  UnavailableForDuplication = 'UNAVAILABLE_FOR_DUPLICATION',
}

/** List of event sections that can be duplicated. */
export enum DuplicatableEventSectionName {
  /** Duplicate all email settings. */
  Emails = 'EMAILS',
  /** Duplicate event polls. */
  EventPolls = 'EVENT_POLLS',
  /** Duplicate all booths, sponsors, and sponsor areas. */
  ExpoAndSponsors = 'EXPO_AND_SPONSORS',
  /** Duplicate event documents. */
  Media = 'MEDIA',
  /** Duplicate all networking settings. */
  Networking = 'NETWORKING',
  /** Duplicate the reception page customization. */
  Reception = 'RECEPTION',
  /** Duplicate all settings from Registration -> Details page */
  RegistrationDetails = 'REGISTRATION_DETAILS',
  /**
   * Duplicate the classic registration page customization. Excludes
   * sponsors and sponsor areas.
   */
  RegistrationPage = 'REGISTRATION_PAGE',
  /** Duplicate all event schedules. */
  Schedules = 'SCHEDULES',
  /** Duplicate all sessions and session-related settings. */
  Sessions = 'SESSIONS',
  /** Duplicate all speakers. */
  Speakers = 'SPEAKERS',
  /** Duplicate all stages and stage-related settings. */
  Stages = 'STAGES',
  /** Duplicate event theme customizations. */
  Theming = 'THEMING',
  /** Duplicate all tickets and ticket groups. */
  Tickets = 'TICKETS',
  /** Duplicate settings related to venue controls (access to the event, attendee experience, activity panel). */
  VenueControls = 'VENUE_CONTROLS',
}

/** Attendees stats for Essentials plans */
export type EssentialsAttendeesStats = {
  readonly __typename?: 'EssentialsAttendeesStats';
  /** attendees allowance per event. */
  readonly eventAttendeesAllowance: Scalars['Int']['output'];
  /**
   * The number of events that are within the attendees
   *                                                        allowance.
   */
  readonly eventCountAboveAllowance: Scalars['Int']['output'];
  /**
   * The number of events that exeeded the attendees
   *                                                        allowance.
   */
  readonly eventCountBelowAllowance: Scalars['Int']['output'];
};

/** An Event resource. */
export type Event = {
  readonly __typename?: 'Event';
  /** To attach calendar invite (.ics) file while sending event email */
  readonly attachCalendarInvite: Scalars['Boolean']['output'];
  /** Whether or not the event can be duplicated. */
  readonly canBeDuplicated?: Maybe<Scalars['Boolean']['output']>;
  /** The date and time (ISO 8601 format) when the event was created. */
  readonly createdAt: Scalars['DateTime']['output'];
  /** Whether or not the event can be deleted. */
  readonly deletable?: Maybe<EventDeletableStatus>;
  /** The event description. */
  readonly description?: Maybe<Scalars['String']['output']>;
  /**
   * The list of event sections that can be duplicated into a new event.
   * Some event sections are available only to specific payment plans and
   * may therefore be unavailable in the current payment plan of the
   * event's organization. Unavailable event sections contain a
   * message specifying the reason why they're unavailable.
   */
  readonly duplicatableEventSections?: Maybe<
    ReadonlyArray<DuplicatableEventSection>
  >;
  /** The event kind. */
  readonly eventKind: Scalars['String']['output'];
  /** The event's event series. */
  readonly eventSeries: EventSeriesConnection;
  /** The number of series an event belongs to. */
  readonly eventSeriesCount?: Maybe<Scalars['Int']['output']>;
  /** Names of the event series this event belongs to. */
  readonly eventSeriesNames: ReadonlyArray<Scalars['String']['output']>;
  /** The event expiration status. */
  readonly expired: Scalars['Boolean']['output'];
  /** The event organizer. */
  readonly host: Host;
  /** A global unique identifier of the event. */
  readonly id: Scalars['ID']['output'];
  /** The image for the event. */
  readonly image: Image;
  /** Whether or not the event is a lite event. */
  readonly isLite: Scalars['Boolean']['output'];
  /** Org Linkedin Url */
  readonly linkedinCompanyUrl?: Maybe<Scalars['String']['output']>;
  /** linkedin_company_url update time */
  readonly linkedinCompanyUrlEnabledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The logo for the event. */
  readonly logo: Image;
  /** The event name. */
  readonly name: Scalars['String']['output'];
  /** The organization members that have access to this event. */
  readonly organizationMembersWithAccess: EventOrganizationMemberConnection;
  /** The organization members that do not have access to this event. */
  readonly organizationMembersWithoutAccess: EventOrganizationMemberConnection;
  /** The ticket price range of the event with prices formatted as decimals. */
  readonly priceRange: EventPriceRange;
  /** The users that are registered to this event. */
  readonly registrants?: Maybe<EventRegistrantConnection>;
  /** The event registration page URL. */
  readonly registrationPageUrl: Scalars['Url']['output'];
  /** The total number of event registrations. */
  readonly registrationsCount?: Maybe<Scalars['Int']['output']>;
  /** A unique human-friendly string of the event name. */
  readonly slug: Scalars['String']['output'];
  /** Fetches an event speaker by ID. */
  readonly speaker?: Maybe<EventSpeaker>;
  /** The event's speakers. */
  readonly speakers: EventSpeakerConnection;
  /** Fetches stage by UUID. Returns null if the stage doesn't exist. */
  readonly stage?: Maybe<Stage>;
  /** Stages that belong to this event. */
  readonly stages?: Maybe<StageConnection>;
  /** The event status. */
  readonly status?: Maybe<EventStatus>;
  /** The event's tickets. */
  readonly tickets: TicketConnection;
  /** The event end date and time (ISO 8601 format) in UTC. */
  readonly timeEnd: Scalars['DateTime']['output'];
  /** The event start date and time (ISO 8601 format) in UTC. */
  readonly timeStart: Scalars['DateTime']['output'];
  /** The event time zone name. */
  readonly timeZone: Scalars['String']['output'];
  /** The date and time (ISO 8601 format) when the event was last modified. */
  readonly updatedAt: Scalars['DateTime']['output'];
  /** The event venue type. */
  readonly venueType: Scalars['String']['output'];
};

/** An Event resource. */
export type EventEventSeriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSeriesSortKeys>;
};

/** An Event resource. */
export type EventOrganizationMembersWithAccessArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<OrganizationMemberSortKeys>;
};

/** An Event resource. */
export type EventOrganizationMembersWithoutAccessArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<OrganizationMemberSortKeys>;
};

/** An Event resource. */
export type EventRegistrantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventRegistrantSortKeys>;
};

/** An Event resource. */
export type EventSpeakerArgs = {
  speakerId: Scalars['ID']['input'];
};

/** An Event resource. */
export type EventSpeakersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSpeakerSortKeys>;
};

/** An Event resource. */
export type EventStageArgs = {
  stageUuid: Scalars['ID']['input'];
};

/** An Event resource. */
export type EventStagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventStageSortKeys>;
};

/** An Event resource. */
export type EventTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<TicketSortKeys>;
};

/** The connection type for Event. */
export type EventConnection = {
  readonly __typename?: 'EventConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<EventEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** Whether or not the event can be deleted. */
export enum EventDeletableStatus {
  /** The event can be deleted. */
  Deletable = 'DELETABLE',
  /** The event cannot be deleted because there are registrations that have not been refunded. */
  NotRefundedRegistrations = 'NOT_REFUNDED_REGISTRATIONS',
}

/** An error that occurs during the execution of EventDelete. */
export type EventDeleteError = DisplayableError & {
  readonly __typename?: 'EventDeleteError';
  /** The error code. */
  readonly code: EventDeleteErrorCode;
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Error codes that can be returned by `EventDeleteError`. */
export enum EventDeleteErrorCode {
  /** Non-refunded, non-organizer(preview) registrations exist for this event. */
  ExistingRegistrations = 'EXISTING_REGISTRATIONS',
}

/** Autogenerated input type of EventDelete */
export type EventDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the event to be deleted. */
  readonly eventId: Scalars['ID']['input'];
};

/** Autogenerated return type of EventDelete */
export type EventDeletePayload = {
  readonly __typename?: 'EventDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted event. */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<EventDeleteError>;
};

/** An error that occurs during the execution of EventDuplicate. */
export type EventDuplicateError = DisplayableError & {
  readonly __typename?: 'EventDuplicateError';
  /** The error code. */
  readonly code: EventDuplicateErrorCode;
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Error codes that can be returned by `EventDuplicateError`. */
export enum EventDuplicateErrorCode {
  /** The input is blank. */
  Blank = 'BLANK',
  /** Event duplication failed. Error details have been logged and will be investigated. */
  DuplicationFailed = 'DUPLICATION_FAILED',
  /** Event length exceeds the allowed maximum. */
  EventTooLong = 'EVENT_TOO_LONG',
  /** The input format is invalid. */
  Invalid = 'INVALID',
  /** The provided time is in the past. */
  InThePast = 'IN_THE_PAST',
  /** The end time is earlier than the start time. */
  NegativeDuration = 'NEGATIVE_DURATION',
  /** Some of the selected event sections are not available for duplication. */
  SectionsUnavailable = 'SECTIONS_UNAVAILABLE',
}

/** Autogenerated input type of EventDuplicate */
export type EventDuplicateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the original event. */
  readonly eventId: Scalars['ID']['input'];
  /**
   * The event sections from the original event to be duplicated
   * into the new event.
   */
  readonly eventSections: ReadonlyArray<DuplicatableEventSectionName>;
  /** The new event name. */
  readonly name: Scalars['String']['input'];
  /** The new event end date and time (ISO 8601 format) in UTC. */
  readonly timeEnd: Scalars['DateTime']['input'];
  /** The new event start date and time (ISO 8601 format) in UTC. */
  readonly timeStart: Scalars['DateTime']['input'];
  /** The new event time zone name. */
  readonly timeZone: Scalars['String']['input'];
};

/** Autogenerated return type of EventDuplicate */
export type EventDuplicatePayload = {
  readonly __typename?: 'EventDuplicatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /**
   * The new event that was created as the target of the duplication.
   * This is a blank event, in the `building` status, which indicates
   * that the selected event sections of the original event are still
   * being duplicated.
   */
  readonly newEvent?: Maybe<Event>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<EventDuplicateError>;
};

/** An edge in a connection. */
export type EventEdge = {
  readonly __typename?: 'EventEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Event>;
};

/** A connection of organization members. */
export type EventOrganizationMemberConnection = {
  readonly __typename?: 'EventOrganizationMemberConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<EventOrganizationMemberEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection to an Event which holds one organization member. */
export type EventOrganizationMemberEdge = {
  readonly __typename?: 'EventOrganizationMemberEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The type of access the user has in relation to the event. */
  readonly eventAccess?: Maybe<OrganizationMemberEventAccessTypes>;
  /** The date when the user joined the organization. */
  readonly joinedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The item at the end of the edge. */
  readonly node?: Maybe<OrganizationMember>;
  /** The role of the user in the organization. */
  readonly role?: Maybe<OrganizationMemberRoles>;
};

/** The ticket price range of the event. */
export type EventPriceRange = {
  readonly __typename?: 'EventPriceRange';
  /** The highest ticket price. */
  readonly maxTicketPrice?: Maybe<Money>;
  /** The lowest ticket price. */
  readonly minTicketPrice?: Maybe<Money>;
};

/** A user that is registered for an event. */
export type EventRegistrant = {
  readonly __typename?: 'EventRegistrant';
  /** The registrant's bio. */
  readonly bio?: Maybe<Scalars['String']['output']>;
  /** Whether the user has been blocked. Blocked users cannot access the event. */
  readonly blocked?: Maybe<Scalars['Boolean']['output']>;
  /** The email of the registrant. */
  readonly email: Scalars['EmailAddress']['output'];
  /** The first name of the registrant. */
  readonly firstName: Scalars['String']['output'];
  /** The registrant's headline. */
  readonly headline?: Maybe<Scalars['String']['output']>;
  /** The unique id of the registrant. */
  readonly id: Scalars['ID']['output'];
  /** The image for the registrant. */
  readonly image: Image;
  /** The last name of the registrant. */
  readonly lastName: Scalars['String']['output'];
  /** The registrant's LinkedIn URL. */
  readonly linkedinUrl?: Maybe<Scalars['Url']['output']>;
  /** Whether the user has been refunded. Refunded users can access the event. */
  readonly refunded?: Maybe<Scalars['Boolean']['output']>;
  /** The registrant's Twitter URL. */
  readonly twitterUrl?: Maybe<Scalars['Url']['output']>;
  /** The registrant's Website URL. */
  readonly websiteUrl?: Maybe<Scalars['Url']['output']>;
};

/** The connection type for EventRegistrant. */
export type EventRegistrantConnection = {
  readonly __typename?: 'EventRegistrantConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<EventRegistrantEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EventRegistrantEdge = {
  readonly __typename?: 'EventRegistrantEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EventRegistrant>;
};

/** A user profile that is registered for an event. */
export type EventRegistrantProfile = {
  readonly __typename?: 'EventRegistrantProfile';
  /** The email of the registrant. */
  readonly email?: Maybe<Scalars['EmailAddress']['output']>;
  /** The event associated with this registrant profile. */
  readonly event?: Maybe<Event>;
  /** The first name of the registrant. */
  readonly firstName: Scalars['String']['output'];
  /** The registrant's headline. */
  readonly headline?: Maybe<Scalars['String']['output']>;
  /** The unique id of the registrant. */
  readonly id: Scalars['ID']['output'];
  /** The image for the registrant. */
  readonly image: Image;
  /** The last name of the registrant. */
  readonly lastName: Scalars['String']['output'];
  /** The registrant's LinkedIn URL. */
  readonly linkedinUrl?: Maybe<Scalars['Url']['output']>;
  /** The registrant's Twitter URL. */
  readonly twitterUrl?: Maybe<Scalars['Url']['output']>;
  /** The registrant's Website URL. */
  readonly websiteUrl?: Maybe<Scalars['Url']['output']>;
};

/** The connection type for EventRegistrantProfile. */
export type EventRegistrantProfileConnection = {
  readonly __typename?: 'EventRegistrantProfileConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<EventRegistrantProfileEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EventRegistrantProfileEdge = {
  readonly __typename?: 'EventRegistrantProfileEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EventRegistrantProfile>;
};

/** The set of valid sort keys for the event registrants query. */
export enum EventRegistrantSortKeys {
  /** Sort by the _id_ value */
  Id = 'ID',
}

/** An error that occurs during the execution of EventRegistrantUpdateTicket. */
export type EventRegistrantUpdateTicketError = DisplayableError & {
  readonly __typename?: 'EventRegistrantUpdateTicketError';
  /** The error code. */
  readonly code: EventRegistrantUpdateTicketErrorCode;
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Error codes that can be returned by `EventRegistrantUpdateTicket`. */
export enum EventRegistrantUpdateTicketErrorCode {
  /**
   * In order to perform this change and delete segment registrations, the mutation
   * must be called with a `confirm` argument set to `true`.
   */
  HasSegmentRegistrations = 'HAS_SEGMENT_REGISTRATIONS',
  /** The ticket is sold out. */
  SoldOut = 'SOLD_OUT',
  /**
   * Switching from a free to a paid ticket does not make any charge; in order to
   * perform this change, the mutation must be called with a `confirm` argument set to `true`.
   */
  SwitchingFromFreeToPaid = 'SWITCHING_FROM_FREE_TO_PAID',
  /**
   * Switching from a paid to a free ticket does not make any refund; in order to
   * perform this change, the mutation must be called with a `confirm` argument set to `true`.
   */
  SwitchingFromPaidToFree = 'SWITCHING_FROM_PAID_TO_FREE',
  /**
   * Switching from a paid to another paid ticket does not make any refund/charge;
   * in order to perform this change,the mutation must be called with a `confirm`
   * argument set to `true`.
   */
  SwitchingFromPaidToPaid = 'SWITCHING_FROM_PAID_TO_PAID',
}

/** Autogenerated input type of EventRegistrantUpdateTicket */
export type EventRegistrantUpdateTicketInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Flag representing if the user confirms that they want to make sensible changes.
   * If this is false and the ticket type change deals with money (from paid to free,
   * from free to paid or from paid to paid) or has segment registrations, it will return
   * the proper error. If this confirm parameter is true, then it is assumed that the
   * organizer aknowledged the message and confirmed that they want to continue.
   */
  readonly confirm?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the event registrant whose ticket will be updated. */
  readonly eventRegistrantId: Scalars['ID']['input'];
  /** The ID of the new ticket to be assigned to the event registrant. */
  readonly ticketId: Scalars['ID']['input'];
};

/** Autogenerated return type of EventRegistrantUpdateTicket */
export type EventRegistrantUpdateTicketPayload = {
  readonly __typename?: 'EventRegistrantUpdateTicketPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated event registrant. */
  readonly eventRegistrant?: Maybe<EventRegistrant>;
  /** The new ticket that has been assigned to the event registrant. */
  readonly ticket?: Maybe<Ticket>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<EventRegistrantUpdateTicketError>;
};

/** The Schedule of an event. */
export type EventSchedule = {
  readonly __typename?: 'EventSchedule';
  /** A global unique identifier of the EventSchedule. */
  readonly id: Scalars['ID']['output'];
  /** Draft status of the whole event schedule. */
  readonly isDraft: Scalars['Boolean']['output'];
  /** The scheduled sessions for the event. */
  readonly sessions: EventSessionConnection;
  /** The event end date and time (ISO 8601 format) in UTC. */
  readonly timeEnd: Scalars['DateTime']['output'];
  /** The event start date and time (ISO 8601 format) in UTC. */
  readonly timeStart: Scalars['DateTime']['output'];
  /** The event time zone name. */
  readonly timeZone: Scalars['String']['output'];
};

/** The Schedule of an event. */
export type EventScheduleSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSessionSortKeys>;
};

/** An event series grouping several events. */
export type EventSeries = {
  readonly __typename?: 'EventSeries';
  /** Allow multi event registration for this event series. */
  readonly allowMultiEventRegistration: Scalars['Boolean']['output'];
  /** The serie's events. */
  readonly events: EventConnection;
  /** The number of events in the series. */
  readonly eventsCount: Scalars['Int']['output'];
  /** The unique id of the event series. */
  readonly id: Scalars['ID']['output'];
  /** The name of the event series. */
  readonly name: Scalars['String']['output'];
  /** The total number of registrants for all the events in the series. */
  readonly registrants: Scalars['Int']['output'];
  /** The image for the series */
  readonly seriesImage: ReadonlyArray<Image>;
  /** The status of the event series. */
  readonly status: Scalars['String']['output'];
  /** The end time of the last event in the series */
  readonly timeEnd?: Maybe<Scalars['DateTime']['output']>;
  /** The start time of the first event in the series */
  readonly timeStart?: Maybe<Scalars['DateTime']['output']>;
};

/** An event series grouping several events. */
export type EventSeriesEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
};

/** Autogenerated input type of EventSeriesAddEvent */
export type EventSeriesAddEventInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the event that will be added to the event series. */
  readonly eventId: Scalars['ID']['input'];
  /** The ID of the event series that will hold the event. */
  readonly eventSeriesId: Scalars['ID']['input'];
};

/** Autogenerated return type of EventSeriesAddEvent */
export type EventSeriesAddEventPayload = {
  readonly __typename?: 'EventSeriesAddEventPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error messages while adding event to series */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The added event. */
  readonly event?: Maybe<Event>;
  /** The event series. */
  readonly eventSeries?: Maybe<EventSeries>;
};

/** The connection type for EventSeries. */
export type EventSeriesConnection = {
  readonly __typename?: 'EventSeriesConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<EventSeriesEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** Autogenerated input type of EventSeriesCreate */
export type EventSeriesCreateInput = {
  /** Allow multi event registration for this event series. */
  readonly allowMultiEventRegistration?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the event series. */
  readonly name: Scalars['String']['input'];
  /** External org id for which we want to create a event series. */
  readonly organizationId: Scalars['ID']['input'];
  /** External space id for which we want to create an event series. */
  readonly spaceExternalId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of EventSeriesCreate */
export type EventSeriesCreatePayload = {
  readonly __typename?: 'EventSeriesCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error messages while creating event series */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The event series that was created. */
  readonly eventSeries?: Maybe<EventSeries>;
};

/** Autogenerated input type of EventSeriesDelete */
export type EventSeriesDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** External id for the event series we want to delete. */
  readonly eventSeriesId: Scalars['ID']['input'];
};

/** Autogenerated return type of EventSeriesDelete */
export type EventSeriesDeletePayload = {
  readonly __typename?: 'EventSeriesDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted event series. */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
  /** Error messages while deleting a event series */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** An edge in a connection. */
export type EventSeriesEdge = {
  readonly __typename?: 'EventSeriesEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EventSeries>;
};

/** Autogenerated input type of EventSeriesRemoveEventFromAllSeries */
export type EventSeriesRemoveEventFromAllSeriesInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the event that will be removed from all the event series. */
  readonly eventId: Scalars['ID']['input'];
};

/** Autogenerated return type of EventSeriesRemoveEventFromAllSeries */
export type EventSeriesRemoveEventFromAllSeriesPayload = {
  readonly __typename?: 'EventSeriesRemoveEventFromAllSeriesPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The removed event from all event series. */
  readonly event?: Maybe<Event>;
};

/** Autogenerated input type of EventSeriesRemoveEvent */
export type EventSeriesRemoveEventInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the event that will be removed from the event series. */
  readonly eventId: Scalars['ID']['input'];
  /** The ID of the event series that holds the event. */
  readonly eventSeriesId: Scalars['ID']['input'];
};

/** Autogenerated return type of EventSeriesRemoveEvent */
export type EventSeriesRemoveEventPayload = {
  readonly __typename?: 'EventSeriesRemoveEventPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The removed event. */
  readonly event?: Maybe<Event>;
  /** The event series. */
  readonly eventSeries?: Maybe<EventSeries>;
};

/** The set of valid sort keys for the event event series query. */
export enum EventSeriesSortKeys {
  /** Sort by the _id_ value */
  Id = 'ID',
  /** Sort by the _name_ value */
  Name = 'NAME',
}

/** Autogenerated input type of EventSeriesUpdateEventFromAllSeries */
export type EventSeriesUpdateEventFromAllSeriesInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the event to be reassigned to one or more series. */
  readonly eventId: Scalars['ID']['input'];
  /** The IDs of the series to which the event should be reassigned. */
  readonly seriesIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

/** Autogenerated return type of EventSeriesUpdateEventFromAllSeries */
export type EventSeriesUpdateEventFromAllSeriesPayload = {
  readonly __typename?: 'EventSeriesUpdateEventFromAllSeriesPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error messages while updating event series assignments */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The updated event with reassigned series. */
  readonly event?: Maybe<Event>;
};

/** Autogenerated input type of EventSeriesUpdate */
export type EventSeriesUpdateInput = {
  /** Allow multi event registration for this event series. */
  readonly allowMultiEventRegistration?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** External id for the event series we want to update. */
  readonly eventSeriesId: Scalars['ID']['input'];
  /** Name of the event series. */
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EventSeriesUpdate */
export type EventSeriesUpdatePayload = {
  readonly __typename?: 'EventSeriesUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error messages while updating the event series */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The event series that was updated. */
  readonly eventSeries?: Maybe<EventSeries>;
};

/** A scheduled session in the event. */
export type EventSession = {
  readonly __typename?: 'EventSession';
  /** The intended attendance for the event session. */
  readonly attendance: EventSessionAttendance;
  /**
   * The maximum number of attendees for the event session.
   * When `null`, the event session has unlimited capacity.
   */
  readonly capacity?: Maybe<Scalars['Int']['output']>;
  /** The description of the event session. */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** The unique id of the event session. */
  readonly id: Scalars['ID']['output'];
  /** Whether the event session is in draft mode. */
  readonly isDraft: Scalars['Boolean']['output'];
  /** The name of the event session. */
  readonly name: Scalars['String']['output'];
  /**
   * The number of available registrations for the event session.
   * When event session capacity is unlimited this value is null.'
   */
  readonly remainingCapacity?: Maybe<Scalars['Int']['output']>;
  /** The format of the event session. */
  readonly sessionFormat?: Maybe<EventSessionFormats>;
  /** The event session's speakers. */
  readonly speakers: EventSpeakerConnection;
  /** The event session end date and time (ISO 8601 format) in UTC. */
  readonly timeEnd: Scalars['DateTime']['output'];
  /** The event session start date and time (ISO 8601 format) in UTC. */
  readonly timeStart: Scalars['DateTime']['output'];
};

/** A scheduled session in the event. */
export type EventSessionSpeakersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSpeakerSortKeys>;
};

/** The intended attendance for the event session. */
export enum EventSessionAttendance {
  /** Event attendants will be automatically guided to the session. */
  Essential = 'ESSENTIAL',
  /** Event attendants can choose whether to attend the session. */
  Optional = 'OPTIONAL',
  /** Event attendants are advised to attend the session. */
  Recommended = 'RECOMMENDED',
}

/** The connection type for EventSession. */
export type EventSessionConnection = {
  readonly __typename?: 'EventSessionConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<EventSessionEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EventSessionEdge = {
  readonly __typename?: 'EventSessionEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EventSession>;
};

/** The format of the event session. */
export enum EventSessionFormats {
  /** The session will take place online and at a physical location. */
  Hybrid = 'HYBRID',
  /** The session will take place at a physical location. */
  Onsite = 'ONSITE',
  /** The session will take place online. */
  Virtual = 'VIRTUAL',
}

/** The set of valid sort keys for the Schedule sessions query. */
export enum EventSessionSortKeys {
  /** Sort by the end date time of the schedule item. */
  TimeEnd = 'TIME_END',
  /** Sort by the start date & time of the schedule item. */
  TimeStart = 'TIME_START',
}

/** The set of valid sort keys for the Event query. */
export enum EventSortKeys {
  /** Sort by the _id_ value. */
  Id = 'ID',
  /** Sort by the start date & time of the event. */
  TimeEnd = 'TIME_END',
  /** Sort by the start date & time of the event. */
  TimeStart = 'TIME_START',
}

/** An EventSpeaker resource. */
export type EventSpeaker = {
  readonly __typename?: 'EventSpeaker';
  /** The event speaker's bio. */
  readonly bio?: Maybe<Scalars['String']['output']>;
  /** The unique email of the event speaker. */
  readonly email?: Maybe<Scalars['EmailAddress']['output']>;
  /** The first name of the event speaker. */
  readonly firstName: Scalars['String']['output'];
  /** The event speaker's headline. */
  readonly headline?: Maybe<Scalars['String']['output']>;
  /** Whenever the speaker is hidden from the public view. */
  readonly hidden?: Maybe<Scalars['Boolean']['output']>;
  /** The unique id of the event speaker. */
  readonly id: Scalars['ID']['output'];
  /** The image for the event speaker. */
  readonly image: Image;
  /** The last name of the event speaker. */
  readonly lastName: Scalars['String']['output'];
  /** The event speaker's LinkedIn URL. */
  readonly linkedinUrl?: Maybe<Scalars['Url']['output']>;
  /** The event speaker's Order Priority. */
  readonly priority?: Maybe<Scalars['Int']['output']>;
  /** The external ID of the speaker's redeem code. */
  readonly redeemCodeExternalId?: Maybe<Scalars['String']['output']>;
  /** The ID of the speaker's redeem code. */
  readonly redeemCodeId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the speaker's registration. */
  readonly registrationId?: Maybe<Scalars['ID']['output']>;
  /** The event speaker's registration status. */
  readonly registrationStatus: EventSpeakerRegistrationStatus;
  /** The event speaker's links. */
  readonly speakerLinks: ReadonlyArray<SpeakerLink>;
  /** The event speaker's Twitter URL. */
  readonly twitterUrl?: Maybe<Scalars['Url']['output']>;
  /** The event speaker's Website URL. */
  readonly websiteUrl?: Maybe<Scalars['Url']['output']>;
};

/** The connection type for EventSpeaker. */
export type EventSpeakerConnection = {
  readonly __typename?: 'EventSpeakerConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<EventSpeakerEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An error that occurs during the execution of EventSpeakerCreate. */
export type EventSpeakerCreateError = DisplayableError & {
  readonly __typename?: 'EventSpeakerCreateError';
  /** The error code. */
  readonly code: EventSpeakerCreateErrorCode;
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Error codes that can be returned by `EventSpeakerCreateError`. */
export enum EventSpeakerCreateErrorCode {
  /** The e-mail belongs to an existing event speaker. */
  AlreadyExists = 'ALREADY_EXISTS',
  /** The input is blank. */
  Blank = 'BLANK',
  /** The input format is invalid. */
  Invalid = 'INVALID',
  /** The domain in the URL is invalid. */
  InvalidDomain = 'INVALID_DOMAIN',
  /** The email is invalid. */
  InvalidEmail = 'INVALID_EMAIL',
  /** The input is too long. */
  TooLong = 'TOO_LONG',
}

/** Autogenerated input type of EventSpeakerCreateFromRegistrant */
export type EventSpeakerCreateFromRegistrantInput = {
  /** The event speaker's bio. */
  readonly bio?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the event to which the speaker will be added. */
  readonly eventId: Scalars['ID']['input'];
  /** The event speaker's headline. */
  readonly headline?: InputMaybe<Scalars['String']['input']>;
  /** URL to temp S3 file for the event speaker's image. */
  readonly imageUrl?: InputMaybe<Scalars['UserFileUploadS3TempUrl']['input']>;
  /** The event speaker's LinkedIn URL. */
  readonly linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  /** The event speaker's Order Priority. */
  readonly priority?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the registrant to be added as speaker. */
  readonly registrantId: Scalars['ID']['input'];
  /** The event speaker's Twitter URL. */
  readonly twitterUrl?: InputMaybe<Scalars['String']['input']>;
  /** The event speaker's website URL. */
  readonly websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EventSpeakerCreateFromRegistrant */
export type EventSpeakerCreateFromRegistrantPayload = {
  readonly __typename?: 'EventSpeakerCreateFromRegistrantPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The event speaker that was created. */
  readonly eventSpeaker?: Maybe<EventSpeaker>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<EventSpeakerCreateError>;
};

/** Autogenerated input type of EventSpeakerCreate */
export type EventSpeakerCreateInput = {
  /** The event speaker's bio. */
  readonly bio?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The event speaker's email address. */
  readonly email: Scalars['EmailAddress']['input'];
  /** The ID of the event to which the speaker will be added. */
  readonly eventId: Scalars['ID']['input'];
  /** The event speaker's first name. */
  readonly firstName: Scalars['String']['input'];
  /** The event speaker's headline. */
  readonly headline?: InputMaybe<Scalars['String']['input']>;
  /** Whenever the speaker is hidden from the public view. */
  readonly hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** URL to temp S3 file for the event speaker's image. */
  readonly imageUrl?: InputMaybe<Scalars['UserFileUploadS3TempUrl']['input']>;
  /** The event speaker's last name. */
  readonly lastName: Scalars['String']['input'];
  /** The event speaker's LinkedIn URL. */
  readonly linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  /** The event speaker's Order Priority. */
  readonly priority?: InputMaybe<Scalars['Int']['input']>;
  /** The event speaker's Twitter URL. */
  readonly twitterUrl?: InputMaybe<Scalars['String']['input']>;
  /** The event speaker's website URL. */
  readonly websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EventSpeakerCreate */
export type EventSpeakerCreatePayload = {
  readonly __typename?: 'EventSpeakerCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The event speaker that was created. */
  readonly eventSpeaker?: Maybe<EventSpeaker>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<EventSpeakerCreateError>;
};

/** Autogenerated input type of EventSpeakerDelete */
export type EventSpeakerDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the event speaker to be deleted. */
  readonly eventSpeakerId: Scalars['ID']['input'];
};

/** Autogenerated return type of EventSpeakerDelete */
export type EventSpeakerDeletePayload = {
  readonly __typename?: 'EventSpeakerDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted event speaker. */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
};

/** An edge in a connection. */
export type EventSpeakerEdge = {
  readonly __typename?: 'EventSpeakerEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EventSpeaker>;
};

/** An error that occurs during the execution of EventSpeakerRegister. */
export type EventSpeakerRegisterError = DisplayableError & {
  readonly __typename?: 'EventSpeakerRegisterError';
  /** The error code. */
  readonly code: EventSpeakerRegisterErrorCode;
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Error codes that can be returned by `EventSpeakerRegisterError`. */
export enum EventSpeakerRegisterErrorCode {
  /** The event speaker is already registered for the event. */
  AlreadyRegistered = 'ALREADY_REGISTERED',
  /** The event is no longer open for registrations. */
  Inaccessible = 'INACCESSIBLE',
  /** An unknown error occurred. */
  InternalError = 'INTERNAL_ERROR',
  /** The magic link was created but could not be claimed. */
  NotClaimed = 'NOT_CLAIMED',
}

/** Autogenerated input type of EventSpeakerRegister */
export type EventSpeakerRegisterInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the event speaker to be registered. */
  readonly eventSpeakerId: Scalars['ID']['input'];
  /** The ID of the ticket to be used for registering the event speaker. */
  readonly ticketId: Scalars['ID']['input'];
};

/** Autogenerated return type of EventSpeakerRegister */
export type EventSpeakerRegisterPayload = {
  readonly __typename?: 'EventSpeakerRegisterPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The event speaker that was registered. */
  readonly eventSpeaker?: Maybe<EventSpeaker>;
  /** The event for which the speaker was registered. */
  readonly magicLink?: Maybe<MagicLink>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<EventSpeakerRegisterError>;
};

/** The registration status of the event speaker. */
export enum EventSpeakerRegistrationStatus {
  /** The speaker is registered for the event but the registration has been blocked */
  Blocked = 'BLOCKED',
  /** The speaker is not yet registered for the event */
  NotRegistered = 'NOT_REGISTERED',
  /** The speaker has a user account and is already registered for the event */
  Registered = 'REGISTERED',
}

/** The set of valid sort keys for the EventSpeaker query. */
export enum EventSpeakerSortKeys {
  /** Sort by the _first_name_ value */
  FirstName = 'FIRST_NAME',
  /** Sort by the _id_ value */
  Id = 'ID',
  /** Sort by the _last_name_ value */
  LastName = 'LAST_NAME',
  /** Sort by the _priority_ value */
  Priority = 'PRIORITY',
}

/** An error that occurs during the execution of EventSpeakerUpdate. */
export type EventSpeakerUpdateError = DisplayableError & {
  readonly __typename?: 'EventSpeakerUpdateError';
  /** The error code. */
  readonly code: EventSpeakerUpdateErrorCode;
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Error codes that can be returned by `EventSpeakerUpdateError`. */
export enum EventSpeakerUpdateErrorCode {
  /** The input is blank. */
  Blank = 'BLANK',
  /** The input format is invalid. */
  Invalid = 'INVALID',
  /** The domain in the URL is invalid. */
  InvalidDomain = 'INVALID_DOMAIN',
  /** The email is invalid. */
  InvalidEmail = 'INVALID_EMAIL',
  /** The e-mail belongs to an existing event speaker. */
  Taken = 'TAKEN',
  /** The input is too long. */
  TooLong = 'TOO_LONG',
}

/** Autogenerated input type of EventSpeakerUpdate */
export type EventSpeakerUpdateInput = {
  /** The event speaker's bio. */
  readonly bio?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The event speaker's email address. */
  readonly email?: InputMaybe<Scalars['EmailAddress']['input']>;
  /** The ID of the event speaker to be updated. */
  readonly eventSpeakerId: Scalars['ID']['input'];
  /** The event speaker's first name. */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  /** The event speaker's headline. */
  readonly headline?: InputMaybe<Scalars['String']['input']>;
  /** Whenever the speaker is hidden from the public view. */
  readonly hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** URL to temp S3 file for the event speaker's image. */
  readonly imageUrl?: InputMaybe<Scalars['UserFileUploadS3TempUrl']['input']>;
  /** The event speaker's last name. */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** The event speaker's LinkedIn URL. */
  readonly linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  /** The event speaker's Order Priority. */
  readonly priority?: InputMaybe<Scalars['Int']['input']>;
  /** The event speaker's Twitter URL. */
  readonly twitterUrl?: InputMaybe<Scalars['String']['input']>;
  /** The event speaker's website URL. */
  readonly websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EventSpeakerUpdate */
export type EventSpeakerUpdatePayload = {
  readonly __typename?: 'EventSpeakerUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The event speaker that was updated. */
  readonly eventSpeaker?: Maybe<EventSpeaker>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<EventSpeakerUpdateError>;
};

/** Error codes that can be returned by `StageSetupRTMP`. */
export enum EventStageSetupRtmpErrorCode {
  /** RTMP setup creation failed. Error details have been logged and will be investigated. */
  Failed = 'FAILED',
}

/** An error that occurs during the execution of StageSetupRTMP. */
export type EventStageSetupRtmpError = DisplayableError & {
  readonly __typename?: 'EventStageSetupRtmpError';
  /** The error code. */
  readonly code: EventStageSetupRtmpErrorCode;
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** The set of valid sort keys for the Stage query. */
export enum EventStageSortKeys {
  /** Sort by the _id_ value. */
  Id = 'ID',
  /** Sort by the name of the stage. */
  Name = 'NAME',
}

/** The status of the event. */
export enum EventStatus {
  /** The event is being set up and is not yet available for editing by the organizer */
  Building = 'BUILDING',
  /** The event has been deleted. */
  Deleted = 'DELETED',
  /** The event is available for editing by the organizer. It is not yet visible for attendees. */
  Draft = 'DRAFT',
  /** The event has been published and is live. */
  Live = 'LIVE',
  Preview = 'PREVIEW',
}

/** Registration balance and usage for Free plans */
export type FreeRegistrationsUsage = {
  readonly __typename?: 'FreeRegistrationsUsage';
  /** The number of registrations per event. */
  readonly includedPerEvent: Scalars['Int']['output'];
};

/** The event host. */
export type Host = {
  readonly __typename?: 'Host';
  /** The host description. */
  readonly about?: Maybe<Scalars['String']['output']>;
  /** The host facebook page. */
  readonly facebookUrl?: Maybe<Scalars['Url']['output']>;
  /** The host name. */
  readonly name: Scalars['String']['output'];
  /** The host picture. */
  readonly picture: Image;
  /** The host twitter page. */
  readonly twitterUrl?: Maybe<Scalars['Url']['output']>;
  /** The host website. */
  readonly websiteUrl?: Maybe<Scalars['Url']['output']>;
};

/** Represents an image resource. */
export type Image = {
  readonly __typename?: 'Image';
  /** The location of the image as a URL. */
  readonly url?: Maybe<Scalars['Url']['output']>;
};

/** Represents an image resource. */
export type ImageUrlArgs = {
  imgixParams?: InputMaybe<Scalars['JSON']['input']>;
};

/** A MagicLink resource. */
export type MagicLink = {
  readonly __typename?: 'MagicLink';
  /** The date and time (ISO 8601 format) when the magic link was created. */
  readonly createdAt: Scalars['DateTime']['output'];
  /** The email of the magic link recipient. */
  readonly email: Scalars['EmailAddress']['output'];
  /** The event for which the magic link was created. */
  readonly event?: Maybe<Event>;
  /** The first name of the magic link recipient. */
  readonly firstName: Scalars['String']['output'];
  /** The headline of the magic link recipient. */
  readonly headline?: Maybe<Scalars['String']['output']>;
  /** A global unique identifier of the magic link. */
  readonly id: Scalars['ID']['output'];
  /** The last name of the magic link recipient. */
  readonly lastName: Scalars['String']['output'];
  /** The magic link status. */
  readonly status?: Maybe<MagicLinkStatus>;
  /** The ticket associated with the magic link. */
  readonly ticket?: Maybe<Ticket>;
  /** The date and time (ISO 8601 format) when the magic link was last modified. */
  readonly updatedAt: Scalars['DateTime']['output'];
  /** The magic link URL. */
  readonly url?: Maybe<Scalars['Url']['output']>;
};

/** The status of the magic link. */
export enum MagicLinkStatus {
  Declined = 'DECLINED',
  Invited = 'INVITED',
  NotYetInvited = 'NOT_YET_INVITED',
  Registered = 'REGISTERED',
}

/** A monetary value with currency. */
export type Money = {
  readonly __typename?: 'Money';
  /** Decimal money amount. */
  readonly amount: Scalars['Decimal']['output'];
  /** Currency of the money. */
  readonly currencyCode: CurrencyCode;
};

/** The root query for all mutation operations. */
export type Mutation = {
  readonly __typename?: 'Mutation';
  /** Deletes an event. */
  readonly eventDelete?: Maybe<EventDeletePayload>;
  /**
   * Creates a blank new event and initiates the duplication of the
   * original event. The selected event sections of the original event are
   * duplicated in the new event asynchronously.
   */
  readonly eventDuplicate?: Maybe<EventDuplicatePayload>;
  /** Updates the ticket of the event registrant. */
  readonly eventRegistrantUpdateTicket?: Maybe<EventRegistrantUpdateTicketPayload>;
  /** Adds the event to the event series. */
  readonly eventSeriesAddEvent?: Maybe<EventSeriesAddEventPayload>;
  /** Creates a new event series. */
  readonly eventSeriesCreate?: Maybe<EventSeriesCreatePayload>;
  /** Delete the event series. */
  readonly eventSeriesDelete?: Maybe<EventSeriesDeletePayload>;
  /** Removes the event from the event series. */
  readonly eventSeriesRemoveEvent?: Maybe<EventSeriesRemoveEventPayload>;
  /** Removes the event from all the event series. */
  readonly eventSeriesRemoveEventFromAllSeries?: Maybe<EventSeriesRemoveEventFromAllSeriesPayload>;
  /** Updates the event series. */
  readonly eventSeriesUpdate?: Maybe<EventSeriesUpdatePayload>;
  /** Updates the series the event belongs to. */
  readonly eventSeriesUpdateEventFromAllSeries?: Maybe<EventSeriesUpdateEventFromAllSeriesPayload>;
  /** Creates a new event speaker. */
  readonly eventSpeakerCreate?: Maybe<EventSpeakerCreatePayload>;
  /**
   * Adds an event registrant as a speaker. Passing profile attributes as
   * inputs will override the respective registrant's attributes.
   */
  readonly eventSpeakerCreateFromRegistrant?: Maybe<EventSpeakerCreateFromRegistrantPayload>;
  /** Deletes the event speaker. */
  readonly eventSpeakerDelete?: Maybe<EventSpeakerDeletePayload>;
  /** Registers the event speaker for the event. */
  readonly eventSpeakerRegister?: Maybe<EventSpeakerRegisterPayload>;
  /** Updates the event speaker. */
  readonly eventSpeakerUpdate?: Maybe<EventSpeakerUpdatePayload>;
  /** Creates a new organization. */
  readonly organizationCreate?: Maybe<OrganizationCreatePayload>;
  /** Updates the event access type of all organization members in bulk. */
  readonly organizationMemberEventAccessBulkUpdateAll?: Maybe<OrganizationMemberEventAccessBulkUpdateAllPayload>;
  /** Updates the event access type of an an organization member. */
  readonly organizationMemberEventAccessUpdate?: Maybe<OrganizationMemberEventAccessUpdatePayload>;
  /** Accepts an invitation to join an organization. */
  readonly organizationMemberInvitationAccept?: Maybe<OrganizationInvitationAcceptPayload>;
  /** Cancels the invitation to join the organization. */
  readonly organizationMemberInvitationCancel?: Maybe<OrganizationMemberInvitationCancelPayload>;
  /** Rejects an invitation to join an organization. */
  readonly organizationMemberInvitationReject?: Maybe<OrganizationInvitationRejectPayload>;
  /** Invites a team member to join the organization. */
  readonly organizationMemberInvitationSend?: Maybe<OrganizationMemberInvitationSendPayload>;
  /** Removes the team member from the organization. */
  readonly organizationMemberRemove?: Maybe<OrganizationMemberRemovePayload>;
  /** Updates the organization role of an organization member. */
  readonly organizationMemberRoleUpdate?: Maybe<OrganizationMemberRoleUpdatePayload>;
  /** Updates an organization member's assigned spaces. */
  readonly organizationMemberSpacesUpdate?: Maybe<OrganizationMemberSpacesUpdatePayload>;
  /** Creates a new organization space. */
  readonly organizationSpaceCreate?: Maybe<OrganizationSpaceCreatePayload>;
  /** Updates an organization space. */
  readonly organizationSpaceUpdate?: Maybe<OrganizationSpaceUpdatePayload>;
  /** Updates the organization. */
  readonly organizationUpdate?: Maybe<OrganizationUpdatePayload>;
  /** Removes team seats. */
  readonly paymentPlanSeatRemove?: Maybe<PaymentPlanSeatRemovePayload>;
  /** Adds an event to the list of user saved events. */
  readonly savedEventAdd?: Maybe<SavedEventAddPayload>;
  /** Removes an event from the list of user saved events. */
  readonly savedEventRemove?: Maybe<SavedEventRemovePayload>;
  /** Setup RTMP for the given stage. This creates new RTMP video channels or returns the existing ones. */
  readonly stageSetupRtmp?: Maybe<StageSetupRtmpPayload>;
  /** Unlinks a Stripe account. */
  readonly stripeUnlinkAccount?: Maybe<StripeUnlinkAccountPayload>;
  readonly userAcceptTerms?: Maybe<AcceptTermsPayload>;
  /** Changes the email of the authenticated user. */
  readonly userChangeEmail?: Maybe<UserChangeEmailPayload>;
  /** Changes the password of the authenticated user. */
  readonly userChangePassword?: Maybe<UserChangePasswordPayload>;
  /** Removes a registrant from the list of user connections. */
  readonly userConnectionDelete?: Maybe<UserConnectionDeletePayload>;
  /** Deletes the authenticated user. The mutation will only succeed if the correct confirmation phrase is provided. */
  readonly userDelete?: Maybe<UserDeletePayload>;
  /** Updates the currently authenticated user. */
  readonly userUpdate?: Maybe<UserUpdatePayload>;
};

/** The root query for all mutation operations. */
export type MutationEventDeleteArgs = {
  input: EventDeleteInput;
};

/** The root query for all mutation operations. */
export type MutationEventDuplicateArgs = {
  input: EventDuplicateInput;
};

/** The root query for all mutation operations. */
export type MutationEventRegistrantUpdateTicketArgs = {
  input: EventRegistrantUpdateTicketInput;
};

/** The root query for all mutation operations. */
export type MutationEventSeriesAddEventArgs = {
  input: EventSeriesAddEventInput;
};

/** The root query for all mutation operations. */
export type MutationEventSeriesCreateArgs = {
  input: EventSeriesCreateInput;
};

/** The root query for all mutation operations. */
export type MutationEventSeriesDeleteArgs = {
  input: EventSeriesDeleteInput;
};

/** The root query for all mutation operations. */
export type MutationEventSeriesRemoveEventArgs = {
  input: EventSeriesRemoveEventInput;
};

/** The root query for all mutation operations. */
export type MutationEventSeriesRemoveEventFromAllSeriesArgs = {
  input: EventSeriesRemoveEventFromAllSeriesInput;
};

/** The root query for all mutation operations. */
export type MutationEventSeriesUpdateArgs = {
  input: EventSeriesUpdateInput;
};

/** The root query for all mutation operations. */
export type MutationEventSeriesUpdateEventFromAllSeriesArgs = {
  input: EventSeriesUpdateEventFromAllSeriesInput;
};

/** The root query for all mutation operations. */
export type MutationEventSpeakerCreateArgs = {
  input: EventSpeakerCreateInput;
};

/** The root query for all mutation operations. */
export type MutationEventSpeakerCreateFromRegistrantArgs = {
  input: EventSpeakerCreateFromRegistrantInput;
};

/** The root query for all mutation operations. */
export type MutationEventSpeakerDeleteArgs = {
  input: EventSpeakerDeleteInput;
};

/** The root query for all mutation operations. */
export type MutationEventSpeakerRegisterArgs = {
  input: EventSpeakerRegisterInput;
};

/** The root query for all mutation operations. */
export type MutationEventSpeakerUpdateArgs = {
  input: EventSpeakerUpdateInput;
};

/** The root query for all mutation operations. */
export type MutationOrganizationCreateArgs = {
  input: OrganizationCreateInput;
};

/** The root query for all mutation operations. */
export type MutationOrganizationMemberEventAccessBulkUpdateAllArgs = {
  input: OrganizationMemberEventAccessBulkUpdateAllInput;
};

/** The root query for all mutation operations. */
export type MutationOrganizationMemberEventAccessUpdateArgs = {
  input: OrganizationMemberEventAccessUpdateInput;
};

/** The root query for all mutation operations. */
export type MutationOrganizationMemberInvitationAcceptArgs = {
  input: OrganizationInvitationAcceptInput;
};

/** The root query for all mutation operations. */
export type MutationOrganizationMemberInvitationCancelArgs = {
  input: OrganizationMemberInvitationCancelInput;
};

/** The root query for all mutation operations. */
export type MutationOrganizationMemberInvitationRejectArgs = {
  input: OrganizationInvitationRejectInput;
};

/** The root query for all mutation operations. */
export type MutationOrganizationMemberInvitationSendArgs = {
  input: OrganizationMemberInvitationSendInput;
};

/** The root query for all mutation operations. */
export type MutationOrganizationMemberRemoveArgs = {
  input: OrganizationMemberRemoveInput;
};

/** The root query for all mutation operations. */
export type MutationOrganizationMemberRoleUpdateArgs = {
  input: OrganizationMemberRoleUpdateInput;
};

/** The root query for all mutation operations. */
export type MutationOrganizationMemberSpacesUpdateArgs = {
  input: OrganizationMemberSpacesUpdateInput;
};

/** The root query for all mutation operations. */
export type MutationOrganizationSpaceCreateArgs = {
  input: OrganizationSpaceCreateInput;
};

/** The root query for all mutation operations. */
export type MutationOrganizationSpaceUpdateArgs = {
  input: OrganizationSpaceUpdateInput;
};

/** The root query for all mutation operations. */
export type MutationOrganizationUpdateArgs = {
  input: OrganizationUpdateInput;
};

/** The root query for all mutation operations. */
export type MutationPaymentPlanSeatRemoveArgs = {
  input: PaymentPlanSeatRemoveInput;
};

/** The root query for all mutation operations. */
export type MutationSavedEventAddArgs = {
  input: SavedEventAddInput;
};

/** The root query for all mutation operations. */
export type MutationSavedEventRemoveArgs = {
  input: SavedEventRemoveInput;
};

/** The root query for all mutation operations. */
export type MutationStageSetupRtmpArgs = {
  input: StageSetupRtmpInput;
};

/** The root query for all mutation operations. */
export type MutationStripeUnlinkAccountArgs = {
  input: StripeUnlinkAccountInput;
};

/** The root query for all mutation operations. */
export type MutationUserAcceptTermsArgs = {
  input: AcceptTermsInput;
};

/** The root query for all mutation operations. */
export type MutationUserChangeEmailArgs = {
  input: UserChangeEmailInput;
};

/** The root query for all mutation operations. */
export type MutationUserChangePasswordArgs = {
  input: UserChangePasswordInput;
};

/** The root query for all mutation operations. */
export type MutationUserConnectionDeleteArgs = {
  input: UserConnectionDeleteInput;
};

/** The root query for all mutation operations. */
export type MutationUserDeleteArgs = {
  input: UserDeleteInput;
};

/** The root query for all mutation operations. */
export type MutationUserUpdateArgs = {
  input: UserUpdateInput;
};

/** An Organization resource. */
export type Organization = {
  readonly __typename?: 'Organization';
  /** The organization about. */
  readonly about?: Maybe<Scalars['String']['output']>;
  /** The cover image of the organization. */
  readonly coverImage: Image;
  /** The date and time (ISO 8601 format) when the organization was created. */
  readonly createdAt: Scalars['DateTime']['output'];
  /** The email of the organization. */
  readonly email: Scalars['EmailAddress']['output'];
  /** The organization's event series. */
  readonly eventSeries: EventSeriesConnection;
  /** The organization's events. */
  readonly events: EventConnection;
  /** The organization's Facebook URL. */
  readonly facebookUrl?: Maybe<Scalars['Url']['output']>;
  /** The set of features enabled for the organization. */
  readonly features: OrganizationFeatures;
  /** Whether the organization has reached the maximum number of members */
  readonly hasReachedOrganiserLimit?: Maybe<Scalars['Boolean']['output']>;
  /** A global unique identifier of the organization. */
  readonly id: Scalars['ID']['output'];
  /** The image for the organization. */
  readonly image: Image;
  /** The organization's LinkedIn URL. */
  readonly linkedinUrl?: Maybe<Scalars['Url']['output']>;
  /**
   * The spaces visible to the current user in organization management contexts.
   * Organization admins can see all organization spaces even when they are not space members.
   */
  readonly manageableSpaces: OrganizationSpaceConnection;
  /** The organization's member invitations. */
  readonly memberInvitations?: Maybe<OrganizationInvitationConnection>;
  /** The organization's members. */
  readonly members?: Maybe<OrganizationMemberConnection>;
  /** The organization name. */
  readonly name: Scalars['String']['output'];
  /** The global unique identifier of the organization's owner. */
  readonly ownerId: Scalars['String']['output'];
  /** The organization payment plan. */
  readonly paymentPlan?: Maybe<PaymentPlan>;
  /** The total number of pending member invitations for the organization. */
  readonly pendingMemberInvitationsCount?: Maybe<Scalars['Int']['output']>;
  /** The settings available for the organization. */
  readonly settings?: Maybe<OrganizationSetting>;
  /** The spaces in this organization where the current user is a member. */
  readonly spaces: OrganizationSpaceConnection;
  /** The standalone studios available to the organization. */
  readonly standaloneStudios: ReadonlyArray<StandaloneStudio>;
  /** The organization's Twitter URL. */
  readonly twitterUrl?: Maybe<Scalars['Url']['output']>;
  /** The date and time (ISO 8601 format) when the organization was last modified. */
  readonly updatedAt: Scalars['DateTime']['output'];
  /** The organization's Website URL. */
  readonly websiteUrl?: Maybe<Scalars['Url']['output']>;
};

/** An Organization resource. */
export type OrganizationEventSeriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pinEvent?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSeriesSortKeys>;
  spaceExternalId?: InputMaybe<Scalars['ID']['input']>;
};

/** An Organization resource. */
export type OrganizationEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pinEventSeries?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
  spaceExternalId?: InputMaybe<Scalars['ID']['input']>;
};

/** An Organization resource. */
export type OrganizationManageableSpacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<OrganizationSpaceSortKeys>;
  spaceExternalIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

/** An Organization resource. */
export type OrganizationMemberInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<OrganizationInvitationSortKeys>;
};

/** An Organization resource. */
export type OrganizationMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<OrganizationMemberSortKeys>;
};

/** An Organization resource. */
export type OrganizationSpacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<OrganizationSpaceSortKeys>;
  spaceExternalIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

/** A connection of organizations. */
export type OrganizationConnection = {
  readonly __typename?: 'OrganizationConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<UserOrganizationEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An error that occurs during the execution of OrganizationCreate. */
export type OrganizationCreateError = DisplayableError & {
  readonly __typename?: 'OrganizationCreateError';
  /** The error code. */
  readonly code: OrganizationCreateErrorCode;
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Error codes that can be returned by `OrganizationCreateError`. */
export enum OrganizationCreateErrorCode {
  /** The input is blank. */
  Blank = 'BLANK',
  /** The email is invalid. */
  InvalidEmail = 'INVALID_EMAIL',
  /** Something went wrong when attempting to validate the record. */
  InvalidRecord = 'INVALID_RECORD',
  /** The input is too long. */
  TooLong = 'TOO_LONG',
}

/** Autogenerated input type of OrganizationCreate */
export type OrganizationCreateInput = {
  /** The about for the organization. */
  readonly about?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The email for the organization. */
  readonly email?: InputMaybe<Scalars['EmailAddress']['input']>;
  /** Whether or not a user gave consent for a marketing communication. */
  readonly marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name for the organization. */
  readonly name: Scalars['String']['input'];
};

/** Autogenerated return type of OrganizationCreate */
export type OrganizationCreatePayload = {
  readonly __typename?: 'OrganizationCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The organization that was created. */
  readonly organization?: Maybe<Organization>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OrganizationCreateError>;
};

/** Represents the feature set available to the organization. */
export type OrganizationFeatures = {
  readonly __typename?: 'OrganizationFeatures';
  /** Whether an organization can access to the apps section. */
  readonly appStore: Scalars['Boolean']['output'];
  /** Whether an organization can access the event dashboard people menu. */
  readonly eventDashboardPeopleMenu: Scalars['Boolean']['output'];
  /** Whether an organization can create lite events. */
  readonly eventsLite: Scalars['Boolean']['output'];
  /** Whether an organization can create regular (full-featured) events. */
  readonly eventsPro: Scalars['Boolean']['output'];
  /** Maximum number of hours for virtual/onsite/hybrid events */
  readonly maxEventLengthHours: Scalars['Int']['output'];
  /** Whether an organization can create onsite and hybrid events. */
  readonly onsiteHybridEvents: Scalars['Boolean']['output'];
  /** Whether an organization can publish an event. */
  readonly publishEvent: Scalars['Boolean']['output'];
  /** Whether an organization can have roles and permissions assigned to organization members. */
  readonly rolesAndPermissions: Scalars['Boolean']['output'];
};

/** An invitation sent to a user to join an organization. */
export type OrganizationInvitation = {
  readonly __typename?: 'OrganizationInvitation';
  /** The email the invitation was sent to. */
  readonly email: Scalars['EmailAddress']['output'];
  /** The unique id of the invitation. */
  readonly id: Scalars['ID']['output'];
  /** The organization the user was invited to. */
  readonly organization: Organization;
  /** The role the user is invited to. */
  readonly role: OrganizationMemberRoles;
  /** The spaces the user is invited to join. */
  readonly spaces?: Maybe<ReadonlyArray<Space>>;
  /** The status of the invite. */
  readonly status: OrganizationInvitationStatus;
};

/** Autogenerated input type of OrganizationInvitationAccept */
export type OrganizationInvitationAcceptInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the organization invitation to be accepted. */
  readonly invitationId: Scalars['ID']['input'];
};

/** Autogenerated return type of OrganizationInvitationAccept */
export type OrganizationInvitationAcceptPayload = {
  readonly __typename?: 'OrganizationInvitationAcceptPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The organization invitation that was accepted. */
  readonly invitation?: Maybe<OrganizationInvitation>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OrganizationMemberInvitationAcceptError>;
};

/** The connection type for OrganizationInvitation. */
export type OrganizationInvitationConnection = {
  readonly __typename?: 'OrganizationInvitationConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<OrganizationInvitationEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OrganizationInvitationEdge = {
  readonly __typename?: 'OrganizationInvitationEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<OrganizationInvitation>;
};

/** Autogenerated input type of OrganizationInvitationReject */
export type OrganizationInvitationRejectInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the organization invitation to be rejected. */
  readonly invitationId: Scalars['ID']['input'];
};

/** Autogenerated return type of OrganizationInvitationReject */
export type OrganizationInvitationRejectPayload = {
  readonly __typename?: 'OrganizationInvitationRejectPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The organization invitation that was rejected. */
  readonly invitation?: Maybe<OrganizationInvitation>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OrganizationMemberInvitationRejectError>;
};

/** The set of valid sort keys for the organization invitation query. */
export enum OrganizationInvitationSortKeys {
  /** Sort by the _id_ value */
  Id = 'ID',
}

/** The status of an user invitation to an organization. */
export enum OrganizationInvitationStatus {
  /** The invitation has been accepted. */
  Accepted = 'ACCEPTED',
  /** The invitation was cancelled by the sender. */
  Cancelled = 'CANCELLED',
  /** The invitation is pending. */
  Pending = 'PENDING',
  /** The invitation has been rejected. */
  Rejected = 'REJECTED',
}

/** An organization member. */
export type OrganizationMember = {
  readonly __typename?: 'OrganizationMember';
  /** The organization member bio. */
  readonly bio?: Maybe<Scalars['String']['output']>;
  /** The unique email of the organization member. */
  readonly email: Scalars['EmailAddress']['output'];
  /** The first name of the organization member. */
  readonly firstName: Scalars['String']['output'];
  /** The unique id of the organization member. */
  readonly id: Scalars['ID']['output'];
  /** The image for the organization member. */
  readonly image: Image;
  /** The last name of the organization member. */
  readonly lastName: Scalars['String']['output'];
};

/** A connection of organization members. */
export type OrganizationMemberConnection = {
  readonly __typename?: 'OrganizationMemberConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<OrganizationMemberEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection to an Organization which holds one organization member. */
export type OrganizationMemberEdge = {
  readonly __typename?: 'OrganizationMemberEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The date when the user joined the organization. */
  readonly joinedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The item at the end of the edge. */
  readonly node?: Maybe<OrganizationMember>;
  /** The role of the user in the organization. */
  readonly role?: Maybe<OrganizationMemberRoles>;
  /** The spaces assigned to the organization member. */
  readonly spaces: ReadonlyArray<OrganizationSpace>;
};

/** Autogenerated input type of OrganizationMemberEventAccessBulkUpdateAll */
export type OrganizationMemberEventAccessBulkUpdateAllInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the event in relation to which the access type is being updated for all organization members. */
  readonly eventId: Scalars['ID']['input'];
  /** The new event access type for all the organization members. */
  readonly newEventAccess: OrganizationMemberEventAccessTypes;
};

/** Autogenerated return type of OrganizationMemberEventAccessBulkUpdateAll */
export type OrganizationMemberEventAccessBulkUpdateAllPayload = {
  readonly __typename?: 'OrganizationMemberEventAccessBulkUpdateAllPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated event access type that was assigned to all organization members. */
  readonly eventAccess?: Maybe<OrganizationMemberEventAccessTypes>;
};

/** The type of event access of the organization member. */
export enum OrganizationMemberEventAccessTypes {
  /** Can manage all aspects of the event. */
  FullAccess = 'FULL_ACCESS',
  /** Cannot manage any aspects of the event. */
  NoAccess = 'NO_ACCESS',
}

/** An error that occurs during the execution of OrganizationMemberEventAccessUpdate. */
export type OrganizationMemberEventAccessUpdateError = DisplayableError & {
  readonly __typename?: 'OrganizationMemberEventAccessUpdateError';
  /** The error code. */
  readonly code: OrganizationMemberEventAccessUpdateErrorCode;
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Error codes that can be returned by `OrganizationMemberEventAccessUpdateError`. */
export enum OrganizationMemberEventAccessUpdateErrorCode {
  /** Users that do not belong to the event's organization cannot be given access to the organization's events. */
  OrganizationMembership = 'ORGANIZATION_MEMBERSHIP',
}

/** Autogenerated input type of OrganizationMemberEventAccessUpdate */
export type OrganizationMemberEventAccessUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the event in relation to which the organization member's access type is being updated. */
  readonly eventId: Scalars['ID']['input'];
  /** The new event access type for the organization member. */
  readonly newEventAccess: OrganizationMemberEventAccessTypes;
  /** The ID of the organization member whose event access type is being updated. */
  readonly organizationMemberId: Scalars['ID']['input'];
};

/** Autogenerated return type of OrganizationMemberEventAccessUpdate */
export type OrganizationMemberEventAccessUpdatePayload = {
  readonly __typename?: 'OrganizationMemberEventAccessUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated event access type of the organization member. */
  readonly eventAccess?: Maybe<OrganizationMemberEventAccessTypes>;
  /** The organization member whose event access type was updated. */
  readonly organizationMember?: Maybe<OrganizationInvitation>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OrganizationMemberEventAccessUpdateError>;
};

/** An error that occurs during the execution of OrganizationMemberInvitationAccept. */
export type OrganizationMemberInvitationAcceptError = DisplayableError & {
  readonly __typename?: 'OrganizationMemberInvitationAcceptError';
  /** The error code. */
  readonly code: OrganizationMemberInvitationAcceptErrorCode;
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Error codes that can be returned by `OrganizationMemberInvitationAcceptError`. */
export enum OrganizationMemberInvitationAcceptErrorCode {
  /** Something went wrong when attempting to validate the record. */
  InvalidRecord = 'INVALID_RECORD',
  /** The invitation has a status that doesn't allow it to be accepted. */
  InvalidStatus = 'INVALID_STATUS',
}

/** An error that occurs during the execution of OrganizationMemberInvitationCancel. */
export type OrganizationMemberInvitationCancelError = DisplayableError & {
  readonly __typename?: 'OrganizationMemberInvitationCancelError';
  /** The error code. */
  readonly code: OrganizationMemberInvitationCancelErrorCode;
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Error codes that can be returned by `OrganizationMemberInvitationCancelError`. */
export enum OrganizationMemberInvitationCancelErrorCode {
  /** The invitation has a status that doesn't allow it to be canceled. */
  InvalidStatus = 'INVALID_STATUS',
}

/** Autogenerated input type of OrganizationMemberInvitationCancel */
export type OrganizationMemberInvitationCancelInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the invitation to cancel. */
  readonly invitationId: Scalars['ID']['input'];
};

/** Autogenerated return type of OrganizationMemberInvitationCancel */
export type OrganizationMemberInvitationCancelPayload = {
  readonly __typename?: 'OrganizationMemberInvitationCancelPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The invitation that was canceled. */
  readonly invitation?: Maybe<OrganizationInvitation>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OrganizationMemberInvitationCancelError>;
};

/** An error that occurs during the execution of OrganizationMemberInvitationReject. */
export type OrganizationMemberInvitationRejectError = DisplayableError & {
  readonly __typename?: 'OrganizationMemberInvitationRejectError';
  /** The error code. */
  readonly code: OrganizationMemberInvitationRejectErrorCode;
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Error codes that can be returned by `OrganizationMemberInvitationRejectError`. */
export enum OrganizationMemberInvitationRejectErrorCode {
  /** Something went wrong when attempting to validate the record. */
  InvalidRecord = 'INVALID_RECORD',
  /** The invitation has a status that doesn't allow it to be rejected. */
  InvalidStatus = 'INVALID_STATUS',
}

/** An error that occurs during the execution of OrganizationMemberInvitationSend. */
export type OrganizationMemberInvitationSendError = DisplayableError & {
  readonly __typename?: 'OrganizationMemberInvitationSendError';
  /** The error code. */
  readonly code: OrganizationMemberInvitationSendErrorCode;
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Error codes that can be returned by `OrganizationMemberInvitationSendError`. */
export enum OrganizationMemberInvitationSendErrorCode {
  /** The e-mail belongs to an existing team member. */
  AlreadyExists = 'ALREADY_EXISTS',
  /** The selected space IDs contain duplicates. */
  DuplicateSpaceExternalIds = 'DUPLICATE_SPACE_EXTERNAL_IDS',
  /** The email is invalid. */
  InvalidEmail = 'INVALID_EMAIL',
  /** Something went wrong when attempting to validate the record. */
  InvalidRecord = 'INVALID_RECORD',
  /** The maximum limit of team members has already been reached. */
  LimitReached = 'LIMIT_REACHED',
  /** One or more selected spaces were not found. */
  SpaceNotFound = 'SPACE_NOT_FOUND',
  /** A space selection is required. */
  SpaceRequired = 'SPACE_REQUIRED',
  /** The organization has no spaces available for invitation assignment. */
  SpaceUnavailable = 'SPACE_UNAVAILABLE',
  /** Your account has been suspended. */
  UserBanned = 'USER_BANNED',
}

/** Autogenerated input type of OrganizationMemberInvitationSend */
export type OrganizationMemberInvitationSendInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The e-mail address of the user who is being invited to join the organization. */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the organization for which a user is being invited to join. */
  readonly organizationId: Scalars['ID']['input'];
  /** The organization role for the user being invited to join the organization. */
  readonly role?: InputMaybe<OrganizationMemberRoles>;
  /** The external IDs of the spaces the invited user should join. */
  readonly spaceExternalIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

/** Autogenerated return type of OrganizationMemberInvitationSend */
export type OrganizationMemberInvitationSendPayload = {
  readonly __typename?: 'OrganizationMemberInvitationSendPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The invitation that was sent. */
  readonly invitation?: Maybe<OrganizationInvitation>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OrganizationMemberInvitationSendError>;
};

/** An error that occurs during the execution of OrganizationMemberRemove. */
export type OrganizationMemberRemoveError = DisplayableError & {
  readonly __typename?: 'OrganizationMemberRemoveError';
  /** The error code. */
  readonly code: OrganizationMemberRemoveErrorCode;
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Error codes that can be returned by `OrganizationMemberRemoveError`. */
export enum OrganizationMemberRemoveErrorCode {
  /** Cannot remove the last member. Team has an upcoming or ongoing event. */
  LastMember = 'LAST_MEMBER',
  /** Cannot remove the last admin. Organization needs at least one admin. */
  LastOrganizationAdmin = 'LAST_ORGANIZATION_ADMIN',
  /** Cannot remove the organization owner. */
  OrganizationOwner = 'ORGANIZATION_OWNER',
}

/** Autogenerated input type of OrganizationMemberRemove */
export type OrganizationMemberRemoveInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the member to remove. */
  readonly memberId: Scalars['ID']['input'];
  /** The ID of the organization from which the member will be removed. */
  readonly organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of OrganizationMemberRemove */
export type OrganizationMemberRemovePayload = {
  readonly __typename?: 'OrganizationMemberRemovePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the member that was removed. */
  readonly removedMemberId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OrganizationMemberRemoveError>;
};

/** An error that occurs during the execution of OrganizationMemberRoleUpdate. */
export type OrganizationMemberRoleUpdateError = DisplayableError & {
  readonly __typename?: 'OrganizationMemberRoleUpdateError';
  /** The error code. */
  readonly code: OrganizationMemberRoleUpdateErrorCode;
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Error codes that can be returned by `OrganizationMemberRoleUpdateError`. */
export enum OrganizationMemberRoleUpdateErrorCode {
  /** The role of the last remaining organization admin cannot be changed. */
  LastOrganizationAdmin = 'LAST_ORGANIZATION_ADMIN',
  /** The user is not an organization member of the organization. */
  OrganizationMembership = 'ORGANIZATION_MEMBERSHIP',
  /** Users cannot change their own roles. */
  OwnRole = 'OWN_ROLE',
}

/** Autogenerated input type of OrganizationMemberRoleUpdate */
export type OrganizationMemberRoleUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The new role for the organization member. */
  readonly newRole: OrganizationMemberRoles;
  /** The ID of the organization for which the organization member's role is being updated. */
  readonly organizationId: Scalars['ID']['input'];
  /** The ID of the organization member whose role is being updated. */
  readonly organizationMemberId: Scalars['ID']['input'];
};

/** Autogenerated return type of OrganizationMemberRoleUpdate */
export type OrganizationMemberRoleUpdatePayload = {
  readonly __typename?: 'OrganizationMemberRoleUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The organization member whose role was updated. */
  readonly organizationMember?: Maybe<OrganizationMember>;
  /** The updated role of the organization member */
  readonly role?: Maybe<OrganizationMemberRoles>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OrganizationMemberRoleUpdateError>;
};

/** The role of the organization member. */
export enum OrganizationMemberRoles {
  /** Can access all events and manage the organisation. */
  Admin = 'ADMIN',
  /** Can access applicable events. */
  Member = 'MEMBER',
}

/** The set of valid sort keys for the OrganizationMember query. */
export enum OrganizationMemberSortKeys {
  /** Sort by the _first_name_ value */
  FirstName = 'FIRST_NAME',
  /** Sort by the _id_ value */
  Id = 'ID',
  /** Sort by the _last_name_ value */
  LastName = 'LAST_NAME',
}

/** An error that occurs during the execution of OrganizationMemberSpacesUpdate. */
export type OrganizationMemberSpacesUpdateError = DisplayableError & {
  readonly __typename?: 'OrganizationMemberSpacesUpdateError';
  /** The error code. */
  readonly code: OrganizationMemberSpacesUpdateErrorCode;
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Error codes that can be returned by `OrganizationMemberSpacesUpdateError`. */
export enum OrganizationMemberSpacesUpdateErrorCode {
  /** The selected spaces contain duplicates. */
  DuplicateSpaceExternalIds = 'DUPLICATE_SPACE_EXTERNAL_IDS',
  /** At least one space must be selected. */
  EmptySelection = 'EMPTY_SELECTION',
  /** The selected spaces are invalid. */
  InvalidRecord = 'INVALID_RECORD',
  /** The user is not an organization member of the organization. */
  OrganizationMembership = 'ORGANIZATION_MEMBERSHIP',
  /** One or more selected spaces were not found in the organization. */
  SpaceNotFound = 'SPACE_NOT_FOUND',
}

/** Autogenerated input type of OrganizationMemberSpacesUpdate */
export type OrganizationMemberSpacesUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the organization for which the member's spaces are being updated. */
  readonly organizationId: Scalars['ID']['input'];
  /** The ID of the organization member whose spaces are being updated. */
  readonly organizationMemberId: Scalars['ID']['input'];
  /** The external IDs of the spaces assigned to the organization member. */
  readonly spaceExternalIds: ReadonlyArray<Scalars['ID']['input']>;
};

/** Autogenerated return type of OrganizationMemberSpacesUpdate */
export type OrganizationMemberSpacesUpdatePayload = {
  readonly __typename?: 'OrganizationMemberSpacesUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The organization member whose spaces were updated. */
  readonly organizationMember?: Maybe<OrganizationMember>;
  /** The updated spaces assigned to the organization member. */
  readonly spaces: ReadonlyArray<OrganizationSpace>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OrganizationMemberSpacesUpdateError>;
};

/** Represents the settings available for the organization. */
export type OrganizationSetting = {
  readonly __typename?: 'OrganizationSetting';
  /** Whether the organization has disabled AI features. */
  readonly disableAiFeatures: Scalars['Boolean']['output'];
};

/** The set of valid sort keys for the Organization query. */
export enum OrganizationSortKeys {
  /** Sort by the _created_at_ value */
  CreatedAt = 'CREATED_AT',
  /** Sort by the _id_ value */
  Id = 'ID',
}

/** An Organization Space resource. */
export type OrganizationSpace = {
  readonly __typename?: 'OrganizationSpace';
  /** The organization space description. */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** The number of event series assigned to the organization space. */
  readonly eventSeriesCount: Scalars['Int']['output'];
  /** The number of events assigned to the organization space. */
  readonly eventsCount: Scalars['Int']['output'];
  /** The external identifier of the organization space. */
  readonly externalId: Scalars['ID']['output'];
  /** A global unique identifier of the organization space. */
  readonly id: Scalars['ID']['output'];
  /** The number of members assigned to the organization space. */
  readonly membersCount: Scalars['Int']['output'];
  /** The organization space name. */
  readonly name: Scalars['String']['output'];
};

/** The connection type for OrganizationSpace. */
export type OrganizationSpaceConnection = {
  readonly __typename?: 'OrganizationSpaceConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<OrganizationSpaceEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An error that occurs during the execution of OrganizationSpaceCreate. */
export type OrganizationSpaceCreateError = DisplayableError & {
  readonly __typename?: 'OrganizationSpaceCreateError';
  /** The error code. */
  readonly code: OrganizationSpaceCreateErrorCode;
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Error codes that can be returned by `OrganizationSpaceCreateError`. */
export enum OrganizationSpaceCreateErrorCode {
  /** The input is blank. */
  Blank = 'BLANK',
  /** Something went wrong when attempting to validate the record. */
  InvalidRecord = 'INVALID_RECORD',
  /** The space name is already used by another space in the organization. */
  Taken = 'TAKEN',
  /** The input is too long. */
  TooLong = 'TOO_LONG',
}

/** Autogenerated input type of OrganizationSpaceCreate */
export type OrganizationSpaceCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the organization space. */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the organization space. */
  readonly name: Scalars['String']['input'];
  /** The ID of the organization for which the space is created. */
  readonly organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of OrganizationSpaceCreate */
export type OrganizationSpaceCreatePayload = {
  readonly __typename?: 'OrganizationSpaceCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The organization space that was created. */
  readonly organizationSpace?: Maybe<OrganizationSpace>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OrganizationSpaceCreateError>;
};

/** An edge in a connection. */
export type OrganizationSpaceEdge = {
  readonly __typename?: 'OrganizationSpaceEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<OrganizationSpace>;
};

/** The set of valid sort keys for the OrganizationSpace query. */
export enum OrganizationSpaceSortKeys {
  /** Sort by the _created_at_ value */
  CreatedAt = 'CREATED_AT',
  /** Sort by the _id_ value */
  Id = 'ID',
  /** Sort by the _name_ value */
  Name = 'NAME',
}

/** An error that occurs during the execution of OrganizationSpaceUpdate. */
export type OrganizationSpaceUpdateError = DisplayableError & {
  readonly __typename?: 'OrganizationSpaceUpdateError';
  /** The error code. */
  readonly code: OrganizationSpaceUpdateErrorCode;
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Error codes that can be returned by `OrganizationSpaceUpdateError`. */
export enum OrganizationSpaceUpdateErrorCode {
  /** The input is blank. */
  Blank = 'BLANK',
  /** Something went wrong when attempting to validate the record. */
  InvalidRecord = 'INVALID_RECORD',
  /** The space name is already used by another space in the organization. */
  Taken = 'TAKEN',
  /** The input is too long. */
  TooLong = 'TOO_LONG',
}

/** Autogenerated input type of OrganizationSpaceUpdate */
export type OrganizationSpaceUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The new description of the organization space. */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The new name of the organization space. */
  readonly name: Scalars['String']['input'];
  /** The ID of the organization space to update. */
  readonly spaceId: Scalars['ID']['input'];
};

/** Autogenerated return type of OrganizationSpaceUpdate */
export type OrganizationSpaceUpdatePayload = {
  readonly __typename?: 'OrganizationSpaceUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The organization space that was updated. */
  readonly organizationSpace?: Maybe<OrganizationSpace>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OrganizationSpaceUpdateError>;
};

/** An error that occurs during the execution of OrganizationUpdate. */
export type OrganizationUpdateError = DisplayableError & {
  readonly __typename?: 'OrganizationUpdateError';
  /** The error code. */
  readonly code: OrganizationUpdateErrorCode;
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Error codes that can be returned by `OrganizationUpdateError`. */
export enum OrganizationUpdateErrorCode {
  /** The input is blank. */
  Blank = 'BLANK',
  /** The domain in the URL is invalid. */
  InvalidDomain = 'INVALID_DOMAIN',
  /** The email is invalid. */
  InvalidEmail = 'INVALID_EMAIL',
  /** Something went wrong when attempting to validate the record. */
  InvalidRecord = 'INVALID_RECORD',
  /** The URL is invalid. */
  InvalidUrl = 'INVALID_URL',
  /** The input is too long. */
  TooLong = 'TOO_LONG',
}

/** Autogenerated input type of OrganizationUpdate */
export type OrganizationUpdateInput = {
  /** The new about for the organization. */
  readonly about?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** URL to temp S3 file that will replace organization's cover image. */
  readonly coverImageUrl?: InputMaybe<
    Scalars['UserFileUploadS3TempUrl']['input']
  >;
  /** The new email for the organization. */
  readonly email?: InputMaybe<Scalars['EmailAddress']['input']>;
  /** The organization's Facebook URL. */
  readonly facebookUrl?: InputMaybe<Scalars['String']['input']>;
  /** URL to temp S3 file that will replace organization's image. */
  readonly imageUrl?: InputMaybe<Scalars['UserFileUploadS3TempUrl']['input']>;
  /** The organization's LinkedIn URL. */
  readonly linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  /** The new name for the organization. */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the organization to be updated. */
  readonly organizationId: Scalars['ID']['input'];
  /** The organization's Twitter URL. */
  readonly twitterUrl?: InputMaybe<Scalars['String']['input']>;
  /** The organization's Website URL. */
  readonly websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of OrganizationUpdate */
export type OrganizationUpdatePayload = {
  readonly __typename?: 'OrganizationUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The organization that was updated. */
  readonly organization?: Maybe<Organization>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OrganizationUpdateError>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  readonly __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** A PaymentPlan of an organization. */
export type PaymentPlan = {
  readonly __typename?: 'PaymentPlan';
  /** Attendees stats for the organization events. */
  readonly attendeesStats?: Maybe<AttendeesStats>;
  /** Whether the current license was downgraded to free. */
  readonly downgradedToFree: Scalars['Boolean']['output'];
  /** The date when the license ends. */
  readonly endsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether or not there is an active self-serve subscription tied to the account. */
  readonly hasActiveSubscription: Scalars['Boolean']['output'];
  /** Whether or not the events lite feature is enabled. */
  readonly hasEventsLite?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not the events pro feature is enabled. */
  readonly hasEventsPro?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not the account has a payment provider customer associated. */
  readonly hasPaymentProviderCustomer: Scalars['Boolean']['output'];
  /**
   * The number of registrations included in the payment plan
   *                                                               per billing period.
   */
  readonly includedRegistrations: Scalars['Int']['output'];
  /**
   * The number of seats included in the payment plan. When the
   *                                                       value is `-1` it means that the seats are unlimited.
   * @deprecated Use `seats` instead.
   */
  readonly includedSeats: Scalars['Int']['output'];
  /**
   * Whether the payment plan is an advanced plan
   *                                                   (Unlimited, Pro, Business, Enterprise, Essentials, etc.).
   */
  readonly isAdvanced: Scalars['Boolean']['output'];
  /** Whether the payment plan is Appsumo. */
  readonly isAppsumo: Scalars['Boolean']['output'];
  /**
   * Whether the payment plan is a self-serve plan
   *                                                                  (Starter or Growth).
   */
  readonly isSelfserve: Scalars['Boolean']['output'];
  /**
   * Whether the payment plan is a special
   *                                                   plan (Appsumo, Unlimited, or Pro).
   */
  readonly isSpecial: Scalars['Boolean']['output'];
  /** Whether the stripe migration feature flag is turned on or off. */
  readonly isStripeMigrationEnabled: Scalars['Boolean']['output'];
  /** The payment plan name. */
  readonly name: PaymentPlanName;
  /** Whether the payment plan allows paid tickets. */
  readonly paidTicketsAllowed: Scalars['Boolean']['output'];
  /** Stripe Connected Account Client Id. */
  readonly paymentProviderConnectedAccountClientId: Scalars['String']['output'];
  /** The payment plan name as a string. */
  readonly planName: Scalars['String']['output'];
  /** The payment plan name locale. */
  readonly planNameLocale: Scalars['String']['output'];
  /** The price and billing interval of a payment plan. Available only for self serve plans. */
  readonly pricing?: Maybe<PaymentPlanPricing>;
  /** Registrations usage and availability for the organization. */
  readonly registrationsUsage?: Maybe<RegistrationsUsage>;
  /** Seats usage and availability for the organization */
  readonly seats: PaymentPlanSeats;
  /** The date when the license starts. */
  readonly startsAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The number of seats used in the payment plan.
   * @deprecated Use `seats` instead.
   */
  readonly usedSeats: Scalars['Int']['output'];
};

/** The name of the payment plan. */
export enum PaymentPlanName {
  Appsumo = 'APPSUMO',
  Appsumo1 = 'APPSUMO1',
  Appsumo2 = 'APPSUMO2',
  Appsumo3 = 'APPSUMO3',
  Appsumo4 = 'APPSUMO4',
  Appsumo5 = 'APPSUMO5',
  Appsumo6 = 'APPSUMO6',
  Appsumo7 = 'APPSUMO7',
  Appsumo8 = 'APPSUMO8',
  Appsumo9 = 'APPSUMO9',
  Appsumo10 = 'APPSUMO10',
  Business = 'BUSINESS',
  BusinessSixMonths = 'BUSINESS_SIX_MONTHS',
  BusinessThreeMonths = 'BUSINESS_THREE_MONTHS',
  BusinessTwelveMonths = 'BUSINESS_TWELVE_MONTHS',
  Enterprise = 'ENTERPRISE',
  Essentials_100 = 'ESSENTIALS_100',
  Essentials_500 = 'ESSENTIALS_500',
  Essentials_1000 = 'ESSENTIALS_1000',
  Essentials_2000 = 'ESSENTIALS_2000',
  Essentials_3000 = 'ESSENTIALS_3000',
  Essentials_5000 = 'ESSENTIALS_5000',
  Essentials_7500 = 'ESSENTIALS_7500',
  Essentials_10000 = 'ESSENTIALS_10000',
  Essentials_20000 = 'ESSENTIALS_20000',
  EventsEcommerce_100 = 'EVENTS_ECOMMERCE_100',
  EventsEcommerce_500 = 'EVENTS_ECOMMERCE_500',
  EventsEcommerce_1000 = 'EVENTS_ECOMMERCE_1000',
  Free = 'FREE',
  FreeTrial = 'FREE_TRIAL',
  GrowthAnnual = 'GROWTH_ANNUAL',
  GrowthMonthly = 'GROWTH_MONTHLY',
  HopinTrialAccessForAttendifyCustomers = 'HOPIN_TRIAL_ACCESS_FOR_ATTENDIFY_CUSTOMERS',
  Pro = 'PRO',
  SalesLedGrowth = 'SALES_LED_GROWTH',
  StarterAnnual = 'STARTER_ANNUAL',
  StarterMonthly = 'STARTER_MONTHLY',
  Unlimited = 'UNLIMITED',
}

/** The price and billing interval of a payment plan. */
export type PaymentPlanPricing = {
  readonly __typename?: 'PaymentPlanPricing';
  /** The pricing interval of the payment plan. */
  readonly interval?: Maybe<PaymentPlanPricingInterval>;
  /** The price of the payment plan. */
  readonly price?: Maybe<Money>;
};

/** The pricing interval of a payment plan. */
export enum PaymentPlanPricingInterval {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY',
}

/** An error that occurs during the execution of PaymentPlanSeatRemove. */
export type PaymentPlanSeatRemoveError = DisplayableError & {
  readonly __typename?: 'PaymentPlanSeatRemoveError';
  /** The error code. */
  readonly code: PaymentPlanSeatRemoveErrorCode;
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Error codes that can be returned by `PaymentPlanSeatRemoveErrorCodeEnum`. */
export enum PaymentPlanSeatRemoveErrorCode {
  /** The input is blank. */
  Blank = 'BLANK',
  /** Something went wrong. */
  Internal = 'INTERNAL',
  /** The organization is not on Self Serve Plan. */
  NotSelfServePlan = 'NOT_SELF_SERVE_PLAN',
  /** The resulting quantity is below zero. */
  QuantityLowerThanZero = 'QUANTITY_LOWER_THAN_ZERO',
}

/** Autogenerated input type of PaymentPlanSeatRemove */
export type PaymentPlanSeatRemoveInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Amount of team seats to remove. */
  readonly numberOfSeats: Scalars['Int']['input'];
  /** The organization ID of the organization from which the team seats will be removed. */
  readonly organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of PaymentPlanSeatRemove */
export type PaymentPlanSeatRemovePayload = {
  readonly __typename?: 'PaymentPlanSeatRemovePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The payment plan from which the seats were removed. */
  readonly paymentPlan: PaymentPlan;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PaymentPlanSeatRemoveError>;
};

/** Seats usage and availability of an organization's payment plan. */
export type PaymentPlanSeats = {
  readonly __typename?: 'PaymentPlanSeats';
  /** Additional seats - seats purchased on top of the included ones. */
  readonly additional: Scalars['Int']['output'];
  /** The price of an additional seat. */
  readonly additionalSeatPrice?: Maybe<Money>;
  /** Included seats. */
  readonly included: Scalars['Int']['output'];
  /**
   * The total number of seats the organization is allowed to have. When the
   *                             value is `-1` it means that the seats are unlimited.
   */
  readonly total: Scalars['Int']['output'];
  /** Used additional seats. */
  readonly usedAdditional: Scalars['Int']['output'];
  /** Used included seats. */
  readonly usedIncluded: Scalars['Int']['output'];
  /** Total included and additional seats used. */
  readonly usedTotal: Scalars['Int']['output'];
};

/** The query root of the GraphQL interface from which all queries must start. */
export type Query = {
  readonly __typename?: 'Query';
  /** Fetches event by ID. Returns null if the event doesn't exist. */
  readonly event?: Maybe<Event>;
  /** Fetches event by slug. Returns null if the event doesn't exist. */
  readonly eventBySlug?: Maybe<Event>;
  /** Fetches the event schedule by the event ID. Returns null if the event doesn't exist. */
  readonly eventSchedule?: Maybe<EventSchedule>;
  /** Fetches event series by ID. Returns null if the event doesn't exist. */
  readonly eventSeries?: Maybe<EventSeries>;
  /** The currently authenticated user. */
  readonly me?: Maybe<User>;
  /** Lookup an organization by ID. */
  readonly organization?: Maybe<Organization>;
  /** Lookup an organization space by ID or space external ID. */
  readonly organizationSpace?: Maybe<OrganizationSpace>;
  /** Returns whether a space exists for the organization and current user. */
  readonly spaceExists: Scalars['Boolean']['output'];
};

/** The query root of the GraphQL interface from which all queries must start. */
export type QueryEventArgs = {
  id: Scalars['ID']['input'];
};

/** The query root of the GraphQL interface from which all queries must start. */
export type QueryEventBySlugArgs = {
  slug: Scalars['String']['input'];
};

/** The query root of the GraphQL interface from which all queries must start. */
export type QueryEventScheduleArgs = {
  eventId: Scalars['ID']['input'];
};

/** The query root of the GraphQL interface from which all queries must start. */
export type QueryEventSeriesArgs = {
  id: Scalars['ID']['input'];
};

/** The query root of the GraphQL interface from which all queries must start. */
export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};

/** The query root of the GraphQL interface from which all queries must start. */
export type QueryOrganizationSpaceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  spaceExternalId?: InputMaybe<Scalars['ID']['input']>;
};

/** The query root of the GraphQL interface from which all queries must start. */
export type QuerySpaceExistsArgs = {
  organizationExternalId: Scalars['ID']['input'];
  spaceExternalId: Scalars['ID']['input'];
};

/** PaymentPlan value objects containing registrations usage and availability. */
export type RegistrationsUsage =
  | AdvancedRegistrationsUsage
  | AppsumoRegistrationsUsage
  | BaseRegistrationsUsage
  | FreeRegistrationsUsage
  | SelfServeRegistrationsUsage;

/** Autogenerated input type of SavedEventAdd */
export type SavedEventAddInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the event to be added. */
  readonly eventId: Scalars['ID']['input'];
};

/** Autogenerated return type of SavedEventAdd */
export type SavedEventAddPayload = {
  readonly __typename?: 'SavedEventAddPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The event that was added. */
  readonly event?: Maybe<Event>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SavedEventAddUserError>;
};

/** An error that occurs during the execution of SavedEventAdd. */
export type SavedEventAddUserError = DisplayableError & {
  readonly __typename?: 'SavedEventAddUserError';
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Autogenerated input type of SavedEventRemove */
export type SavedEventRemoveInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the event to be removed. */
  readonly eventId: Scalars['ID']['input'];
};

/** Autogenerated return type of SavedEventRemove */
export type SavedEventRemovePayload = {
  readonly __typename?: 'SavedEventRemovePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The removed event. */
  readonly event?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SavedEventRemoveUserError>;
};

/** An error that occurs during the execution of SavedEventRemove. */
export type SavedEventRemoveUserError = DisplayableError & {
  readonly __typename?: 'SavedEventRemoveUserError';
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Registration balance and usage for Self Serve plans. */
export type SelfServeRegistrationsUsage = {
  readonly __typename?: 'SelfServeRegistrationsUsage';
  /**
   * The number of accrued registrations.
   *                                    Unused registrations at the end of a billing period are accrued.
   */
  readonly accrued: Scalars['Int']['output'];
  /** The number of registrations available this billing period. */
  readonly available: Scalars['Int']['output'];
  /** The number of included registrations per billing period. */
  readonly included: Scalars['Int']['output'];
  /** The number of used registrations this billing period. */
  readonly used: Scalars['Int']['output'];
};

/** A Space resource. */
export type Space = {
  readonly __typename?: 'Space';
  /** The description of the space. */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** The external id of the space. */
  readonly externalId: Scalars['ID']['output'];
  /** The name of the space. */
  readonly name: Scalars['String']['output'];
};

/** A SpeakerLink resource. */
export type SpeakerLink = {
  readonly __typename?: 'SpeakerLink';
  /** The link to join the session or stage. */
  readonly link: Scalars['String']['output'];
  /** The name of the schedule item. */
  readonly segmentName: Scalars['String']['output'];
  /** The name of the session attached to the schedule. It is not null only if the schedule has multiple sessions attached. */
  readonly sessionName?: Maybe<Scalars['String']['output']>;
};

export type Stage = {
  readonly __typename?: 'Stage';
  /** Chat id for the stage. */
  readonly chatId?: Maybe<Scalars['String']['output']>;
  /** The name of the stage. */
  readonly name: Scalars['String']['output'];
  /** A UUID (Universal Unique Identifier) for the stage. */
  readonly uuid: Scalars['String']['output'];
  /** The video channels that belong to the stage. */
  readonly videoChannels?: Maybe<VideoChannelConnection>;
};

export type StageVideoChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<StageVideoChannelSortKeys>;
};

/** The connection type for Stage. */
export type StageConnection = {
  readonly __typename?: 'StageConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<StageEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type StageEdge = {
  readonly __typename?: 'StageEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Stage>;
};

/** Autogenerated input type of StageSetupRTMP */
export type StageSetupRtmpInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The uuid of the stage for which to setup RTMP. */
  readonly stageUuid: Scalars['String']['input'];
};

/** Autogenerated return type of StageSetupRTMP */
export type StageSetupRtmpPayload = {
  readonly __typename?: 'StageSetupRTMPPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Stage for which the RTMP channel(s) were created. */
  readonly stage?: Maybe<Stage>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<EventStageSetupRtmpError>;
};

/** The set of valid sort keys for the VideoChannel query. */
export enum StageVideoChannelSortKeys {
  /** Sort by the _id_ value. */
  Id = 'ID',
}

/** Represents a standalone studio. */
export type StandaloneStudio = {
  readonly __typename?: 'StandaloneStudio';
  /** The event of the standalone studio. */
  readonly event: Event;
  /** The name of the standalone studio. */
  readonly name: Scalars['String']['output'];
  /** A UUID identifier of the standalone studio. */
  readonly uuid: Scalars['String']['output'];
};

/** An error that occurs during the execution of StripeUnlinkAccount. */
export type StripeUnlinkAccountError = DisplayableError & {
  readonly __typename?: 'StripeUnlinkAccountError';
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Autogenerated input type of StripeUnlinkAccount */
export type StripeUnlinkAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The organization ID of the organization from which the Stripe account will be unlinked */
  readonly organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of StripeUnlinkAccount */
export type StripeUnlinkAccountPayload = {
  readonly __typename?: 'StripeUnlinkAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the organization that was unlinked from Stripe. */
  readonly unlinkedOrganizationId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<StripeUnlinkAccountError>;
};

/** An event ticket. */
export type Ticket = {
  readonly __typename?: 'Ticket';
  /** The type of access awarded by the ticket type. */
  readonly accessType: TicketAccessType;
  /** The availability of the ticket. */
  readonly availability: TicketAvailability;
  /** The description of the ticket. */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** The unique id of the ticket. */
  readonly id: Scalars['ID']['output'];
  /** The name of the ticket. */
  readonly name: Scalars['String']['output'];
  /** The price for the ticket. */
  readonly price: Money;
  /** The pricing type of the ticket. */
  readonly pricingType: TicketPricingType;
  /** The number of tickets that are still available to be acquired for this ticket type. */
  readonly remainingCapacity: Scalars['Int']['output'];
};

/** The type of access awarded by an event ticket. */
export enum TicketAccessType {
  /** The ticket awards access to both the online component and the physical location of the event. */
  Hybrid = 'HYBRID',
  /** The ticket awards access to the physical location of the event. */
  Onsite = 'ONSITE',
  /** The ticket awards access to the online component of the event. */
  Virtual = 'VIRTUAL',
}

/** The availability of the ticket for sale. */
export enum TicketAvailability {
  /** The ticket sales are closed. */
  Closed = 'CLOSED',
  /** The ticket sales are open. */
  Open = 'OPEN',
}

/** The connection type for Ticket. */
export type TicketConnection = {
  readonly __typename?: 'TicketConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<TicketEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TicketEdge = {
  readonly __typename?: 'TicketEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Ticket>;
};

/** The type of ticket pricing. */
export enum TicketPricingType {
  /** The ticket price is equal to `0`. */
  Free = 'FREE',
  /** The ticket price is more than `0`. */
  Paid = 'PAID',
}

/** The set of valid sort keys for the Ticket query. */
export enum TicketSortKeys {
  /** Sort by the _id_ value. */
  Id = 'ID',
  /** Sort by the _price.amount_ value. */
  Price = 'PRICE',
}

/** A User resource. */
export type User = {
  readonly __typename?: 'User';
  /** The user's bio. */
  readonly bio?: Maybe<Scalars['String']['output']>;
  /** Returns all user connections across all events. */
  readonly connections: EventRegistrantProfileConnection;
  /** The date and time (ISO 8601 format) when the user was created. */
  readonly createdAt: Scalars['DateTime']['output'];
  /** The confirmation phrase that must be provided to delete the user's account. */
  readonly deleteConfirmationPhrase: Scalars['String']['output'];
  /** The unique email of the user. */
  readonly email: Scalars['EmailAddress']['output'];
  /** The date and time (ISO 8601 format) when the user confirmed the email. */
  readonly emailConfirmedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The first name of the user. */
  readonly firstName: Scalars['String']['output'];
  /** Whether the user has accepted the current Terms of Service. */
  readonly hasAcceptedTerms: Scalars['Boolean']['output'];
  /** The user's headline. */
  readonly headline?: Maybe<Scalars['String']['output']>;
  /** The unique id of the user. */
  readonly id: Scalars['ID']['output'];
  /** The image for the user. */
  readonly image: Image;
  /** The last name of the user. */
  readonly lastName: Scalars['String']['output'];
  /** The user's LinkedIn URL. */
  readonly linkedinUrl?: Maybe<Scalars['Url']['output']>;
  /** The pending invitations the user has received to become an organization member. */
  readonly organizationInvitations?: Maybe<OrganizationInvitationConnection>;
  /** The organizations the user belongs to. */
  readonly organizations: OrganizationConnection;
  /**
   * Returns a list of events recommended for the user.
   * @deprecated No longer supported, returns an empty list.
   */
  readonly recommendedEvents: UserEventConnection;
  /** Fetch an event the user has registered for by ID. */
  readonly registeredEvent?: Maybe<Event>;
  /** Returns a list of events that the user has registered for. */
  readonly registeredEvents: UserEventConnection;
  /** Returns a list of events that the user has saved. */
  readonly savedEvents: UserEventConnection;
  /** The user's Twitter URL. */
  readonly twitterUrl?: Maybe<Scalars['Url']['output']>;
  /** The user's unconfirmed email. After confirmation this value is copied to the email attribute and cleared. */
  readonly unconfirmedEmail?: Maybe<Scalars['String']['output']>;
  /** The date and time (ISO 8601 format) when the user was last modified. */
  readonly updatedAt: Scalars['DateTime']['output'];
  /** Whether the user logged in via enterprise SSO. */
  readonly userLoggedInViaSso: Scalars['Boolean']['output'];
  /** Returns a list of the vendor booths the user can manage. */
  readonly vendorBooths: VendorBoothConnection;
  /** The user's Website URL. */
  readonly websiteUrl?: Maybe<Scalars['Url']['output']>;
};

/** A User resource. */
export type UserConnectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventRegistrantSortKeys>;
};

/** A User resource. */
export type UserOrganizationInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<OrganizationInvitationSortKeys>;
};

/** A User resource. */
export type UserOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<OrganizationSortKeys>;
};

/** A User resource. */
export type UserRecommendedEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A User resource. */
export type UserRegisteredEventArgs = {
  eventId: Scalars['ID']['input'];
};

/** A User resource. */
export type UserRegisteredEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
};

/** A User resource. */
export type UserSavedEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
};

/** A User resource. */
export type UserVendorBoothsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<VendorBoothSortKeys>;
};

/** An error that occurs during the execution of UserChangeEmail. */
export type UserChangeEmailError = DisplayableError & {
  readonly __typename?: 'UserChangeEmailError';
  /** The error code. */
  readonly code: UserChangeEmailErrorCode;
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Error codes that can be returned by `UserChangeEmailError`. */
export enum UserChangeEmailErrorCode {
  /** The email is already taken. */
  EmailTaken = 'EMAIL_TAKEN',
  /** An unknown error occurred. */
  InternalError = 'INTERNAL_ERROR',
  /** The email is invalid. */
  InvalidEmail = 'INVALID_EMAIL',
}

/** Autogenerated input type of UserChangeEmail */
export type UserChangeEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The new email for the authenticated user. */
  readonly newEmail: Scalars['String']['input'];
};

/** Autogenerated return type of UserChangeEmail */
export type UserChangeEmailPayload = {
  readonly __typename?: 'UserChangeEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The currently authenticated user. */
  readonly me?: Maybe<User>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserChangeEmailError>;
};

/** An error that occurs during the execution of UserChangePassword. */
export type UserChangePasswordError = DisplayableError & {
  readonly __typename?: 'UserChangePasswordError';
  /** The error code. */
  readonly code: UserChangePasswordErrorCode;
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Error codes that can be returned by `UserChangePasswordErrorCodeEnum`. */
export enum UserChangePasswordErrorCode {
  /** The input is missing an alphabetic character. The password requires at least one alphabetic character. */
  AlphaCharacterMissing = 'ALPHA_CHARACTER_MISSING',
  /** The input is blank. */
  Blank = 'BLANK',
  /** The current password is invalid for the user. */
  InvalidPassword = 'INVALID_PASSWORD',
  /** The input is missing a number. The password requires at least one digit (`0-9`). */
  NumberMissing = 'NUMBER_MISSING',
  /** The input is missing a character. The password requires at least one special character. */
  SpecialCharacterMissing = 'SPECIAL_CHARACTER_MISSING',
  /** The input is too short. The password requires a minimum of `10` characters. */
  TooShort = 'TOO_SHORT',
}

/** Autogenerated input type of UserChangePassword */
export type UserChangePasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The current password of the authenticated user. */
  readonly currentPassword: Scalars['String']['input'];
  /** The new password of the authenticated user. */
  readonly newPassword: Scalars['String']['input'];
};

/** Autogenerated return type of UserChangePassword */
export type UserChangePasswordPayload = {
  readonly __typename?: 'UserChangePasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The currently authenticated user. */
  readonly me?: Maybe<User>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserChangePasswordError>;
};

/** Autogenerated input type of UserConnectionDelete */
export type UserConnectionDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the registrant to be removed as a connection. */
  readonly registrantId: Scalars['ID']['input'];
};

/** Autogenerated return type of UserConnectionDelete */
export type UserConnectionDeletePayload = {
  readonly __typename?: 'UserConnectionDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The registrant ID of the removed connection. */
  readonly deletedRegistrantId?: Maybe<Scalars['ID']['output']>;
};

/** An error that occurs during the execution of UserDelete. */
export type UserDeleteError = DisplayableError & {
  readonly __typename?: 'UserDeleteError';
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Autogenerated input type of UserDelete */
export type UserDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Must match: `confirm-delete-${me.firstName}-${me.lastName}`
   *
   * Names are [parameterized](https://api.rubyonrails.org/classes/ActiveSupport/Inflector.html#method-i-parameterize).
   *
   * Examples:
   * * If `me = { "firstName":"Amália", "lastName":"Rodrigues" }` then
   * `confirmationPhrase === "confirm-delete-amalia-rodrigues"`
   * * If `me = { "firstName":"Donald", "lastName":"E. Knuth" }` then `confirmationPhrase === "confirm-delete-donald-e-knuth"`
   */
  readonly confirmationPhrase: Scalars['String']['input'];
};

/** Autogenerated return type of UserDelete */
export type UserDeletePayload = {
  readonly __typename?: 'UserDeletePayload';
  /** Our goodbye message. */
  readonly bye?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The user ID of the deleted user. */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserDeleteError>;
};

/** A connection of events to a User. */
export type UserEventConnection = {
  readonly __typename?: 'UserEventConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<UserEventEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection to a User which holds one Event. */
export type UserEventEdge = {
  readonly __typename?: 'UserEventEdge';
  /** Returns a list of user connections for the event. */
  readonly connections: EventRegistrantProfileConnection;
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** Whether the user has added the event to the list of saved events. */
  readonly isSaved: Scalars['Boolean']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Event>;
};

/** An edge in a connection to a User which holds one Event. */
export type UserEventEdgeConnectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventRegistrantSortKeys>;
};

/** An edge in a connection to a User which holds one organization. */
export type UserOrganizationEdge = {
  readonly __typename?: 'UserOrganizationEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The date when the user joined the organization. */
  readonly joinedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The item at the end of the edge. */
  readonly node?: Maybe<Organization>;
  /** The role of the user in the organization. */
  readonly role?: Maybe<OrganizationMemberRoles>;
};

/** An error that occurs during the execution of UserUpdate. */
export type UserUpdateError = DisplayableError & {
  readonly __typename?: 'UserUpdateError';
  /** The error code. */
  readonly code: UserUpdateErrorCode;
  /** The error message. */
  readonly message: Scalars['String']['output'];
  /** The path to the input field that caused the error. */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Error codes that can be returned by `UserUpdateError`. */
export enum UserUpdateErrorCode {
  /** The input is blank. */
  Blank = 'BLANK',
  /** The input format is invalid. */
  Invalid = 'INVALID',
  /** The domain in the URL is invalid. */
  InvalidDomain = 'INVALID_DOMAIN',
  /** Something went wrong when attempting to validate the record. */
  InvalidRecord = 'INVALID_RECORD',
  /** The URL is invalid. */
  InvalidUrl = 'INVALID_URL',
  /** The URL is expected to contain a username. Eg.: http://example.com/username */
  InvalidUsername = 'INVALID_USERNAME',
  /** The input is too long. */
  TooLong = 'TOO_LONG',
}

/** Autogenerated input type of UserUpdate */
export type UserUpdateInput = {
  /** The new bio of the user. */
  readonly bio?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The new first name of the user. */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  /** The new headline of the user. */
  readonly headline?: InputMaybe<Scalars['String']['input']>;
  /** URL to temp S3 file that will replace user's image. */
  readonly imageUrl?: InputMaybe<Scalars['UserFileUploadS3TempUrl']['input']>;
  /** The new last name of the user. */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** The new LinkedIn profile URL of the user. */
  readonly linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  /** The new Twitter profile URL of the user. */
  readonly twitterUrl?: InputMaybe<Scalars['String']['input']>;
  /** The new website URL of the user. */
  readonly websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UserUpdate */
export type UserUpdatePayload = {
  readonly __typename?: 'UserUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The user that was updated. */
  readonly me?: Maybe<User>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserUpdateError>;
};

/** A Vendor booth. */
export type VendorBooth = {
  readonly __typename?: 'VendorBooth';
  /** The vendor booth about. */
  readonly about: Scalars['String']['output'];
  /** The cover image of the booth. */
  readonly coverImage: Image;
  /** The email of the vendor booth. */
  readonly email: Scalars['EmailAddress']['output'];
  /** The event to which the vendor booth belongs. */
  readonly event: Event;
  /** The vendor booth headline. */
  readonly headline: Scalars['String']['output'];
  /** A global unique identifier of the vendor booth. */
  readonly id: Scalars['ID']['output'];
  /** The image for the vendor booth. */
  readonly image: Image;
  /** The vendor booth name. */
  readonly name: Scalars['String']['output'];
};

/** The connection type for VendorBooth. */
export type VendorBoothConnection = {
  readonly __typename?: 'VendorBoothConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<VendorBoothEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type VendorBoothEdge = {
  readonly __typename?: 'VendorBoothEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<VendorBooth>;
};

/** The set of valid sort keys for the vendor booths query. */
export enum VendorBoothSortKeys {
  /** Sort by the _id_ value */
  Id = 'ID',
  /** Sort by the _name_ value */
  Name = 'NAME',
}

export type VideoChannel = {
  readonly __typename?: 'VideoChannel';
  /** The VideoChannel priority. */
  readonly priority: VideoChannelPriorities;
  /** The VideoChannel stream key. */
  readonly streamKey: Scalars['String']['output'];
  /** The VideoChannel stream url. */
  readonly streamUrl: Scalars['String']['output'];
};

/** The connection type for VideoChannel. */
export type VideoChannelConnection = {
  readonly __typename?: 'VideoChannelConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<VideoChannelEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type VideoChannelEdge = {
  readonly __typename?: 'VideoChannelEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<VideoChannel>;
};

/** The priority of the VideoChannel. */
export enum VideoChannelPriorities {
  /** The VideoChannel is a fallback one */
  Fallback = 'FALLBACK',
  /** The VideoChannel is a preferred one */
  Preferred = 'PREFERRED',
}

export type TeamAccessEventDetailsQueryVariables = Exact<{
  input: Scalars['ID']['input'];
}>;

export type TeamAccessEventDetailsQuery = {
  readonly __typename?: 'Query';
  readonly event?: {
    readonly __typename?: 'Event';
    readonly id: string;
    readonly name: string;
    readonly timeEnd: any;
    readonly timeStart: any;
  } | null;
};

export type MyProfileQueryVariables = Exact<{ [key: string]: never }>;

export type MyProfileQuery = {
  readonly __typename?: 'Query';
  readonly me?: {
    readonly __typename?: 'User';
    readonly id: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly email: any;
    readonly hasAcceptedTerms: boolean;
    readonly image: {
      readonly __typename?: 'Image';
      readonly small?: any | null;
      readonly large?: any | null;
    };
  } | null;
};

export type OrganizationsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type OrganizationsQuery = {
  readonly __typename?: 'Query';
  readonly me?: {
    readonly __typename?: 'User';
    readonly id: string;
    readonly organizations: {
      readonly __typename?: 'OrganizationConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'UserOrganizationEdge';
        readonly cursor: string;
        readonly node?: {
          readonly __typename?: 'Organization';
          readonly id: string;
          readonly name: string;
          readonly createdAt: any;
          readonly image: {
            readonly __typename?: 'Image';
            readonly small?: any | null;
            readonly medium?: any | null;
            readonly large?: any | null;
          };
          readonly paymentPlan?: {
            readonly __typename?: 'PaymentPlan';
            readonly planName: string;
            readonly planNameLocale: string;
          } | null;
          readonly features: {
            readonly __typename?: 'OrganizationFeatures';
            readonly appStore: boolean;
          };
        } | null;
      }>;
      readonly pageInfo: {
        readonly __typename?: 'PageInfo';
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
    };
  } | null;
};

export type VendorBoothsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type VendorBoothsQuery = {
  readonly __typename?: 'Query';
  readonly me?: {
    readonly __typename?: 'User';
    readonly id: string;
    readonly vendorBooths: {
      readonly __typename?: 'VendorBoothConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'VendorBoothEdge';
        readonly cursor: string;
        readonly node?: {
          readonly __typename?: 'VendorBooth';
          readonly id: string;
          readonly name: string;
          readonly image: {
            readonly __typename?: 'Image';
            readonly url?: any | null;
          };
          readonly event: {
            readonly __typename?: 'Event';
            readonly name: string;
          };
        } | null;
      }>;
      readonly pageInfo: {
        readonly __typename?: 'PageInfo';
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
    };
  } | null;
};

export type UserFirstOrganizationQueryVariables = Exact<{
  [key: string]: never;
}>;

export type UserFirstOrganizationQuery = {
  readonly __typename?: 'Query';
  readonly me?: {
    readonly __typename?: 'User';
    readonly id: string;
    readonly organizations: {
      readonly __typename?: 'OrganizationConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'UserOrganizationEdge';
        readonly cursor: string;
        readonly node?: {
          readonly __typename?: 'Organization';
          readonly id: string;
          readonly name: string;
        } | null;
      }>;
      readonly pageInfo: {
        readonly __typename?: 'PageInfo';
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
    };
  } | null;
};

export type OrganizationInvitationQueryVariables = Exact<{
  [key: string]: never;
}>;

export type OrganizationInvitationQuery = {
  readonly __typename?: 'Query';
  readonly me?: {
    readonly __typename?: 'User';
    readonly id: string;
    readonly email: any;
    readonly organizationInvitations?: {
      readonly __typename?: 'OrganizationInvitationConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'OrganizationInvitationEdge';
        readonly node?: {
          readonly __typename?: 'OrganizationInvitation';
          readonly id: string;
          readonly status: OrganizationInvitationStatus;
          readonly role: OrganizationMemberRoles;
          readonly organization: {
            readonly __typename?: 'Organization';
            readonly id: string;
            readonly name: string;
          };
        } | null;
      }>;
    } | null;
  } | null;
};

export type OrganizationInvitationAcceptMutationVariables = Exact<{
  input: OrganizationInvitationAcceptInput;
}>;

export type OrganizationInvitationAcceptMutation = {
  readonly __typename?: 'Mutation';
  readonly organizationMemberInvitationAccept?: {
    readonly __typename?: 'OrganizationInvitationAcceptPayload';
    readonly userErrors: ReadonlyArray<{
      readonly __typename?: 'OrganizationMemberInvitationAcceptError';
      readonly code: OrganizationMemberInvitationAcceptErrorCode;
    }>;
    readonly invitation?: {
      readonly __typename?: 'OrganizationInvitation';
      readonly status: OrganizationInvitationStatus;
      readonly id: string;
      readonly organization: {
        readonly __typename?: 'Organization';
        readonly name: string;
        readonly id: string;
      };
    } | null;
  } | null;
};

export type OrganizationInvitationRejectMutationVariables = Exact<{
  input: OrganizationInvitationRejectInput;
}>;

export type OrganizationInvitationRejectMutation = {
  readonly __typename?: 'Mutation';
  readonly organizationMemberInvitationReject?: {
    readonly __typename?: 'OrganizationInvitationRejectPayload';
    readonly userErrors: ReadonlyArray<{
      readonly __typename?: 'OrganizationMemberInvitationRejectError';
      readonly code: OrganizationMemberInvitationRejectErrorCode;
    }>;
    readonly invitation?: {
      readonly __typename?: 'OrganizationInvitation';
      readonly status: OrganizationInvitationStatus;
      readonly id: string;
    } | null;
  } | null;
};

export type UserAcceptTermsMutationVariables = Exact<{
  input: AcceptTermsInput;
}>;

export type UserAcceptTermsMutation = {
  readonly __typename?: 'Mutation';
  readonly userAcceptTerms?: {
    readonly __typename?: 'AcceptTermsPayload';
    readonly clientMutationId?: string | null;
    readonly me?: {
      readonly __typename?: 'User';
      readonly id: string;
      readonly hasAcceptedTerms: boolean;
    } | null;
  } | null;
};

export type CurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentUserQuery = {
  readonly __typename?: 'Query';
  readonly me?: {
    readonly __typename?: 'User';
    readonly id: string;
    readonly email: any;
  } | null;
};

export type OrganizationMemberRoleQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  emailQuery?: InputMaybe<Scalars['String']['input']>;
}>;

export type OrganizationMemberRoleQuery = {
  readonly __typename?: 'Query';
  readonly organization?: {
    readonly __typename?: 'Organization';
    readonly id: string;
    readonly members?: {
      readonly __typename?: 'OrganizationMemberConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'OrganizationMemberEdge';
        readonly role?: OrganizationMemberRoles | null;
        readonly node?: {
          readonly __typename?: 'OrganizationMember';
          readonly id: string;
        } | null;
      }>;
    } | null;
    readonly features: {
      readonly __typename?: 'OrganizationFeatures';
      readonly rolesAndPermissions: boolean;
    };
  } | null;
};

export type PaymentPlanQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;

export type PaymentPlanQuery = {
  readonly __typename?: 'Query';
  readonly organization?: {
    readonly __typename?: 'Organization';
    readonly id: string;
    readonly paymentPlan?: {
      readonly __typename?: 'PaymentPlan';
      readonly planName: string;
      readonly planNameLocale: string;
    } | null;
  } | null;
};

export type OrganizationExistsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  spaceExternalIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}>;

export type OrganizationExistsQuery = {
  readonly __typename?: 'Query';
  readonly organization?: {
    readonly __typename?: 'Organization';
    readonly id: string;
    readonly name: string;
    readonly spaces: {
      readonly __typename?: 'OrganizationSpaceConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'OrganizationSpaceEdge';
        readonly node?: {
          readonly __typename?: 'OrganizationSpace';
          readonly id: string;
          readonly externalId: string;
          readonly name: string;
        } | null;
      }>;
    };
  } | null;
};

export type EventExistsQueryVariables = Exact<{
  eventSlug: Scalars['String']['input'];
}>;

export type EventExistsQuery = {
  readonly __typename?: 'Query';
  readonly eventBySlug?: {
    readonly __typename?: 'Event';
    readonly id: string;
  } | null;
};

export type UserEventEdgeFragment = {
  readonly __typename?: 'UserEventEdge';
  readonly cursor: string;
  readonly node?: {
    readonly __typename?: 'Event';
    readonly id: string;
    readonly name: string;
    readonly timeStart: any;
    readonly timeEnd: any;
    readonly slug: string;
    readonly registrationPageUrl: any;
    readonly host: { readonly __typename?: 'Host'; readonly name: string };
    readonly image: {
      readonly __typename?: 'Image';
      readonly small?: any | null;
    };
    readonly priceRange: {
      readonly __typename?: 'EventPriceRange';
      readonly minTicketPrice?: {
        readonly __typename?: 'Money';
        readonly amount: any;
        readonly currencyCode: CurrencyCode;
      } | null;
      readonly maxTicketPrice?: {
        readonly __typename?: 'Money';
        readonly amount: any;
        readonly currencyCode: CurrencyCode;
      } | null;
    };
  } | null;
};

export type EventCardFragment = {
  readonly __typename?: 'Event';
  readonly id: string;
  readonly name: string;
  readonly timeStart: any;
  readonly timeEnd: any;
  readonly slug: string;
  readonly registrationPageUrl: any;
  readonly host: { readonly __typename?: 'Host'; readonly name: string };
  readonly image: {
    readonly __typename?: 'Image';
    readonly small?: any | null;
  };
  readonly priceRange: {
    readonly __typename?: 'EventPriceRange';
    readonly minTicketPrice?: {
      readonly __typename?: 'Money';
      readonly amount: any;
      readonly currencyCode: CurrencyCode;
    } | null;
    readonly maxTicketPrice?: {
      readonly __typename?: 'Money';
      readonly amount: any;
      readonly currencyCode: CurrencyCode;
    } | null;
  };
};

export type UpcomingEventsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
}>;

export type UpcomingEventsQuery = {
  readonly __typename?: 'Query';
  readonly me?: {
    readonly __typename?: 'User';
    readonly id: string;
    readonly registeredEvents: {
      readonly __typename?: 'UserEventConnection';
      readonly pageInfo: {
        readonly __typename?: 'PageInfo';
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'UserEventEdge';
        readonly node?: {
          readonly __typename?: 'Event';
          readonly id: string;
          readonly name: string;
          readonly timeStart: any;
          readonly timeEnd: any;
          readonly slug: string;
          readonly registrationPageUrl: any;
          readonly host: {
            readonly __typename?: 'Host';
            readonly name: string;
          };
          readonly image: {
            readonly __typename?: 'Image';
            readonly small?: any | null;
          };
          readonly priceRange: {
            readonly __typename?: 'EventPriceRange';
            readonly minTicketPrice?: {
              readonly __typename?: 'Money';
              readonly amount: any;
              readonly currencyCode: CurrencyCode;
            } | null;
            readonly maxTicketPrice?: {
              readonly __typename?: 'Money';
              readonly amount: any;
              readonly currencyCode: CurrencyCode;
            } | null;
          };
        } | null;
      }>;
    };
  } | null;
};

export type PastEventsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
}>;

export type PastEventsQuery = {
  readonly __typename?: 'Query';
  readonly me?: {
    readonly __typename?: 'User';
    readonly id: string;
    readonly registeredEvents: {
      readonly __typename?: 'UserEventConnection';
      readonly pageInfo: {
        readonly __typename?: 'PageInfo';
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'UserEventEdge';
        readonly node?: {
          readonly __typename?: 'Event';
          readonly id: string;
          readonly name: string;
          readonly timeStart: any;
          readonly timeEnd: any;
          readonly slug: string;
          readonly registrationPageUrl: any;
          readonly host: {
            readonly __typename?: 'Host';
            readonly name: string;
          };
          readonly image: {
            readonly __typename?: 'Image';
            readonly small?: any | null;
          };
          readonly priceRange: {
            readonly __typename?: 'EventPriceRange';
            readonly minTicketPrice?: {
              readonly __typename?: 'Money';
              readonly amount: any;
              readonly currencyCode: CurrencyCode;
            } | null;
            readonly maxTicketPrice?: {
              readonly __typename?: 'Money';
              readonly amount: any;
              readonly currencyCode: CurrencyCode;
            } | null;
          };
        } | null;
      }>;
    };
  } | null;
};

export type AttendeeProfileQueryVariables = Exact<{ [key: string]: never }>;

export type AttendeeProfileQuery = {
  readonly __typename?: 'Query';
  readonly me?: {
    readonly __typename?: 'User';
    readonly id: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly email: any;
    readonly headline?: string | null;
    readonly bio?: string | null;
    readonly linkedinUrl?: any | null;
    readonly twitterUrl?: any | null;
    readonly websiteUrl?: any | null;
    readonly deleteConfirmationPhrase: string;
    readonly userLoggedInViaSso: boolean;
    readonly image: {
      readonly __typename?: 'Image';
      readonly url?: any | null;
    };
  } | null;
};

export type UserUpdateFieldsFragment = {
  readonly __typename?: 'UserUpdatePayload';
  readonly me?: {
    readonly __typename?: 'User';
    readonly id: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly email: any;
    readonly headline?: string | null;
    readonly bio?: string | null;
    readonly linkedinUrl?: any | null;
    readonly twitterUrl?: any | null;
    readonly websiteUrl?: any | null;
    readonly deleteConfirmationPhrase: string;
    readonly userLoggedInViaSso: boolean;
    readonly image: {
      readonly __typename?: 'Image';
      readonly url?: any | null;
      readonly small?: any | null;
      readonly large?: any | null;
    };
  } | null;
  readonly userErrors: ReadonlyArray<{
    readonly __typename?: 'UserUpdateError';
    readonly message: string;
    readonly path?: ReadonlyArray<string> | null;
    readonly code: UserUpdateErrorCode;
  }>;
};

export type UpdateAttendeeProfileMutationVariables = Exact<{
  input: UserUpdateInput;
}>;

export type UpdateAttendeeProfileMutation = {
  readonly __typename?: 'Mutation';
  readonly userUpdate?: {
    readonly __typename?: 'UserUpdatePayload';
    readonly me?: {
      readonly __typename?: 'User';
      readonly id: string;
      readonly firstName: string;
      readonly lastName: string;
      readonly email: any;
      readonly headline?: string | null;
      readonly bio?: string | null;
      readonly linkedinUrl?: any | null;
      readonly twitterUrl?: any | null;
      readonly websiteUrl?: any | null;
      readonly deleteConfirmationPhrase: string;
      readonly userLoggedInViaSso: boolean;
      readonly image: {
        readonly __typename?: 'Image';
        readonly url?: any | null;
        readonly small?: any | null;
        readonly large?: any | null;
      };
    } | null;
    readonly userErrors: ReadonlyArray<{
      readonly __typename?: 'UserUpdateError';
      readonly message: string;
      readonly path?: ReadonlyArray<string> | null;
      readonly code: UserUpdateErrorCode;
    }>;
  } | null;
};

export type UpdatePasswordMutationVariables = Exact<{
  input: UserChangePasswordInput;
}>;

export type UpdatePasswordMutation = {
  readonly __typename?: 'Mutation';
  readonly userChangePassword?: {
    readonly __typename?: 'UserChangePasswordPayload';
    readonly userErrors: ReadonlyArray<{
      readonly __typename?: 'UserChangePasswordError';
      readonly message: string;
      readonly path?: ReadonlyArray<string> | null;
      readonly code: UserChangePasswordErrorCode;
    }>;
  } | null;
};

export type UserChangeEmailMutationVariables = Exact<{
  input: UserChangeEmailInput;
}>;

export type UserChangeEmailMutation = {
  readonly __typename?: 'Mutation';
  readonly userChangeEmail?: {
    readonly __typename?: 'UserChangeEmailPayload';
    readonly userErrors: ReadonlyArray<{
      readonly __typename?: 'UserChangeEmailError';
      readonly message: string;
      readonly path?: ReadonlyArray<string> | null;
      readonly code: UserChangeEmailErrorCode;
    }>;
  } | null;
};

export type UserChangePasswordMutationVariables = Exact<{
  input: UserChangePasswordInput;
}>;

export type UserChangePasswordMutation = {
  readonly __typename?: 'Mutation';
  readonly userChangePassword?: {
    readonly __typename?: 'UserChangePasswordPayload';
    readonly userErrors: ReadonlyArray<{
      readonly __typename?: 'UserChangePasswordError';
      readonly message: string;
      readonly path?: ReadonlyArray<string> | null;
      readonly code: UserChangePasswordErrorCode;
    }>;
  } | null;
};

export type DeleteAccountMutationVariables = Exact<{
  confirmationPhrase: Scalars['String']['input'];
}>;

export type DeleteAccountMutation = {
  readonly __typename?: 'Mutation';
  readonly userDelete?: {
    readonly __typename?: 'UserDeletePayload';
    readonly bye?: string | null;
    readonly userErrors: ReadonlyArray<{
      readonly __typename?: 'UserDeleteError';
      readonly message: string;
      readonly path?: ReadonlyArray<string> | null;
    }>;
  } | null;
};

export type AccountConnectionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type AccountConnectionsQuery = {
  readonly __typename?: 'Query';
  readonly me?: {
    readonly __typename?: 'User';
    readonly id: string;
    readonly connections: {
      readonly __typename?: 'EventRegistrantProfileConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'EventRegistrantProfileEdge';
        readonly cursor: string;
        readonly node?: {
          readonly __typename?: 'EventRegistrantProfile';
          readonly id: string;
          readonly firstName: string;
          readonly lastName: string;
          readonly headline?: string | null;
          readonly email?: any | null;
          readonly websiteUrl?: any | null;
          readonly twitterUrl?: any | null;
          readonly linkedinUrl?: any | null;
          readonly image: {
            readonly __typename?: 'Image';
            readonly url?: any | null;
          };
          readonly event?: {
            readonly __typename?: 'Event';
            readonly id: string;
            readonly name: string;
            readonly slug: string;
            readonly timeStart: any;
            readonly timeEnd: any;
          } | null;
        } | null;
      }>;
      readonly pageInfo: {
        readonly __typename?: 'PageInfo';
        readonly endCursor?: string | null;
        readonly startCursor?: string | null;
        readonly hasNextPage: boolean;
        readonly hasPreviousPage: boolean;
      };
    };
  } | null;
};

export type RegisteredEventsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type RegisteredEventsQuery = {
  readonly __typename?: 'Query';
  readonly me?: {
    readonly __typename?: 'User';
    readonly id: string;
    readonly registeredEvents: {
      readonly __typename?: 'UserEventConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'UserEventEdge';
        readonly node?: {
          readonly __typename?: 'Event';
          readonly id: string;
          readonly name: string;
        } | null;
      }>;
      readonly pageInfo: {
        readonly __typename?: 'PageInfo';
        readonly endCursor?: string | null;
        readonly startCursor?: string | null;
        readonly hasNextPage: boolean;
      };
    };
  } | null;
};

export type DeleteConnectionMutationVariables = Exact<{
  input: UserConnectionDeleteInput;
}>;

export type DeleteConnectionMutation = {
  readonly __typename?: 'Mutation';
  readonly userConnectionDelete?: {
    readonly __typename?: 'UserConnectionDeletePayload';
    readonly deletedRegistrantId?: string | null;
  } | null;
};

export type OrganizationEventsFilterQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  spaceExternalId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type OrganizationEventsFilterQuery = {
  readonly __typename?: 'Query';
  readonly organization?: {
    readonly __typename?: 'Organization';
    readonly id: string;
    readonly events: {
      readonly __typename?: 'EventConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'EventEdge';
        readonly node?: {
          readonly __typename?: 'Event';
          readonly id: string;
          readonly name: string;
        } | null;
      }>;
      readonly pageInfo: {
        readonly __typename?: 'PageInfo';
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
    };
  } | null;
};

export type EventSlugByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type EventSlugByIdQuery = {
  readonly __typename?: 'Query';
  readonly event?: {
    readonly __typename?: 'Event';
    readonly slug: string;
  } | null;
};

export type EventInfoByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type EventInfoByIdQuery = {
  readonly __typename?: 'Query';
  readonly event?: {
    readonly __typename?: 'Event';
    readonly name: string;
    readonly slug: string;
    readonly status?: EventStatus | null;
    readonly timeStart: any;
    readonly timeEnd: any;
    readonly expired: boolean;
    readonly image: {
      readonly __typename?: 'Image';
      readonly url?: any | null;
    };
  } | null;
};

export type EventSpeakersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type EventSpeakersQuery = {
  readonly __typename?: 'Query';
  readonly event?: {
    readonly __typename?: 'Event';
    readonly speakers: {
      readonly __typename?: 'EventSpeakerConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'EventSpeakerEdge';
        readonly node?: {
          readonly __typename?: 'EventSpeaker';
          readonly firstName: string;
          readonly id: string;
          readonly lastName: string;
          readonly headline?: string | null;
          readonly bio?: string | null;
          readonly image: {
            readonly __typename?: 'Image';
            readonly url?: any | null;
          };
        } | null;
      }>;
      readonly pageInfo: {
        readonly __typename?: 'PageInfo';
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
    };
  } | null;
};

export type PublishToEventItemFragment = {
  readonly __typename?: 'Event';
  readonly id: string;
  readonly slug: string;
  readonly name: string;
  readonly createdAt: any;
  readonly status?: EventStatus | null;
  readonly expired: boolean;
  readonly isLite: boolean;
  readonly venueType: string;
  readonly timeStart: any;
  readonly timeEnd: any;
  readonly timeZone: string;
  readonly image: { readonly __typename?: 'Image'; readonly url?: any | null };
};

export type OrganizationEventsForPublishQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  eventsSortKey?: InputMaybe<EventSortKeys>;
  eventsSortReverse?: InputMaybe<Scalars['Boolean']['input']>;
  spaceExternalId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type OrganizationEventsForPublishQuery = {
  readonly __typename?: 'Query';
  readonly organization?: {
    readonly __typename?: 'Organization';
    readonly id: string;
    readonly events: {
      readonly __typename?: 'EventConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'EventEdge';
        readonly node?: {
          readonly __typename?: 'Event';
          readonly id: string;
          readonly slug: string;
          readonly name: string;
          readonly createdAt: any;
          readonly status?: EventStatus | null;
          readonly expired: boolean;
          readonly isLite: boolean;
          readonly venueType: string;
          readonly timeStart: any;
          readonly timeEnd: any;
          readonly timeZone: string;
          readonly image: {
            readonly __typename?: 'Image';
            readonly url?: any | null;
          };
        } | null;
      }>;
      readonly pageInfo: {
        readonly __typename?: 'PageInfo';
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
    };
  } | null;
};

export type OrganizationFeaturesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;

export type OrganizationFeaturesQuery = {
  readonly __typename?: 'Query';
  readonly organization?: {
    readonly __typename?: 'Organization';
    readonly id: string;
    readonly features: {
      readonly __typename?: 'OrganizationFeatures';
      readonly onsiteHybridEvents: boolean;
      readonly maxEventLengthHours: number;
    };
    readonly paymentPlan?: {
      readonly __typename?: 'PaymentPlan';
      readonly planName: string;
    } | null;
  } | null;
};

export type SeriesRowFragment = {
  readonly __typename?: 'EventSeries';
  readonly id: string;
  readonly name: string;
  readonly eventsCount: number;
};

export type SeriesRowEdgeFragment = {
  readonly __typename?: 'EventSeriesEdge';
  readonly cursor: string;
  readonly node?: {
    readonly __typename?: 'EventSeries';
    readonly id: string;
    readonly name: string;
    readonly eventsCount: number;
  } | null;
};

export type OrganizationSeriesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  eventSeriesQuery?: InputMaybe<Scalars['String']['input']>;
  eventSeriesSortKey?: InputMaybe<EventSeriesSortKeys>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  spaceExternalId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type OrganizationSeriesQuery = {
  readonly __typename?: 'Query';
  readonly organization?: {
    readonly __typename?: 'Organization';
    readonly id: string;
    readonly eventSeries: {
      readonly __typename?: 'EventSeriesConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'EventSeriesEdge';
        readonly cursor: string;
        readonly node?: {
          readonly __typename?: 'EventSeries';
          readonly id: string;
          readonly name: string;
          readonly eventsCount: number;
        } | null;
      }>;
      readonly pageInfo: {
        readonly __typename?: 'PageInfo';
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
    };
  } | null;
};

export type SingleSeriesQueryVariables = Exact<{
  eventSeriesId: Scalars['ID']['input'];
}>;

export type SingleSeriesQuery = {
  readonly __typename?: 'Query';
  readonly eventSeries?: {
    readonly __typename?: 'EventSeries';
    readonly id: string;
    readonly name: string;
    readonly eventsCount: number;
  } | null;
};

export type OrganizationCreateMutationVariables = Exact<{
  input: OrganizationCreateInput;
}>;

export type OrganizationCreateMutation = {
  readonly __typename?: 'Mutation';
  readonly organizationCreate?: {
    readonly __typename?: 'OrganizationCreatePayload';
    readonly clientMutationId?: string | null;
    readonly organization?: {
      readonly __typename?: 'Organization';
      readonly name: string;
      readonly about?: string | null;
      readonly email: any;
      readonly id: string;
    } | null;
    readonly userErrors: ReadonlyArray<{
      readonly __typename?: 'OrganizationCreateError';
      readonly code: OrganizationCreateErrorCode;
      readonly message: string;
      readonly path?: ReadonlyArray<string> | null;
    }>;
  } | null;
};

export type MyDetailsQueryVariables = Exact<{ [key: string]: never }>;

export type MyDetailsQuery = {
  readonly __typename?: 'Query';
  readonly me?: {
    readonly __typename?: 'User';
    readonly id: string;
    readonly email: any;
    readonly firstName: string;
    readonly lastName: string;
  } | null;
};

export type OrganizationDetailsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;

export type OrganizationDetailsQuery = {
  readonly __typename?: 'Query';
  readonly organization?: {
    readonly __typename?: 'Organization';
    readonly id: string;
    readonly name: string;
    readonly about?: string | null;
    readonly email: any;
    readonly facebookUrl?: any | null;
    readonly linkedinUrl?: any | null;
    readonly twitterUrl?: any | null;
    readonly websiteUrl?: any | null;
    readonly createdAt: any;
    readonly features: {
      readonly __typename?: 'OrganizationFeatures';
      readonly eventsLite: boolean;
      readonly eventsPro: boolean;
      readonly onsiteHybridEvents: boolean;
      readonly appStore: boolean;
    };
    readonly paymentPlan?: {
      readonly __typename?: 'PaymentPlan';
      readonly planName: string;
      readonly planNameLocale: string;
      readonly downgradedToFree: boolean;
      readonly endsAt?: any | null;
      readonly isAdvanced: boolean;
    } | null;
    readonly settings?: {
      readonly __typename?: 'OrganizationSetting';
      readonly disableAiFeatures: boolean;
    } | null;
    readonly image: {
      readonly __typename?: 'Image';
      readonly small?: any | null;
      readonly medium?: any | null;
      readonly large?: any | null;
    };
    readonly standaloneStudios: ReadonlyArray<{
      readonly __typename?: 'StandaloneStudio';
      readonly name: string;
      readonly uuid: string;
      readonly event: { readonly __typename?: 'Event'; readonly slug: string };
    }>;
  } | null;
};

export type UpdateOrgMutationVariables = Exact<{
  input: OrganizationUpdateInput;
}>;

export type UpdateOrgMutation = {
  readonly __typename?: 'Mutation';
  readonly organizationUpdate?: {
    readonly __typename?: 'OrganizationUpdatePayload';
    readonly organization?: {
      readonly __typename?: 'Organization';
      readonly id: string;
      readonly about?: string | null;
      readonly email: any;
      readonly name: string;
      readonly twitterUrl?: any | null;
      readonly facebookUrl?: any | null;
      readonly linkedinUrl?: any | null;
      readonly websiteUrl?: any | null;
      readonly image: {
        readonly __typename?: 'Image';
        readonly url?: any | null;
        readonly small?: any | null;
        readonly large?: any | null;
      };
    } | null;
    readonly userErrors: ReadonlyArray<{
      readonly __typename?: 'OrganizationUpdateError';
      readonly message: string;
      readonly path?: ReadonlyArray<string> | null;
      readonly code: OrganizationUpdateErrorCode;
    }>;
  } | null;
};

export type OrganizationByOwnerIdQueryVariables = Exact<{
  ownerId: Scalars['ID']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type OrganizationByOwnerIdQuery = {
  readonly __typename?: 'Query';
  readonly me?: {
    readonly __typename?: 'User';
    readonly id: string;
    readonly organizations: {
      readonly __typename?: 'OrganizationConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'UserOrganizationEdge';
        readonly cursor: string;
        readonly node?: {
          readonly __typename?: 'Organization';
          readonly id: string;
        } | null;
      }>;
      readonly pageInfo: {
        readonly __typename?: 'PageInfo';
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
    };
  } | null;
};

export type OrganizationSpacesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type OrganizationSpacesQuery = {
  readonly __typename?: 'Query';
  readonly organization?: {
    readonly __typename?: 'Organization';
    readonly id: string;
    readonly spaces: {
      readonly __typename?: 'OrganizationSpaceConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'OrganizationSpaceEdge';
        readonly cursor: string;
        readonly node?: {
          readonly __typename?: 'OrganizationSpace';
          readonly id: string;
          readonly externalId: string;
          readonly name: string;
          readonly membersCount: number;
        } | null;
      }>;
      readonly pageInfo: {
        readonly __typename?: 'PageInfo';
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
    };
  } | null;
};

export type OrganizationSpaceExistsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  spaceExternalId: Scalars['ID']['input'];
}>;

export type OrganizationSpaceExistsQuery = {
  readonly __typename?: 'Query';
  readonly organization?: {
    readonly __typename?: 'Organization';
    readonly id: string;
    readonly spaces: {
      readonly __typename?: 'OrganizationSpaceConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'OrganizationSpaceEdge';
        readonly node?: {
          readonly __typename?: 'OrganizationSpace';
          readonly id: string;
        } | null;
      }>;
    };
  } | null;
};

export type EventRowFragment = {
  readonly __typename?: 'Event';
  readonly id: string;
  readonly name: string;
  readonly slug: string;
  readonly registrationsCount?: number | null;
  readonly status?: EventStatus | null;
  readonly description?: string | null;
  readonly timeStart: any;
  readonly timeEnd: any;
  readonly deletable?: EventDeletableStatus | null;
  readonly expired: boolean;
  readonly isLite: boolean;
  readonly venueType: string;
  readonly eventSeriesCount?: number | null;
  readonly eventSeriesNames: ReadonlyArray<string>;
  readonly image: { readonly __typename?: 'Image'; readonly url?: any | null };
  readonly eventSeries: {
    readonly __typename?: 'EventSeriesConnection';
    readonly edges: ReadonlyArray<{
      readonly __typename?: 'EventSeriesEdge';
      readonly node?: {
        readonly __typename?: 'EventSeries';
        readonly id: string;
        readonly name: string;
        readonly eventsCount: number;
      } | null;
    }>;
  };
};

export type EventRowEdgeFragment = {
  readonly __typename?: 'EventEdge';
  readonly cursor: string;
  readonly node?: {
    readonly __typename?: 'Event';
    readonly id: string;
    readonly name: string;
    readonly slug: string;
    readonly registrationsCount?: number | null;
    readonly status?: EventStatus | null;
    readonly description?: string | null;
    readonly timeStart: any;
    readonly timeEnd: any;
    readonly deletable?: EventDeletableStatus | null;
    readonly expired: boolean;
    readonly isLite: boolean;
    readonly venueType: string;
    readonly eventSeriesCount?: number | null;
    readonly eventSeriesNames: ReadonlyArray<string>;
    readonly image: {
      readonly __typename?: 'Image';
      readonly url?: any | null;
    };
    readonly eventSeries: {
      readonly __typename?: 'EventSeriesConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'EventSeriesEdge';
        readonly node?: {
          readonly __typename?: 'EventSeries';
          readonly id: string;
          readonly name: string;
          readonly eventsCount: number;
        } | null;
      }>;
    };
  } | null;
};

export type OrganizationEventsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  eventsQuery?: InputMaybe<Scalars['String']['input']>;
  eventsSortKey?: InputMaybe<EventSortKeys>;
  eventsSortReverse?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  pinEventSeries?: InputMaybe<Scalars['String']['input']>;
  spaceExternalId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type OrganizationEventsQuery = {
  readonly __typename?: 'Query';
  readonly organization?: {
    readonly __typename?: 'Organization';
    readonly id: string;
    readonly features: {
      readonly __typename?: 'OrganizationFeatures';
      readonly eventsLite: boolean;
      readonly eventsPro: boolean;
    };
    readonly events: {
      readonly __typename?: 'EventConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'EventEdge';
        readonly cursor: string;
        readonly node?: {
          readonly __typename?: 'Event';
          readonly id: string;
          readonly name: string;
          readonly slug: string;
          readonly registrationsCount?: number | null;
          readonly status?: EventStatus | null;
          readonly description?: string | null;
          readonly timeStart: any;
          readonly timeEnd: any;
          readonly deletable?: EventDeletableStatus | null;
          readonly expired: boolean;
          readonly isLite: boolean;
          readonly venueType: string;
          readonly eventSeriesCount?: number | null;
          readonly eventSeriesNames: ReadonlyArray<string>;
          readonly image: {
            readonly __typename?: 'Image';
            readonly url?: any | null;
          };
          readonly eventSeries: {
            readonly __typename?: 'EventSeriesConnection';
            readonly edges: ReadonlyArray<{
              readonly __typename?: 'EventSeriesEdge';
              readonly node?: {
                readonly __typename?: 'EventSeries';
                readonly id: string;
                readonly name: string;
                readonly eventsCount: number;
              } | null;
            }>;
          };
        } | null;
      }>;
      readonly pageInfo: {
        readonly __typename?: 'PageInfo';
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
    };
  } | null;
};

export type EventDuplicatableQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;

export type EventDuplicatableQuery = {
  readonly __typename?: 'Query';
  readonly event?: {
    readonly __typename?: 'Event';
    readonly id: string;
    readonly canBeDuplicated?: boolean | null;
  } | null;
};

export type DeleteEventMutationVariables = Exact<{
  input: EventDeleteInput;
}>;

export type DeleteEventMutation = {
  readonly __typename?: 'Mutation';
  readonly eventDelete?: {
    readonly __typename?: 'EventDeletePayload';
    readonly clientMutationId?: string | null;
    readonly deletedId?: string | null;
    readonly userErrors: ReadonlyArray<{
      readonly __typename?: 'EventDeleteError';
      readonly code: EventDeleteErrorCode;
      readonly message: string;
      readonly path?: ReadonlyArray<string> | null;
    }>;
  } | null;
};

export type OrganizationLatestEventsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  spaceExternalId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type OrganizationLatestEventsQuery = {
  readonly __typename?: 'Query';
  readonly organization?: {
    readonly __typename?: 'Organization';
    readonly id: string;
    readonly events: {
      readonly __typename?: 'EventConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'EventEdge';
        readonly node?: {
          readonly __typename?: 'Event';
          readonly id: string;
        } | null;
      }>;
    };
  } | null;
};

export type EventMembersWithAccessQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<OrganizationMemberSortKeys>;
}>;

export type EventMembersWithAccessQuery = {
  readonly __typename?: 'Query';
  readonly event?: {
    readonly __typename?: 'Event';
    readonly id: string;
    readonly organizationMembersWithAccess: {
      readonly __typename?: 'EventOrganizationMemberConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'EventOrganizationMemberEdge';
        readonly role?: OrganizationMemberRoles | null;
        readonly node?: {
          readonly __typename?: 'OrganizationMember';
          readonly id: string;
          readonly firstName: string;
          readonly lastName: string;
          readonly email: any;
          readonly image: {
            readonly __typename?: 'Image';
            readonly url?: any | null;
          };
        } | null;
      }>;
      readonly pageInfo: {
        readonly __typename?: 'PageInfo';
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
    };
  } | null;
};

export type EventMembersWithoutAccessQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<OrganizationMemberSortKeys>;
}>;

export type EventMembersWithoutAccessQuery = {
  readonly __typename?: 'Query';
  readonly event?: {
    readonly __typename?: 'Event';
    readonly id: string;
    readonly organizationMembersWithoutAccess: {
      readonly __typename?: 'EventOrganizationMemberConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'EventOrganizationMemberEdge';
        readonly role?: OrganizationMemberRoles | null;
        readonly node?: {
          readonly __typename?: 'OrganizationMember';
          readonly id: string;
          readonly firstName: string;
          readonly lastName: string;
          readonly email: any;
          readonly image: {
            readonly __typename?: 'Image';
            readonly url?: any | null;
          };
        } | null;
      }>;
      readonly pageInfo: {
        readonly __typename?: 'PageInfo';
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
    };
  } | null;
};

export type OrganizationMemberEventAccessUpdateMutationVariables = Exact<{
  input: OrganizationMemberEventAccessUpdateInput;
}>;

export type OrganizationMemberEventAccessUpdateMutation = {
  readonly __typename?: 'Mutation';
  readonly organizationMemberEventAccessUpdate?: {
    readonly __typename?: 'OrganizationMemberEventAccessUpdatePayload';
    readonly eventAccess?: OrganizationMemberEventAccessTypes | null;
    readonly organizationMember?: {
      readonly __typename?: 'OrganizationInvitation';
      readonly id: string;
      readonly email: any;
    } | null;
    readonly userErrors: ReadonlyArray<{
      readonly __typename?: 'OrganizationMemberEventAccessUpdateError';
      readonly message: string;
      readonly path?: ReadonlyArray<string> | null;
      readonly code: OrganizationMemberEventAccessUpdateErrorCode;
    }>;
  } | null;
};

export type OrganizationMemberEventAccessBulkUpdateAllMutationVariables =
  Exact<{
    input: OrganizationMemberEventAccessBulkUpdateAllInput;
  }>;

export type OrganizationMemberEventAccessBulkUpdateAllMutation = {
  readonly __typename?: 'Mutation';
  readonly organizationMemberEventAccessBulkUpdateAll?: {
    readonly __typename?: 'OrganizationMemberEventAccessBulkUpdateAllPayload';
    readonly eventAccess?: OrganizationMemberEventAccessTypes | null;
  } | null;
};

export type OrganizationBillingQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;

export type OrganizationBillingQuery = {
  readonly __typename?: 'Query';
  readonly organization?: {
    readonly __typename?: 'Organization';
    readonly id: string;
    readonly name: string;
    readonly paymentPlan?: {
      readonly __typename?: 'PaymentPlan';
      readonly planName: string;
      readonly planNameLocale: string;
      readonly startsAt?: any | null;
      readonly endsAt?: any | null;
      readonly hasActiveSubscription: boolean;
      readonly hasPaymentProviderCustomer: boolean;
      readonly hasEventsLite?: boolean | null;
      readonly hasEventsPro?: boolean | null;
      readonly paidTicketsAllowed: boolean;
      readonly includedSeats: number;
      readonly usedSeats: number;
      readonly isStripeMigrationEnabled: boolean;
      readonly paymentProviderConnectedAccountClientId: string;
      readonly registrationsUsage?:
        | {
            readonly __typename: 'AdvancedRegistrationsUsage';
            readonly used: number;
            readonly included: number;
          }
        | {
            readonly __typename: 'AppsumoRegistrationsUsage';
            readonly usedFree: number;
            readonly usedPaid: number;
            readonly includedFree: number;
            readonly includedPaid: number;
          }
        | {
            readonly __typename: 'BaseRegistrationsUsage';
            readonly name?: number | null;
          }
        | {
            readonly __typename: 'FreeRegistrationsUsage';
            readonly includedPerEvent: number;
          }
        | {
            readonly __typename: 'SelfServeRegistrationsUsage';
            readonly included: number;
            readonly available: number;
            readonly accrued: number;
            readonly used: number;
          }
        | null;
      readonly seats: {
        readonly __typename: 'PaymentPlanSeats';
        readonly included: number;
        readonly usedIncluded: number;
        readonly additional: number;
        readonly usedAdditional: number;
        readonly total: number;
        readonly usedTotal: number;
        readonly additionalSeatPrice?: {
          readonly __typename?: 'Money';
          readonly amount: any;
          readonly currencyCode: CurrencyCode;
        } | null;
      };
      readonly attendeesStats?:
        | {
            readonly __typename: 'BaseAttendeesStats';
            readonly name?: number | null;
          }
        | {
            readonly __typename: 'EssentialsAttendeesStats';
            readonly eventAttendeesAllowance: number;
            readonly eventCountAboveAllowance: number;
            readonly eventCountBelowAllowance: number;
          }
        | null;
    } | null;
  } | null;
};

export type StripeUnlinkAccountMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;

export type StripeUnlinkAccountMutation = {
  readonly __typename?: 'Mutation';
  readonly stripeUnlinkAccount?: {
    readonly __typename?: 'StripeUnlinkAccountPayload';
    readonly unlinkedOrganizationId?: string | null;
  } | null;
};

export type OrganizationManageableSpacesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type OrganizationManageableSpacesQuery = {
  readonly __typename?: 'Query';
  readonly organization?: {
    readonly __typename?: 'Organization';
    readonly id: string;
    readonly manageableSpaces: {
      readonly __typename?: 'OrganizationSpaceConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'OrganizationSpaceEdge';
        readonly cursor: string;
        readonly node?: {
          readonly __typename?: 'OrganizationSpace';
          readonly id: string;
          readonly externalId: string;
          readonly name: string;
          readonly membersCount: number;
        } | null;
      }>;
      readonly pageInfo: {
        readonly __typename?: 'PageInfo';
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
    };
  } | null;
};

export type OrganizationSpaceCreateMutationVariables = Exact<{
  input: OrganizationSpaceCreateInput;
}>;

export type OrganizationSpaceCreateMutation = {
  readonly __typename?: 'Mutation';
  readonly organizationSpaceCreate?: {
    readonly __typename?: 'OrganizationSpaceCreatePayload';
    readonly organizationSpace?: {
      readonly __typename?: 'OrganizationSpace';
      readonly id: string;
      readonly externalId: string;
      readonly name: string;
      readonly membersCount: number;
    } | null;
    readonly userErrors: ReadonlyArray<{
      readonly __typename?: 'OrganizationSpaceCreateError';
      readonly code: OrganizationSpaceCreateErrorCode;
      readonly message: string;
      readonly path?: ReadonlyArray<string> | null;
    }>;
  } | null;
};

export type RenameOrganizationSpaceMutationVariables = Exact<{
  input: OrganizationSpaceUpdateInput;
}>;

export type RenameOrganizationSpaceMutation = {
  readonly __typename?: 'Mutation';
  readonly organizationSpaceUpdate?: {
    readonly __typename?: 'OrganizationSpaceUpdatePayload';
    readonly organizationSpace?: {
      readonly __typename?: 'OrganizationSpace';
      readonly id: string;
      readonly externalId: string;
      readonly name: string;
      readonly membersCount: number;
    } | null;
    readonly userErrors: ReadonlyArray<{
      readonly __typename?: 'OrganizationSpaceUpdateError';
      readonly code: OrganizationSpaceUpdateErrorCode;
      readonly message: string;
      readonly path?: ReadonlyArray<string> | null;
    }>;
  } | null;
};

export type InviteMemberMutationVariables = Exact<{
  input: OrganizationMemberInvitationSendInput;
}>;

export type InviteMemberMutation = {
  readonly __typename?: 'Mutation';
  readonly organizationMemberInvitationSend?: {
    readonly __typename?: 'OrganizationMemberInvitationSendPayload';
    readonly invitation?: {
      readonly __typename?: 'OrganizationInvitation';
      readonly id: string;
      readonly email: any;
    } | null;
    readonly userErrors: ReadonlyArray<{
      readonly __typename?: 'OrganizationMemberInvitationSendError';
      readonly message: string;
      readonly path?: ReadonlyArray<string> | null;
      readonly code: OrganizationMemberInvitationSendErrorCode;
    }>;
  } | null;
};

export type OrgTeamDetailsWithPaymentPlanQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;

export type OrgTeamDetailsWithPaymentPlanQuery = {
  readonly __typename?: 'Query';
  readonly organization?: {
    readonly __typename?: 'Organization';
    readonly id: string;
    readonly ownerId: string;
    readonly hasReachedOrganiserLimit?: boolean | null;
    readonly pendingMemberInvitationsCount?: number | null;
    readonly paymentPlan?: {
      readonly __typename?: 'PaymentPlan';
      readonly planName: string;
      readonly isSelfserve: boolean;
      readonly includedRegistrations: number;
      readonly pricing?: {
        readonly __typename?: 'PaymentPlanPricing';
        readonly interval?: PaymentPlanPricingInterval | null;
      } | null;
      readonly seats: {
        readonly __typename?: 'PaymentPlanSeats';
        readonly total: number;
        readonly usedTotal: number;
        readonly additional: number;
        readonly usedAdditional: number;
        readonly included: number;
        readonly usedIncluded: number;
        readonly additionalSeatPrice?: {
          readonly __typename?: 'Money';
          readonly amount: any;
          readonly currencyCode: CurrencyCode;
        } | null;
      };
    } | null;
    readonly features: {
      readonly __typename?: 'OrganizationFeatures';
      readonly rolesAndPermissions: boolean;
    };
  } | null;
};

export type ActiveMembersQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  includeSpaces: Scalars['Boolean']['input'];
}>;

export type ActiveMembersQuery = {
  readonly __typename?: 'Query';
  readonly organization?: {
    readonly __typename?: 'Organization';
    readonly id: string;
    readonly ownerId: string;
    readonly members?: {
      readonly __typename?: 'OrganizationMemberConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'OrganizationMemberEdge';
        readonly role?: OrganizationMemberRoles | null;
        readonly spaces?: ReadonlyArray<{
          readonly __typename?: 'OrganizationSpace';
          readonly id: string;
          readonly externalId: string;
          readonly name: string;
        }>;
        readonly node?: {
          readonly __typename?: 'OrganizationMember';
          readonly id: string;
          readonly firstName: string;
          readonly lastName: string;
          readonly email: any;
          readonly image: {
            readonly __typename?: 'Image';
            readonly url?: any | null;
          };
        } | null;
      }>;
      readonly pageInfo: {
        readonly __typename?: 'PageInfo';
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
    } | null;
    readonly paymentPlan?: {
      readonly __typename?: 'PaymentPlan';
      readonly seats: {
        readonly __typename?: 'PaymentPlanSeats';
        readonly usedAdditional: number;
      };
    } | null;
  } | null;
};

export type OrganizationMemberRoleUpdateMutationVariables = Exact<{
  input: OrganizationMemberRoleUpdateInput;
}>;

export type OrganizationMemberRoleUpdateMutation = {
  readonly __typename?: 'Mutation';
  readonly organizationMemberRoleUpdate?: {
    readonly __typename?: 'OrganizationMemberRoleUpdatePayload';
    readonly clientMutationId?: string | null;
    readonly role?: OrganizationMemberRoles | null;
    readonly organizationMember?: {
      readonly __typename?: 'OrganizationMember';
      readonly id: string;
    } | null;
    readonly userErrors: ReadonlyArray<{
      readonly __typename?: 'OrganizationMemberRoleUpdateError';
      readonly code: OrganizationMemberRoleUpdateErrorCode;
      readonly message: string;
      readonly path?: ReadonlyArray<string> | null;
    }>;
  } | null;
};

export type OrganizationMemberRemoveMutationVariables = Exact<{
  input: OrganizationMemberRemoveInput;
}>;

export type OrganizationMemberRemoveMutation = {
  readonly __typename?: 'Mutation';
  readonly organizationMemberRemove?: {
    readonly __typename?: 'OrganizationMemberRemovePayload';
    readonly removedMemberId?: string | null;
    readonly userErrors: ReadonlyArray<{
      readonly __typename?: 'OrganizationMemberRemoveError';
      readonly code: OrganizationMemberRemoveErrorCode;
      readonly message: string;
      readonly path?: ReadonlyArray<string> | null;
    }>;
  } | null;
};

export type OrganizationMemberSpacesUpdateMutationVariables = Exact<{
  input: OrganizationMemberSpacesUpdateInput;
}>;

export type OrganizationMemberSpacesUpdateMutation = {
  readonly __typename?: 'Mutation';
  readonly organizationMemberSpacesUpdate?: {
    readonly __typename?: 'OrganizationMemberSpacesUpdatePayload';
    readonly clientMutationId?: string | null;
    readonly organizationMember?: {
      readonly __typename?: 'OrganizationMember';
      readonly id: string;
    } | null;
    readonly spaces: ReadonlyArray<{
      readonly __typename?: 'OrganizationSpace';
      readonly id: string;
      readonly externalId: string;
      readonly name: string;
    }>;
    readonly userErrors: ReadonlyArray<{
      readonly __typename?: 'OrganizationMemberSpacesUpdateError';
      readonly code: OrganizationMemberSpacesUpdateErrorCode;
      readonly message: string;
      readonly path?: ReadonlyArray<string> | null;
    }>;
  } | null;
};

export type PendingInvitesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type PendingInvitesQuery = {
  readonly __typename?: 'Query';
  readonly organization?: {
    readonly __typename?: 'Organization';
    readonly id: string;
    readonly memberInvitations?: {
      readonly __typename?: 'OrganizationInvitationConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'OrganizationInvitationEdge';
        readonly node?: {
          readonly __typename?: 'OrganizationInvitation';
          readonly id: string;
          readonly email: any;
          readonly role: OrganizationMemberRoles;
          readonly status: OrganizationInvitationStatus;
        } | null;
      }>;
      readonly pageInfo: {
        readonly __typename?: 'PageInfo';
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
    } | null;
  } | null;
};

export type OrganizationMemberInvitationCancelMutationVariables = Exact<{
  input: OrganizationMemberInvitationCancelInput;
}>;

export type OrganizationMemberInvitationCancelMutation = {
  readonly __typename?: 'Mutation';
  readonly organizationMemberInvitationCancel?: {
    readonly __typename?: 'OrganizationMemberInvitationCancelPayload';
    readonly clientMutationId?: string | null;
    readonly invitation?: {
      readonly __typename?: 'OrganizationInvitation';
      readonly id: string;
      readonly organization: {
        readonly __typename?: 'Organization';
        readonly id: string;
      };
    } | null;
    readonly userErrors: ReadonlyArray<{
      readonly __typename?: 'OrganizationMemberInvitationCancelError';
      readonly code: OrganizationMemberInvitationCancelErrorCode;
      readonly message: string;
    }>;
  } | null;
};

export type SeriesForAddEventToSeriesModalRowFragment = {
  readonly __typename?: 'EventSeries';
  readonly id: string;
  readonly name: string;
  readonly eventsCount: number;
  readonly seriesImage: ReadonlyArray<{
    readonly __typename?: 'Image';
    readonly url?: any | null;
  }>;
};

export type SeriesForAddEventToSeriesModalRowEdgeFragment = {
  readonly __typename?: 'EventSeriesEdge';
  readonly cursor: string;
  readonly node?: {
    readonly __typename?: 'EventSeries';
    readonly id: string;
    readonly name: string;
    readonly eventsCount: number;
    readonly seriesImage: ReadonlyArray<{
      readonly __typename?: 'Image';
      readonly url?: any | null;
    }>;
  } | null;
};

export type SeriesForAddEventToSeriesModalQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  eventSeriesQuery?: InputMaybe<Scalars['String']['input']>;
  eventSeriesSortKey?: InputMaybe<EventSeriesSortKeys>;
  eventSeriesSortReverse?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  pinEvent?: InputMaybe<Scalars['String']['input']>;
  spaceExternalId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type SeriesForAddEventToSeriesModalQuery = {
  readonly __typename?: 'Query';
  readonly organization?: {
    readonly __typename?: 'Organization';
    readonly id: string;
    readonly eventSeries: {
      readonly __typename?: 'EventSeriesConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'EventSeriesEdge';
        readonly cursor: string;
        readonly node?: {
          readonly __typename?: 'EventSeries';
          readonly id: string;
          readonly name: string;
          readonly eventsCount: number;
          readonly seriesImage: ReadonlyArray<{
            readonly __typename?: 'Image';
            readonly url?: any | null;
          }>;
        } | null;
      }>;
      readonly pageInfo: {
        readonly __typename?: 'PageInfo';
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
    };
  } | null;
};

export type EventSeriesRowFragment = {
  readonly __typename?: 'EventSeries';
  readonly id: string;
  readonly name: string;
  readonly registrants: number;
  readonly status: string;
  readonly timeEnd?: any | null;
  readonly timeStart?: any | null;
  readonly eventsCount: number;
  readonly allowMultiEventRegistration: boolean;
  readonly seriesImage: ReadonlyArray<{
    readonly __typename?: 'Image';
    readonly url?: any | null;
  }>;
};

export type EventSeriesRowEdgeFragment = {
  readonly __typename?: 'EventSeriesEdge';
  readonly cursor: string;
  readonly node?: {
    readonly __typename?: 'EventSeries';
    readonly id: string;
    readonly name: string;
    readonly registrants: number;
    readonly status: string;
    readonly timeEnd?: any | null;
    readonly timeStart?: any | null;
    readonly eventsCount: number;
    readonly allowMultiEventRegistration: boolean;
    readonly seriesImage: ReadonlyArray<{
      readonly __typename?: 'Image';
      readonly url?: any | null;
    }>;
  } | null;
};

export type OrganizationEventSeriesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  eventSeriesQuery?: InputMaybe<Scalars['String']['input']>;
  eventSeriesSortKey?: InputMaybe<EventSeriesSortKeys>;
  eventSeriesSortReverse?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  spaceExternalId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type OrganizationEventSeriesQuery = {
  readonly __typename?: 'Query';
  readonly organization?: {
    readonly __typename?: 'Organization';
    readonly id: string;
    readonly features: {
      readonly __typename?: 'OrganizationFeatures';
      readonly eventsLite: boolean;
      readonly eventsPro: boolean;
    };
    readonly eventSeries: {
      readonly __typename?: 'EventSeriesConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'EventSeriesEdge';
        readonly cursor: string;
        readonly node?: {
          readonly __typename?: 'EventSeries';
          readonly id: string;
          readonly name: string;
          readonly registrants: number;
          readonly status: string;
          readonly timeEnd?: any | null;
          readonly timeStart?: any | null;
          readonly eventsCount: number;
          readonly allowMultiEventRegistration: boolean;
          readonly seriesImage: ReadonlyArray<{
            readonly __typename?: 'Image';
            readonly url?: any | null;
          }>;
        } | null;
      }>;
      readonly pageInfo: {
        readonly __typename?: 'PageInfo';
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
    };
  } | null;
};

export type EventSeriesQueryVariables = Exact<{
  eventSeriesId: Scalars['ID']['input'];
  eventsQuery?: InputMaybe<Scalars['String']['input']>;
  eventsSortKey?: InputMaybe<EventSortKeys>;
  eventsSortReverse?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type EventSeriesQuery = {
  readonly __typename?: 'Query';
  readonly eventSeries?: {
    readonly __typename?: 'EventSeries';
    readonly id: string;
    readonly name: string;
    readonly events: {
      readonly __typename?: 'EventConnection';
      readonly edges: ReadonlyArray<{
        readonly __typename?: 'EventEdge';
        readonly cursor: string;
        readonly node?: {
          readonly __typename?: 'Event';
          readonly id: string;
          readonly name: string;
          readonly slug: string;
          readonly registrationsCount?: number | null;
          readonly status?: EventStatus | null;
          readonly description?: string | null;
          readonly timeStart: any;
          readonly timeEnd: any;
          readonly deletable?: EventDeletableStatus | null;
          readonly expired: boolean;
          readonly isLite: boolean;
          readonly venueType: string;
          readonly eventSeriesCount?: number | null;
          readonly eventSeriesNames: ReadonlyArray<string>;
          readonly image: {
            readonly __typename?: 'Image';
            readonly url?: any | null;
          };
          readonly eventSeries: {
            readonly __typename?: 'EventSeriesConnection';
            readonly edges: ReadonlyArray<{
              readonly __typename?: 'EventSeriesEdge';
              readonly node?: {
                readonly __typename?: 'EventSeries';
                readonly id: string;
                readonly name: string;
                readonly eventsCount: number;
              } | null;
            }>;
          };
        } | null;
      }>;
      readonly pageInfo: {
        readonly __typename?: 'PageInfo';
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
    };
  } | null;
};

export type DeleteEventSeriesMutationVariables = Exact<{
  input: EventSeriesDeleteInput;
}>;

export type DeleteEventSeriesMutation = {
  readonly __typename?: 'Mutation';
  readonly eventSeriesDelete?: {
    readonly __typename?: 'EventSeriesDeletePayload';
    readonly clientMutationId?: string | null;
    readonly deletedId?: string | null;
    readonly errors?: ReadonlyArray<string> | null;
  } | null;
};

export type UpdateEventSeriesMutationVariables = Exact<{
  input: EventSeriesUpdateInput;
}>;

export type UpdateEventSeriesMutation = {
  readonly __typename?: 'Mutation';
  readonly eventSeriesUpdate?: {
    readonly __typename?: 'EventSeriesUpdatePayload';
    readonly clientMutationId?: string | null;
    readonly errors?: ReadonlyArray<string> | null;
    readonly eventSeries?: {
      readonly __typename?: 'EventSeries';
      readonly id: string;
      readonly name: string;
      readonly status: string;
      readonly allowMultiEventRegistration: boolean;
    } | null;
  } | null;
};

export type CreateSeriesMutationVariables = Exact<{
  input: EventSeriesCreateInput;
}>;

export type CreateSeriesMutation = {
  readonly __typename?: 'Mutation';
  readonly eventSeriesCreate?: {
    readonly __typename?: 'EventSeriesCreatePayload';
    readonly eventSeries?: {
      readonly __typename?: 'EventSeries';
      readonly name: string;
      readonly id: string;
      readonly status: string;
    } | null;
  } | null;
};

export type AddEventToSeriesMutationVariables = Exact<{
  input: EventSeriesAddEventInput;
}>;

export type AddEventToSeriesMutation = {
  readonly __typename?: 'Mutation';
  readonly eventSeriesAddEvent?: {
    readonly __typename?: 'EventSeriesAddEventPayload';
    readonly eventSeries?: {
      readonly __typename?: 'EventSeries';
      readonly id: string;
      readonly name: string;
      readonly registrants: number;
      readonly status: string;
      readonly timeEnd?: any | null;
      readonly timeStart?: any | null;
      readonly eventsCount: number;
      readonly allowMultiEventRegistration: boolean;
      readonly seriesImage: ReadonlyArray<{
        readonly __typename?: 'Image';
        readonly url?: any | null;
      }>;
    } | null;
  } | null;
};

export type DeleteEventFromSeriesMutationVariables = Exact<{
  input: EventSeriesRemoveEventInput;
}>;

export type DeleteEventFromSeriesMutation = {
  readonly __typename?: 'Mutation';
  readonly eventSeriesRemoveEvent?: {
    readonly __typename?: 'EventSeriesRemoveEventPayload';
    readonly eventSeries?: {
      readonly __typename?: 'EventSeries';
      readonly id: string;
      readonly name: string;
      readonly registrants: number;
      readonly status: string;
      readonly timeEnd?: any | null;
      readonly timeStart?: any | null;
      readonly eventsCount: number;
      readonly allowMultiEventRegistration: boolean;
      readonly seriesImage: ReadonlyArray<{
        readonly __typename?: 'Image';
        readonly url?: any | null;
      }>;
    } | null;
  } | null;
};

export type UpdateEventFromSeriesMutationVariables = Exact<{
  input: EventSeriesUpdateEventFromAllSeriesInput;
}>;

export type UpdateEventFromSeriesMutation = {
  readonly __typename?: 'Mutation';
  readonly eventSeriesUpdateEventFromAllSeries?: {
    readonly __typename?: 'EventSeriesUpdateEventFromAllSeriesPayload';
    readonly event?: {
      readonly __typename?: 'Event';
      readonly id: string;
      readonly name: string;
      readonly slug: string;
      readonly registrationsCount?: number | null;
      readonly status?: EventStatus | null;
      readonly description?: string | null;
      readonly timeStart: any;
      readonly timeEnd: any;
      readonly deletable?: EventDeletableStatus | null;
      readonly expired: boolean;
      readonly isLite: boolean;
      readonly venueType: string;
      readonly eventSeriesCount?: number | null;
      readonly eventSeriesNames: ReadonlyArray<string>;
      readonly eventSeries: {
        readonly __typename?: 'EventSeriesConnection';
        readonly edges: ReadonlyArray<{
          readonly __typename?: 'EventSeriesEdge';
          readonly node?: {
            readonly __typename?: 'EventSeries';
            readonly id: string;
            readonly registrants: number;
            readonly eventsCount: number;
            readonly name: string;
            readonly seriesImage: ReadonlyArray<{
              readonly __typename?: 'Image';
              readonly url?: any | null;
            }>;
          } | null;
        }>;
      };
      readonly image: {
        readonly __typename?: 'Image';
        readonly url?: any | null;
      };
    } | null;
  } | null;
};

export type DeleteEventFromAllSeriesMutationVariables = Exact<{
  input: EventSeriesRemoveEventFromAllSeriesInput;
}>;

export type DeleteEventFromAllSeriesMutation = {
  readonly __typename?: 'Mutation';
  readonly eventSeriesRemoveEventFromAllSeries?: {
    readonly __typename?: 'EventSeriesRemoveEventFromAllSeriesPayload';
    readonly clientMutationId?: string | null;
    readonly event?: {
      readonly __typename?: 'Event';
      readonly id: string;
      readonly name: string;
      readonly slug: string;
      readonly registrationsCount?: number | null;
      readonly status?: EventStatus | null;
      readonly description?: string | null;
      readonly timeStart: any;
      readonly timeEnd: any;
      readonly deletable?: EventDeletableStatus | null;
      readonly expired: boolean;
      readonly isLite: boolean;
      readonly venueType: string;
      readonly eventSeriesCount?: number | null;
      readonly eventSeriesNames: ReadonlyArray<string>;
      readonly image: {
        readonly __typename?: 'Image';
        readonly url?: any | null;
      };
      readonly eventSeries: {
        readonly __typename?: 'EventSeriesConnection';
        readonly edges: ReadonlyArray<{
          readonly __typename?: 'EventSeriesEdge';
          readonly node?: {
            readonly __typename?: 'EventSeries';
            readonly id: string;
            readonly name: string;
            readonly eventsCount: number;
          } | null;
        }>;
      };
    } | null;
  } | null;
};

export const EventCardFragmentDoc = /*#__PURE__*/ gql`
  fragment EventCard on Event {
    id
    name
    timeStart
    timeEnd
    slug
    registrationPageUrl
    host {
      name
    }
    image {
      small: url(imgixParams: { fit: "crop", width: 317, maxH: 125 })
    }
    priceRange {
      minTicketPrice {
        amount
        currencyCode
      }
      maxTicketPrice {
        amount
        currencyCode
      }
    }
  }
`;
export const UserEventEdgeFragmentDoc = /*#__PURE__*/ gql`
  fragment UserEventEdge on UserEventEdge {
    cursor
    node {
      ...EventCard
    }
  }
  ${EventCardFragmentDoc}
`;
export const UserUpdateFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment UserUpdateFields on UserUpdatePayload {
    me {
      id
      firstName
      lastName
      email
      headline
      bio
      linkedinUrl
      twitterUrl
      websiteUrl
      image {
        url
        small: url(imgixParams: { fit: "crop", width: 40, height: 40 })
        large: url(imgixParams: { fit: "crop", width: 80, height: 80 })
      }
      deleteConfirmationPhrase
      userLoggedInViaSso
    }
    userErrors {
      message
      path
      code
    }
  }
`;
export const PublishToEventItemFragmentDoc = /*#__PURE__*/ gql`
  fragment PublishToEventItem on Event {
    id
    slug
    name
    createdAt
    status
    expired
    isLite
    venueType
    timeStart
    timeEnd
    timeZone
    image {
      url(imgixParams: { width: 112, height: 64, fit: crop })
    }
  }
`;
export const SeriesRowFragmentDoc = /*#__PURE__*/ gql`
  fragment SeriesRow on EventSeries {
    id
    name
    eventsCount
  }
`;
export const SeriesRowEdgeFragmentDoc = /*#__PURE__*/ gql`
  fragment SeriesRowEdge on EventSeriesEdge {
    cursor
    node {
      ...SeriesRow
    }
  }
  ${SeriesRowFragmentDoc}
`;
export const EventRowFragmentDoc = /*#__PURE__*/ gql`
  fragment EventRow on Event {
    id
    name
    slug
    registrationsCount
    status
    description
    timeStart
    timeEnd
    deletable
    image {
      url(imgixParams: { width: 73, height: 42, fit: crop })
    }
    expired
    isLite
    venueType
    eventSeriesCount
    eventSeriesNames
    eventSeries {
      edges {
        node {
          id
          name
          eventsCount
        }
      }
    }
  }
`;
export const EventRowEdgeFragmentDoc = /*#__PURE__*/ gql`
  fragment EventRowEdge on EventEdge {
    cursor
    node {
      ...EventRow
    }
  }
  ${EventRowFragmentDoc}
`;
export const SeriesForAddEventToSeriesModalRowFragmentDoc = /*#__PURE__*/ gql`
  fragment SeriesForAddEventToSeriesModalRow on EventSeries {
    id
    name
    eventsCount
    seriesImage {
      url(imgixParams: { width: 96, height: 56, fit: crop })
    }
  }
`;
export const SeriesForAddEventToSeriesModalRowEdgeFragmentDoc = /*#__PURE__*/ gql`
  fragment SeriesForAddEventToSeriesModalRowEdge on EventSeriesEdge {
    cursor
    node {
      ...SeriesForAddEventToSeriesModalRow
    }
  }
  ${SeriesForAddEventToSeriesModalRowFragmentDoc}
`;
export const EventSeriesRowFragmentDoc = /*#__PURE__*/ gql`
  fragment EventSeriesRow on EventSeries {
    id
    name
    registrants
    status
    timeEnd
    timeStart
    eventsCount
    seriesImage {
      url(imgixParams: { width: 96, height: 56, fit: crop })
    }
    allowMultiEventRegistration
  }
`;
export const EventSeriesRowEdgeFragmentDoc = /*#__PURE__*/ gql`
  fragment EventSeriesRowEdge on EventSeriesEdge {
    cursor
    node {
      ...EventSeriesRow
    }
  }
  ${EventSeriesRowFragmentDoc}
`;
export const TeamAccessEventDetailsDocument = /*#__PURE__*/ gql`
  query TeamAccessEventDetails($input: ID!) {
    event(id: $input) {
      id
      name
      timeEnd
      timeStart
    }
  }
`;

export function useTeamAccessEventDetailsQuery(
  options: Omit<
    Urql.UseQueryArgs<TeamAccessEventDetailsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    TeamAccessEventDetailsQuery,
    TeamAccessEventDetailsQueryVariables
  >({ query: TeamAccessEventDetailsDocument, ...options });
}
export const MyProfileDocument = /*#__PURE__*/ gql`
  query MyProfile {
    me {
      id
      firstName
      lastName
      email
      image {
        small: url(imgixParams: { fit: "crop", width: 40, height: 40 })
        large: url(imgixParams: { fit: "crop", width: 80, height: 80 })
      }
      hasAcceptedTerms
    }
  }
`;

export function useMyProfileQuery(
  options?: Omit<Urql.UseQueryArgs<MyProfileQueryVariables>, 'query'>,
) {
  return Urql.useQuery<MyProfileQuery, MyProfileQueryVariables>({
    query: MyProfileDocument,
    ...options,
  });
}
export const OrganizationsDocument = /*#__PURE__*/ gql`
  query Organizations($pageSize: Int, $cursor: String) {
    me {
      id
      organizations(first: $pageSize, after: $cursor) {
        edges {
          node {
            id
            name
            createdAt
            image {
              small: url(imgixParams: { fit: "crop", width: 32, height: 32 })
              medium: url(imgixParams: { fit: "crop", width: 40, height: 40 })
              large: url(imgixParams: { fit: "crop", width: 80, height: 80 })
            }
            paymentPlan {
              planName
              planNameLocale
            }
            features {
              appStore
            }
          }
          cursor
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export function useOrganizationsQuery(
  options?: Omit<Urql.UseQueryArgs<OrganizationsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<OrganizationsQuery, OrganizationsQueryVariables>({
    query: OrganizationsDocument,
    ...options,
  });
}
export const VendorBoothsDocument = /*#__PURE__*/ gql`
  query VendorBooths($pageSize: Int, $cursor: String) {
    me {
      id
      vendorBooths(first: $pageSize, after: $cursor) {
        edges {
          node {
            id
            name
            image {
              url(imgixParams: { fit: "crop", width: 32, height: 32 })
            }
            event {
              name
            }
          }
          cursor
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export function useVendorBoothsQuery(
  options?: Omit<Urql.UseQueryArgs<VendorBoothsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<VendorBoothsQuery, VendorBoothsQueryVariables>({
    query: VendorBoothsDocument,
    ...options,
  });
}
export const UserFirstOrganizationDocument = /*#__PURE__*/ gql`
  query UserFirstOrganization {
    me {
      id
      organizations(first: 1) {
        edges {
          node {
            id
            name
          }
          cursor
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export function useUserFirstOrganizationQuery(
  options?: Omit<
    Urql.UseQueryArgs<UserFirstOrganizationQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    UserFirstOrganizationQuery,
    UserFirstOrganizationQueryVariables
  >({ query: UserFirstOrganizationDocument, ...options });
}
export const OrganizationInvitationDocument = /*#__PURE__*/ gql`
  query OrganizationInvitation {
    me {
      id
      email
      organizationInvitations(query: "status:pending", reverse: true) {
        edges {
          node {
            id
            status
            role
            organization {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export function useOrganizationInvitationQuery(
  options?: Omit<
    Urql.UseQueryArgs<OrganizationInvitationQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    OrganizationInvitationQuery,
    OrganizationInvitationQueryVariables
  >({ query: OrganizationInvitationDocument, ...options });
}
export const OrganizationInvitationAcceptDocument = /*#__PURE__*/ gql`
  mutation OrganizationInvitationAccept(
    $input: OrganizationInvitationAcceptInput!
  ) {
    organizationMemberInvitationAccept(input: $input) {
      userErrors {
        code
      }
      invitation {
        status
        id
        organization {
          name
          id
        }
      }
    }
  }
`;

export function useOrganizationInvitationAcceptMutation() {
  return Urql.useMutation<
    OrganizationInvitationAcceptMutation,
    OrganizationInvitationAcceptMutationVariables
  >(OrganizationInvitationAcceptDocument);
}
export const OrganizationInvitationRejectDocument = /*#__PURE__*/ gql`
  mutation OrganizationInvitationReject(
    $input: OrganizationInvitationRejectInput!
  ) {
    organizationMemberInvitationReject(input: $input) {
      userErrors {
        code
      }
      invitation {
        status
        id
      }
    }
  }
`;

export function useOrganizationInvitationRejectMutation() {
  return Urql.useMutation<
    OrganizationInvitationRejectMutation,
    OrganizationInvitationRejectMutationVariables
  >(OrganizationInvitationRejectDocument);
}
export const UserAcceptTermsDocument = /*#__PURE__*/ gql`
  mutation userAcceptTerms($input: AcceptTermsInput!) {
    userAcceptTerms(input: $input) {
      clientMutationId
      me {
        id
        hasAcceptedTerms
      }
    }
  }
`;

export function useUserAcceptTermsMutation() {
  return Urql.useMutation<
    UserAcceptTermsMutation,
    UserAcceptTermsMutationVariables
  >(UserAcceptTermsDocument);
}
export const CurrentUserDocument = /*#__PURE__*/ gql`
  query CurrentUser {
    me {
      id
      email
    }
  }
`;

export function useCurrentUserQuery(
  options?: Omit<Urql.UseQueryArgs<CurrentUserQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CurrentUserQuery, CurrentUserQueryVariables>({
    query: CurrentUserDocument,
    ...options,
  });
}
export const OrganizationMemberRoleDocument = /*#__PURE__*/ gql`
  query OrganizationMemberRole($organizationId: ID!, $emailQuery: String) {
    organization(id: $organizationId) {
      id
      members(query: $emailQuery) {
        edges {
          role
          node {
            id
          }
        }
      }
      features {
        rolesAndPermissions
      }
    }
  }
`;

export function useOrganizationMemberRoleQuery(
  options: Omit<
    Urql.UseQueryArgs<OrganizationMemberRoleQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    OrganizationMemberRoleQuery,
    OrganizationMemberRoleQueryVariables
  >({ query: OrganizationMemberRoleDocument, ...options });
}
export const PaymentPlanDocument = /*#__PURE__*/ gql`
  query PaymentPlan($organizationId: ID!) {
    organization(id: $organizationId) {
      id
      paymentPlan {
        planName
        planNameLocale
      }
    }
  }
`;

export function usePaymentPlanQuery(
  options: Omit<Urql.UseQueryArgs<PaymentPlanQueryVariables>, 'query'>,
) {
  return Urql.useQuery<PaymentPlanQuery, PaymentPlanQueryVariables>({
    query: PaymentPlanDocument,
    ...options,
  });
}
export const OrganizationExistsDocument = /*#__PURE__*/ gql`
  query OrganizationExists($organizationId: ID!, $spaceExternalIds: [ID!]) {
    organization(id: $organizationId) {
      id
      name
      spaces(first: 1, spaceExternalIds: $spaceExternalIds) {
        edges {
          node {
            id
            externalId
            name
          }
        }
      }
    }
  }
`;

export function useOrganizationExistsQuery(
  options: Omit<Urql.UseQueryArgs<OrganizationExistsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    OrganizationExistsQuery,
    OrganizationExistsQueryVariables
  >({ query: OrganizationExistsDocument, ...options });
}
export const EventExistsDocument = /*#__PURE__*/ gql`
  query EventExists($eventSlug: String!) {
    eventBySlug(slug: $eventSlug) {
      id
    }
  }
`;

export function useEventExistsQuery(
  options: Omit<Urql.UseQueryArgs<EventExistsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<EventExistsQuery, EventExistsQueryVariables>({
    query: EventExistsDocument,
    ...options,
  });
}
export const UpcomingEventsDocument = /*#__PURE__*/ gql`
  query UpcomingEvents(
    $query: String
    $after: String
    $first: Int
    $sortKey: EventSortKeys
  ) {
    me {
      id
      registeredEvents(
        query: $query
        sortKey: $sortKey
        after: $after
        first: $first
      ) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...EventCard
          }
        }
      }
    }
  }
  ${EventCardFragmentDoc}
`;

export function useUpcomingEventsQuery(
  options?: Omit<Urql.UseQueryArgs<UpcomingEventsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<UpcomingEventsQuery, UpcomingEventsQueryVariables>({
    query: UpcomingEventsDocument,
    ...options,
  });
}
export const PastEventsDocument = /*#__PURE__*/ gql`
  query PastEvents(
    $query: String
    $after: String
    $first: Int
    $sortKey: EventSortKeys
  ) {
    me {
      id
      registeredEvents(
        query: $query
        sortKey: $sortKey
        reverse: true
        first: $first
        after: $after
      ) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...EventCard
          }
        }
      }
    }
  }
  ${EventCardFragmentDoc}
`;

export function usePastEventsQuery(
  options?: Omit<Urql.UseQueryArgs<PastEventsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<PastEventsQuery, PastEventsQueryVariables>({
    query: PastEventsDocument,
    ...options,
  });
}
export const AttendeeProfileDocument = /*#__PURE__*/ gql`
  query AttendeeProfile {
    me {
      id
      firstName
      lastName
      email
      headline
      bio
      linkedinUrl
      twitterUrl
      websiteUrl
      image {
        url
      }
      deleteConfirmationPhrase
      userLoggedInViaSso
    }
  }
`;

export function useAttendeeProfileQuery(
  options?: Omit<Urql.UseQueryArgs<AttendeeProfileQueryVariables>, 'query'>,
) {
  return Urql.useQuery<AttendeeProfileQuery, AttendeeProfileQueryVariables>({
    query: AttendeeProfileDocument,
    ...options,
  });
}
export const UpdateAttendeeProfileDocument = /*#__PURE__*/ gql`
  mutation UpdateAttendeeProfile($input: UserUpdateInput!) {
    userUpdate(input: $input) {
      ...UserUpdateFields
    }
  }
  ${UserUpdateFieldsFragmentDoc}
`;

export function useUpdateAttendeeProfileMutation() {
  return Urql.useMutation<
    UpdateAttendeeProfileMutation,
    UpdateAttendeeProfileMutationVariables
  >(UpdateAttendeeProfileDocument);
}
export const UpdatePasswordDocument = /*#__PURE__*/ gql`
  mutation UpdatePassword($input: UserChangePasswordInput!) {
    userChangePassword(input: $input) {
      userErrors {
        message
        path
        code
      }
    }
  }
`;

export function useUpdatePasswordMutation() {
  return Urql.useMutation<
    UpdatePasswordMutation,
    UpdatePasswordMutationVariables
  >(UpdatePasswordDocument);
}
export const UserChangeEmailDocument = /*#__PURE__*/ gql`
  mutation UserChangeEmail($input: UserChangeEmailInput!) {
    userChangeEmail(input: $input) {
      userErrors {
        message
        path
        code
      }
    }
  }
`;

export function useUserChangeEmailMutation() {
  return Urql.useMutation<
    UserChangeEmailMutation,
    UserChangeEmailMutationVariables
  >(UserChangeEmailDocument);
}
export const UserChangePasswordDocument = /*#__PURE__*/ gql`
  mutation UserChangePassword($input: UserChangePasswordInput!) {
    userChangePassword(input: $input) {
      userErrors {
        message
        path
        code
      }
    }
  }
`;

export function useUserChangePasswordMutation() {
  return Urql.useMutation<
    UserChangePasswordMutation,
    UserChangePasswordMutationVariables
  >(UserChangePasswordDocument);
}
export const DeleteAccountDocument = /*#__PURE__*/ gql`
  mutation DeleteAccount($confirmationPhrase: String!) {
    userDelete(input: { confirmationPhrase: $confirmationPhrase }) {
      bye
      userErrors {
        message
        path
      }
    }
  }
`;

export function useDeleteAccountMutation() {
  return Urql.useMutation<
    DeleteAccountMutation,
    DeleteAccountMutationVariables
  >(DeleteAccountDocument);
}
export const AccountConnectionsDocument = /*#__PURE__*/ gql`
  query AccountConnections($first: Int, $after: String, $eventId: ID) {
    me {
      id
      connections(first: $first, after: $after, eventId: $eventId) {
        edges {
          cursor
          node {
            id
            firstName
            lastName
            headline
            email
            websiteUrl
            twitterUrl
            linkedinUrl
            image {
              url
            }
            event {
              id
              name
              slug
              timeStart
              timeEnd
            }
          }
        }
        pageInfo {
          endCursor
          startCursor
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
`;

export function useAccountConnectionsQuery(
  options?: Omit<Urql.UseQueryArgs<AccountConnectionsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    AccountConnectionsQuery,
    AccountConnectionsQueryVariables
  >({ query: AccountConnectionsDocument, ...options });
}
export const RegisteredEventsDocument = /*#__PURE__*/ gql`
  query RegisteredEvents($first: Int, $after: String, $query: String) {
    me {
      id
      registeredEvents(first: $first, after: $after, query: $query) {
        edges {
          node {
            id
            name
          }
        }
        pageInfo {
          endCursor
          startCursor
          hasNextPage
        }
      }
    }
  }
`;

export function useRegisteredEventsQuery(
  options?: Omit<Urql.UseQueryArgs<RegisteredEventsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<RegisteredEventsQuery, RegisteredEventsQueryVariables>({
    query: RegisteredEventsDocument,
    ...options,
  });
}
export const DeleteConnectionDocument = /*#__PURE__*/ gql`
  mutation DeleteConnection($input: UserConnectionDeleteInput!) {
    userConnectionDelete(input: $input) {
      deletedRegistrantId
    }
  }
`;

export function useDeleteConnectionMutation() {
  return Urql.useMutation<
    DeleteConnectionMutation,
    DeleteConnectionMutationVariables
  >(DeleteConnectionDocument);
}
export const OrganizationEventsFilterDocument = /*#__PURE__*/ gql`
  query OrganizationEventsFilter(
    $organizationId: ID!
    $first: Int
    $after: String
    $query: String
    $spaceExternalId: ID
  ) {
    organization(id: $organizationId) {
      id
      events(
        first: $first
        after: $after
        query: $query
        spaceExternalId: $spaceExternalId
      ) {
        edges {
          node {
            id
            name
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export function useOrganizationEventsFilterQuery(
  options: Omit<
    Urql.UseQueryArgs<OrganizationEventsFilterQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    OrganizationEventsFilterQuery,
    OrganizationEventsFilterQueryVariables
  >({ query: OrganizationEventsFilterDocument, ...options });
}
export const EventSlugByIdDocument = /*#__PURE__*/ gql`
  query EventSlugById($id: ID!) {
    event(id: $id) {
      slug
    }
  }
`;

export function useEventSlugByIdQuery(
  options: Omit<Urql.UseQueryArgs<EventSlugByIdQueryVariables>, 'query'>,
) {
  return Urql.useQuery<EventSlugByIdQuery, EventSlugByIdQueryVariables>({
    query: EventSlugByIdDocument,
    ...options,
  });
}
export const EventInfoByIdDocument = /*#__PURE__*/ gql`
  query EventInfoById($id: ID!) {
    event(id: $id) {
      name
      slug
      image {
        url
      }
      status
      timeStart
      timeEnd
      expired
    }
  }
`;

export function useEventInfoByIdQuery(
  options: Omit<Urql.UseQueryArgs<EventInfoByIdQueryVariables>, 'query'>,
) {
  return Urql.useQuery<EventInfoByIdQuery, EventInfoByIdQueryVariables>({
    query: EventInfoByIdDocument,
    ...options,
  });
}
export const EventSpeakersDocument = /*#__PURE__*/ gql`
  query EventSpeakers($id: ID!, $first: Int, $after: String, $query: String) {
    event(id: $id) {
      speakers(first: $first, after: $after, query: $query) {
        edges {
          node {
            firstName
            id
            lastName
            image {
              url
            }
            headline
            bio
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export function useEventSpeakersQuery(
  options: Omit<Urql.UseQueryArgs<EventSpeakersQueryVariables>, 'query'>,
) {
  return Urql.useQuery<EventSpeakersQuery, EventSpeakersQueryVariables>({
    query: EventSpeakersDocument,
    ...options,
  });
}
export const OrganizationEventsForPublishDocument = /*#__PURE__*/ gql`
  query OrganizationEventsForPublish(
    $organizationId: ID!
    $first: Int
    $after: String
    $query: String
    $eventsSortKey: EventSortKeys
    $eventsSortReverse: Boolean
    $spaceExternalId: ID
  ) {
    organization(id: $organizationId) {
      id
      events(
        first: $first
        after: $after
        query: $query
        sortKey: $eventsSortKey
        reverse: $eventsSortReverse
        spaceExternalId: $spaceExternalId
      ) {
        edges {
          node {
            ...PublishToEventItem
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
  ${PublishToEventItemFragmentDoc}
`;

export function useOrganizationEventsForPublishQuery(
  options: Omit<
    Urql.UseQueryArgs<OrganizationEventsForPublishQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    OrganizationEventsForPublishQuery,
    OrganizationEventsForPublishQueryVariables
  >({ query: OrganizationEventsForPublishDocument, ...options });
}
export const OrganizationFeaturesDocument = /*#__PURE__*/ gql`
  query OrganizationFeatures($organizationId: ID!) {
    organization(id: $organizationId) {
      id
      features {
        onsiteHybridEvents
        maxEventLengthHours
      }
      paymentPlan {
        planName
      }
    }
  }
`;

export function useOrganizationFeaturesQuery(
  options: Omit<Urql.UseQueryArgs<OrganizationFeaturesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    OrganizationFeaturesQuery,
    OrganizationFeaturesQueryVariables
  >({ query: OrganizationFeaturesDocument, ...options });
}
export const OrganizationSeriesDocument = /*#__PURE__*/ gql`
  query OrganizationSeries(
    $organizationId: ID!
    $eventSeriesQuery: String
    $eventSeriesSortKey: EventSeriesSortKeys
    $first: Int
    $after: String
    $spaceExternalId: ID
  ) {
    organization(id: $organizationId) {
      id
      eventSeries(
        query: $eventSeriesQuery
        sortKey: $eventSeriesSortKey
        first: $first
        after: $after
        spaceExternalId: $spaceExternalId
      ) {
        edges {
          ...SeriesRowEdge
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
  ${SeriesRowEdgeFragmentDoc}
`;

export function useOrganizationSeriesQuery(
  options: Omit<Urql.UseQueryArgs<OrganizationSeriesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    OrganizationSeriesQuery,
    OrganizationSeriesQueryVariables
  >({ query: OrganizationSeriesDocument, ...options });
}
export const SingleSeriesDocument = /*#__PURE__*/ gql`
  query SingleSeries($eventSeriesId: ID!) {
    eventSeries(id: $eventSeriesId) {
      id
      name
      eventsCount
    }
  }
`;

export function useSingleSeriesQuery(
  options: Omit<Urql.UseQueryArgs<SingleSeriesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SingleSeriesQuery, SingleSeriesQueryVariables>({
    query: SingleSeriesDocument,
    ...options,
  });
}
export const OrganizationCreateDocument = /*#__PURE__*/ gql`
  mutation OrganizationCreate($input: OrganizationCreateInput!) {
    organizationCreate(input: $input) {
      clientMutationId
      organization {
        name
        about
        email
        id
      }
      userErrors {
        code
        message
        path
      }
    }
  }
`;

export function useOrganizationCreateMutation() {
  return Urql.useMutation<
    OrganizationCreateMutation,
    OrganizationCreateMutationVariables
  >(OrganizationCreateDocument);
}
export const MyDetailsDocument = /*#__PURE__*/ gql`
  query MyDetails {
    me {
      id
      email
      firstName
      lastName
    }
  }
`;

export function useMyDetailsQuery(
  options?: Omit<Urql.UseQueryArgs<MyDetailsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<MyDetailsQuery, MyDetailsQueryVariables>({
    query: MyDetailsDocument,
    ...options,
  });
}
export const OrganizationDetailsDocument = /*#__PURE__*/ gql`
  query OrganizationDetails($organizationId: ID!) {
    organization(id: $organizationId) {
      id
      name
      about
      email
      facebookUrl
      linkedinUrl
      twitterUrl
      websiteUrl
      createdAt
      features {
        eventsLite
        eventsPro
        onsiteHybridEvents
        appStore
      }
      paymentPlan {
        planName
        planNameLocale
        downgradedToFree
        endsAt
        isAdvanced
      }
      settings {
        disableAiFeatures
      }
      image {
        small: url(imgixParams: { fit: "crop", width: 32, height: 32 })
        medium: url(imgixParams: { fit: "crop", width: 40, height: 40 })
        large: url(imgixParams: { fit: "crop", width: 80, height: 80 })
      }
      standaloneStudios {
        name
        uuid
        event {
          slug
        }
      }
    }
  }
`;

export function useOrganizationDetailsQuery(
  options: Omit<Urql.UseQueryArgs<OrganizationDetailsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    OrganizationDetailsQuery,
    OrganizationDetailsQueryVariables
  >({ query: OrganizationDetailsDocument, ...options });
}
export const UpdateOrgDocument = /*#__PURE__*/ gql`
  mutation UpdateOrg($input: OrganizationUpdateInput!) {
    organizationUpdate(input: $input) {
      organization {
        id
        about
        email
        name
        twitterUrl
        facebookUrl
        linkedinUrl
        websiteUrl
        image {
          url
          small: url(imgixParams: { fit: "crop", width: 40, height: 40 })
          large: url(imgixParams: { fit: "crop", width: 80, height: 80 })
        }
      }
      userErrors {
        message
        path
        code
      }
    }
  }
`;

export function useUpdateOrgMutation() {
  return Urql.useMutation<UpdateOrgMutation, UpdateOrgMutationVariables>(
    UpdateOrgDocument,
  );
}
export const OrganizationByOwnerIdDocument = /*#__PURE__*/ gql`
  query OrganizationByOwnerId($ownerId: ID!, $pageSize: Int, $cursor: String) {
    me {
      id
      organizations(ownerId: $ownerId, first: $pageSize, after: $cursor) {
        edges {
          node {
            id
          }
          cursor
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export function useOrganizationByOwnerIdQuery(
  options: Omit<
    Urql.UseQueryArgs<OrganizationByOwnerIdQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    OrganizationByOwnerIdQuery,
    OrganizationByOwnerIdQueryVariables
  >({ query: OrganizationByOwnerIdDocument, ...options });
}
export const OrganizationSpacesDocument = /*#__PURE__*/ gql`
  query OrganizationSpaces(
    $organizationId: ID!
    $first: Int
    $after: String
    $query: String
  ) {
    organization(id: $organizationId) {
      id
      spaces(first: $first, after: $after, query: $query) {
        edges {
          node {
            id
            externalId
            name
            membersCount
          }
          cursor
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export function useOrganizationSpacesQuery(
  options: Omit<Urql.UseQueryArgs<OrganizationSpacesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    OrganizationSpacesQuery,
    OrganizationSpacesQueryVariables
  >({ query: OrganizationSpacesDocument, ...options });
}
export const OrganizationSpaceExistsDocument = /*#__PURE__*/ gql`
  query OrganizationSpaceExists($organizationId: ID!, $spaceExternalId: ID!) {
    organization(id: $organizationId) {
      id
      spaces(first: 1, spaceExternalIds: [$spaceExternalId]) {
        edges {
          node {
            id
          }
        }
      }
    }
  }
`;

export function useOrganizationSpaceExistsQuery(
  options: Omit<
    Urql.UseQueryArgs<OrganizationSpaceExistsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    OrganizationSpaceExistsQuery,
    OrganizationSpaceExistsQueryVariables
  >({ query: OrganizationSpaceExistsDocument, ...options });
}
export const OrganizationEventsDocument = /*#__PURE__*/ gql`
  query OrganizationEvents(
    $organizationId: ID!
    $eventsQuery: String
    $eventsSortKey: EventSortKeys
    $eventsSortReverse: Boolean
    $first: Int
    $after: String
    $pinEventSeries: String
    $spaceExternalId: ID
  ) {
    organization(id: $organizationId) {
      id
      features {
        eventsLite
        eventsPro
      }
      events(
        query: $eventsQuery
        sortKey: $eventsSortKey
        reverse: $eventsSortReverse
        first: $first
        after: $after
        pinEventSeries: $pinEventSeries
        spaceExternalId: $spaceExternalId
      ) {
        edges {
          ...EventRowEdge
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
  ${EventRowEdgeFragmentDoc}
`;

export function useOrganizationEventsQuery(
  options: Omit<Urql.UseQueryArgs<OrganizationEventsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    OrganizationEventsQuery,
    OrganizationEventsQueryVariables
  >({ query: OrganizationEventsDocument, ...options });
}
export const EventDuplicatableDocument = /*#__PURE__*/ gql`
  query EventDuplicatable($eventId: ID!) {
    event(id: $eventId) {
      id
      canBeDuplicated
    }
  }
`;

export function useEventDuplicatableQuery(
  options: Omit<Urql.UseQueryArgs<EventDuplicatableQueryVariables>, 'query'>,
) {
  return Urql.useQuery<EventDuplicatableQuery, EventDuplicatableQueryVariables>(
    { query: EventDuplicatableDocument, ...options },
  );
}
export const DeleteEventDocument = /*#__PURE__*/ gql`
  mutation DeleteEvent($input: EventDeleteInput!) {
    eventDelete(input: $input) {
      clientMutationId
      deletedId
      userErrors {
        code
        message
        path
      }
    }
  }
`;

export function useDeleteEventMutation() {
  return Urql.useMutation<DeleteEventMutation, DeleteEventMutationVariables>(
    DeleteEventDocument,
  );
}
export const OrganizationLatestEventsDocument = /*#__PURE__*/ gql`
  query OrganizationLatestEvents(
    $organizationId: ID!
    $first: Int
    $query: String!
    $spaceExternalId: ID
  ) {
    organization(id: $organizationId) {
      id
      events(
        query: $query
        sortKey: TIME_END
        reverse: true
        first: $first
        spaceExternalId: $spaceExternalId
      ) {
        edges {
          node {
            id
          }
        }
      }
    }
  }
`;

export function useOrganizationLatestEventsQuery(
  options: Omit<
    Urql.UseQueryArgs<OrganizationLatestEventsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    OrganizationLatestEventsQuery,
    OrganizationLatestEventsQueryVariables
  >({ query: OrganizationLatestEventsDocument, ...options });
}
export const EventMembersWithAccessDocument = /*#__PURE__*/ gql`
  query EventMembersWithAccess(
    $eventId: ID!
    $searchQuery: String
    $after: String
    $first: Int
    $reverse: Boolean
    $sortKey: OrganizationMemberSortKeys
  ) {
    event(id: $eventId) {
      id
      organizationMembersWithAccess(
        query: $searchQuery
        after: $after
        first: $first
        reverse: $reverse
        sortKey: $sortKey
      ) {
        edges {
          role
          node {
            id
            firstName
            lastName
            email
            image {
              url
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export function useEventMembersWithAccessQuery(
  options: Omit<
    Urql.UseQueryArgs<EventMembersWithAccessQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    EventMembersWithAccessQuery,
    EventMembersWithAccessQueryVariables
  >({ query: EventMembersWithAccessDocument, ...options });
}
export const EventMembersWithoutAccessDocument = /*#__PURE__*/ gql`
  query EventMembersWithoutAccess(
    $eventId: ID!
    $searchQuery: String
    $after: String
    $first: Int
    $reverse: Boolean
    $sortKey: OrganizationMemberSortKeys
  ) {
    event(id: $eventId) {
      id
      organizationMembersWithoutAccess(
        query: $searchQuery
        after: $after
        first: $first
        reverse: $reverse
        sortKey: $sortKey
      ) {
        edges {
          role
          node {
            id
            firstName
            lastName
            email
            image {
              url
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export function useEventMembersWithoutAccessQuery(
  options: Omit<
    Urql.UseQueryArgs<EventMembersWithoutAccessQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    EventMembersWithoutAccessQuery,
    EventMembersWithoutAccessQueryVariables
  >({ query: EventMembersWithoutAccessDocument, ...options });
}
export const OrganizationMemberEventAccessUpdateDocument = /*#__PURE__*/ gql`
  mutation OrganizationMemberEventAccessUpdate(
    $input: OrganizationMemberEventAccessUpdateInput!
  ) {
    organizationMemberEventAccessUpdate(input: $input) {
      eventAccess
      organizationMember {
        id
        email
      }
      userErrors {
        message
        path
        code
      }
    }
  }
`;

export function useOrganizationMemberEventAccessUpdateMutation() {
  return Urql.useMutation<
    OrganizationMemberEventAccessUpdateMutation,
    OrganizationMemberEventAccessUpdateMutationVariables
  >(OrganizationMemberEventAccessUpdateDocument);
}
export const OrganizationMemberEventAccessBulkUpdateAllDocument = /*#__PURE__*/ gql`
  mutation OrganizationMemberEventAccessBulkUpdateAll(
    $input: OrganizationMemberEventAccessBulkUpdateAllInput!
  ) {
    organizationMemberEventAccessBulkUpdateAll(input: $input) {
      eventAccess
    }
  }
`;

export function useOrganizationMemberEventAccessBulkUpdateAllMutation() {
  return Urql.useMutation<
    OrganizationMemberEventAccessBulkUpdateAllMutation,
    OrganizationMemberEventAccessBulkUpdateAllMutationVariables
  >(OrganizationMemberEventAccessBulkUpdateAllDocument);
}
export const OrganizationBillingDocument = /*#__PURE__*/ gql`
  query OrganizationBilling($organizationId: ID!) {
    organization(id: $organizationId) {
      id
      name
      paymentPlan {
        planName
        planNameLocale
        startsAt
        endsAt
        hasActiveSubscription
        hasPaymentProviderCustomer
        hasEventsLite
        hasEventsPro
        paidTicketsAllowed
        includedSeats
        usedSeats
        isStripeMigrationEnabled
        paymentProviderConnectedAccountClientId
        registrationsUsage {
          __typename
          ... on AppsumoRegistrationsUsage {
            usedFree
            usedPaid
            includedFree
            includedPaid
          }
          ... on AdvancedRegistrationsUsage {
            used
            included
          }
          ... on SelfServeRegistrationsUsage {
            included
            available
            accrued
            used
          }
          ... on FreeRegistrationsUsage {
            includedPerEvent
          }
          ... on BaseRegistrationsUsage {
            name
          }
        }
        seats {
          __typename
          ... on PaymentPlanSeats {
            included
            usedIncluded
            additional
            additionalSeatPrice {
              ... on Money {
                amount
                currencyCode
              }
            }
            usedAdditional
            total
            usedTotal
          }
        }
        attendeesStats {
          __typename
          ... on EssentialsAttendeesStats {
            eventAttendeesAllowance
            eventCountAboveAllowance
            eventCountBelowAllowance
          }
          ... on BaseAttendeesStats {
            name
          }
        }
      }
    }
  }
`;

export function useOrganizationBillingQuery(
  options: Omit<Urql.UseQueryArgs<OrganizationBillingQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    OrganizationBillingQuery,
    OrganizationBillingQueryVariables
  >({ query: OrganizationBillingDocument, ...options });
}
export const StripeUnlinkAccountDocument = /*#__PURE__*/ gql`
  mutation StripeUnlinkAccount($organizationId: ID!) {
    stripeUnlinkAccount(input: { organizationId: $organizationId }) {
      unlinkedOrganizationId
    }
  }
`;

export function useStripeUnlinkAccountMutation() {
  return Urql.useMutation<
    StripeUnlinkAccountMutation,
    StripeUnlinkAccountMutationVariables
  >(StripeUnlinkAccountDocument);
}
export const OrganizationManageableSpacesDocument = /*#__PURE__*/ gql`
  query OrganizationManageableSpaces(
    $organizationId: ID!
    $first: Int
    $after: String
    $query: String
  ) {
    organization(id: $organizationId) {
      id
      manageableSpaces(first: $first, after: $after, query: $query) {
        edges {
          node {
            id
            externalId
            name
            membersCount
          }
          cursor
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export function useOrganizationManageableSpacesQuery(
  options: Omit<
    Urql.UseQueryArgs<OrganizationManageableSpacesQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    OrganizationManageableSpacesQuery,
    OrganizationManageableSpacesQueryVariables
  >({ query: OrganizationManageableSpacesDocument, ...options });
}
export const OrganizationSpaceCreateDocument = /*#__PURE__*/ gql`
  mutation OrganizationSpaceCreate($input: OrganizationSpaceCreateInput!) {
    organizationSpaceCreate(input: $input) {
      organizationSpace {
        id
        externalId
        name
        membersCount
      }
      userErrors {
        code
        message
        path
      }
    }
  }
`;

export function useOrganizationSpaceCreateMutation() {
  return Urql.useMutation<
    OrganizationSpaceCreateMutation,
    OrganizationSpaceCreateMutationVariables
  >(OrganizationSpaceCreateDocument);
}
export const RenameOrganizationSpaceDocument = /*#__PURE__*/ gql`
  mutation RenameOrganizationSpace($input: OrganizationSpaceUpdateInput!) {
    organizationSpaceUpdate(input: $input) {
      organizationSpace {
        id
        externalId
        name
        membersCount
      }
      userErrors {
        code
        message
        path
      }
    }
  }
`;

export function useRenameOrganizationSpaceMutation() {
  return Urql.useMutation<
    RenameOrganizationSpaceMutation,
    RenameOrganizationSpaceMutationVariables
  >(RenameOrganizationSpaceDocument);
}
export const InviteMemberDocument = /*#__PURE__*/ gql`
  mutation InviteMember($input: OrganizationMemberInvitationSendInput!) {
    organizationMemberInvitationSend(input: $input) {
      invitation {
        id
        email
      }
      userErrors {
        message
        path
        code
      }
    }
  }
`;

export function useInviteMemberMutation() {
  return Urql.useMutation<InviteMemberMutation, InviteMemberMutationVariables>(
    InviteMemberDocument,
  );
}
export const OrgTeamDetailsWithPaymentPlanDocument = /*#__PURE__*/ gql`
  query OrgTeamDetailsWithPaymentPlan($organizationId: ID!) {
    organization(id: $organizationId) {
      id
      ownerId
      hasReachedOrganiserLimit
      pendingMemberInvitationsCount
      paymentPlan {
        planName
        isSelfserve
        includedRegistrations
        pricing {
          interval
        }
        seats {
          total
          usedTotal
          additional
          usedAdditional
          included
          usedIncluded
          additionalSeatPrice {
            amount
            currencyCode
          }
        }
      }
      features {
        rolesAndPermissions
      }
    }
  }
`;

export function useOrgTeamDetailsWithPaymentPlanQuery(
  options: Omit<
    Urql.UseQueryArgs<OrgTeamDetailsWithPaymentPlanQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    OrgTeamDetailsWithPaymentPlanQuery,
    OrgTeamDetailsWithPaymentPlanQueryVariables
  >({ query: OrgTeamDetailsWithPaymentPlanDocument, ...options });
}
export const ActiveMembersDocument = /*#__PURE__*/ gql`
  query ActiveMembers(
    $organizationId: ID!
    $searchQuery: String
    $first: Int
    $after: String
    $includeSpaces: Boolean!
  ) {
    organization(id: $organizationId) {
      id
      ownerId
      members(
        query: $searchQuery
        sortKey: LAST_NAME
        first: $first
        after: $after
      ) {
        edges {
          role
          spaces @include(if: $includeSpaces) {
            id
            externalId
            name
          }
          node {
            id
            firstName
            lastName
            email
            image {
              url: url(imgixParams: { fit: "crop", width: 32, maxH: 32 })
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
      paymentPlan {
        seats {
          usedAdditional
        }
      }
    }
  }
`;

export function useActiveMembersQuery(
  options: Omit<Urql.UseQueryArgs<ActiveMembersQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ActiveMembersQuery, ActiveMembersQueryVariables>({
    query: ActiveMembersDocument,
    ...options,
  });
}
export const OrganizationMemberRoleUpdateDocument = /*#__PURE__*/ gql`
  mutation OrganizationMemberRoleUpdate(
    $input: OrganizationMemberRoleUpdateInput!
  ) {
    organizationMemberRoleUpdate(input: $input) {
      clientMutationId
      organizationMember {
        id
      }
      role
      userErrors {
        code
        message
        path
      }
    }
  }
`;

export function useOrganizationMemberRoleUpdateMutation() {
  return Urql.useMutation<
    OrganizationMemberRoleUpdateMutation,
    OrganizationMemberRoleUpdateMutationVariables
  >(OrganizationMemberRoleUpdateDocument);
}
export const OrganizationMemberRemoveDocument = /*#__PURE__*/ gql`
  mutation OrganizationMemberRemove($input: OrganizationMemberRemoveInput!) {
    organizationMemberRemove(input: $input) {
      removedMemberId
      userErrors {
        code
        message
        path
      }
    }
  }
`;

export function useOrganizationMemberRemoveMutation() {
  return Urql.useMutation<
    OrganizationMemberRemoveMutation,
    OrganizationMemberRemoveMutationVariables
  >(OrganizationMemberRemoveDocument);
}
export const OrganizationMemberSpacesUpdateDocument = /*#__PURE__*/ gql`
  mutation OrganizationMemberSpacesUpdate(
    $input: OrganizationMemberSpacesUpdateInput!
  ) {
    organizationMemberSpacesUpdate(input: $input) {
      clientMutationId
      organizationMember {
        id
      }
      spaces {
        id
        externalId
        name
      }
      userErrors {
        code
        message
        path
      }
    }
  }
`;

export function useOrganizationMemberSpacesUpdateMutation() {
  return Urql.useMutation<
    OrganizationMemberSpacesUpdateMutation,
    OrganizationMemberSpacesUpdateMutationVariables
  >(OrganizationMemberSpacesUpdateDocument);
}
export const PendingInvitesDocument = /*#__PURE__*/ gql`
  query PendingInvites(
    $organizationId: ID!
    $searchQuery: String
    $first: Int
    $after: String
  ) {
    organization(id: $organizationId) {
      id
      memberInvitations(query: $searchQuery, first: $first, after: $after) {
        edges {
          node {
            id
            email
            role
            status
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export function usePendingInvitesQuery(
  options: Omit<Urql.UseQueryArgs<PendingInvitesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<PendingInvitesQuery, PendingInvitesQueryVariables>({
    query: PendingInvitesDocument,
    ...options,
  });
}
export const OrganizationMemberInvitationCancelDocument = /*#__PURE__*/ gql`
  mutation OrganizationMemberInvitationCancel(
    $input: OrganizationMemberInvitationCancelInput!
  ) {
    organizationMemberInvitationCancel(input: $input) {
      clientMutationId
      invitation {
        id
        organization {
          id
        }
      }
      userErrors {
        code
        message
      }
    }
  }
`;

export function useOrganizationMemberInvitationCancelMutation() {
  return Urql.useMutation<
    OrganizationMemberInvitationCancelMutation,
    OrganizationMemberInvitationCancelMutationVariables
  >(OrganizationMemberInvitationCancelDocument);
}
export const SeriesForAddEventToSeriesModalDocument = /*#__PURE__*/ gql`
  query SeriesForAddEventToSeriesModal(
    $organizationId: ID!
    $eventSeriesQuery: String
    $eventSeriesSortKey: EventSeriesSortKeys
    $eventSeriesSortReverse: Boolean
    $first: Int
    $after: String
    $pinEvent: String
    $spaceExternalId: ID
  ) {
    organization(id: $organizationId) {
      id
      eventSeries(
        query: $eventSeriesQuery
        sortKey: $eventSeriesSortKey
        reverse: $eventSeriesSortReverse
        first: $first
        after: $after
        pinEvent: $pinEvent
        spaceExternalId: $spaceExternalId
      ) {
        edges {
          ...SeriesForAddEventToSeriesModalRowEdge
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
  ${SeriesForAddEventToSeriesModalRowEdgeFragmentDoc}
`;

export function useSeriesForAddEventToSeriesModalQuery(
  options: Omit<
    Urql.UseQueryArgs<SeriesForAddEventToSeriesModalQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    SeriesForAddEventToSeriesModalQuery,
    SeriesForAddEventToSeriesModalQueryVariables
  >({ query: SeriesForAddEventToSeriesModalDocument, ...options });
}
export const OrganizationEventSeriesDocument = /*#__PURE__*/ gql`
  query OrganizationEventSeries(
    $organizationId: ID!
    $eventSeriesQuery: String
    $eventSeriesSortKey: EventSeriesSortKeys
    $eventSeriesSortReverse: Boolean
    $first: Int
    $after: String
    $spaceExternalId: ID
  ) {
    organization(id: $organizationId) {
      id
      features {
        eventsLite
        eventsPro
      }
      eventSeries(
        query: $eventSeriesQuery
        sortKey: $eventSeriesSortKey
        reverse: $eventSeriesSortReverse
        first: $first
        after: $after
        spaceExternalId: $spaceExternalId
      ) {
        edges {
          ...EventSeriesRowEdge
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
  ${EventSeriesRowEdgeFragmentDoc}
`;

export function useOrganizationEventSeriesQuery(
  options: Omit<
    Urql.UseQueryArgs<OrganizationEventSeriesQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    OrganizationEventSeriesQuery,
    OrganizationEventSeriesQueryVariables
  >({ query: OrganizationEventSeriesDocument, ...options });
}
export const EventSeriesDocument = /*#__PURE__*/ gql`
  query EventSeries(
    $eventSeriesId: ID!
    $eventsQuery: String
    $eventsSortKey: EventSortKeys
    $eventsSortReverse: Boolean
    $first: Int
    $after: String
  ) {
    eventSeries(id: $eventSeriesId) {
      id
      name
      events(
        query: $eventsQuery
        sortKey: $eventsSortKey
        reverse: $eventsSortReverse
        first: $first
        after: $after
      ) {
        edges {
          ...EventRowEdge
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
  ${EventRowEdgeFragmentDoc}
`;

export function useEventSeriesQuery(
  options: Omit<Urql.UseQueryArgs<EventSeriesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<EventSeriesQuery, EventSeriesQueryVariables>({
    query: EventSeriesDocument,
    ...options,
  });
}
export const DeleteEventSeriesDocument = /*#__PURE__*/ gql`
  mutation DeleteEventSeries($input: EventSeriesDeleteInput!) {
    eventSeriesDelete(input: $input) {
      clientMutationId
      deletedId
      errors
    }
  }
`;

export function useDeleteEventSeriesMutation() {
  return Urql.useMutation<
    DeleteEventSeriesMutation,
    DeleteEventSeriesMutationVariables
  >(DeleteEventSeriesDocument);
}
export const UpdateEventSeriesDocument = /*#__PURE__*/ gql`
  mutation UpdateEventSeries($input: EventSeriesUpdateInput!) {
    eventSeriesUpdate(input: $input) {
      clientMutationId
      eventSeries {
        id
        name
        status
        allowMultiEventRegistration
      }
      errors
    }
  }
`;

export function useUpdateEventSeriesMutation() {
  return Urql.useMutation<
    UpdateEventSeriesMutation,
    UpdateEventSeriesMutationVariables
  >(UpdateEventSeriesDocument);
}
export const CreateSeriesDocument = /*#__PURE__*/ gql`
  mutation CreateSeries($input: EventSeriesCreateInput!) {
    eventSeriesCreate(input: $input) {
      eventSeries {
        name
        id
        status
      }
    }
  }
`;

export function useCreateSeriesMutation() {
  return Urql.useMutation<CreateSeriesMutation, CreateSeriesMutationVariables>(
    CreateSeriesDocument,
  );
}
export const AddEventToSeriesDocument = /*#__PURE__*/ gql`
  mutation AddEventToSeries($input: EventSeriesAddEventInput!) {
    eventSeriesAddEvent(input: $input) {
      eventSeries {
        ...EventSeriesRow
      }
    }
  }
  ${EventSeriesRowFragmentDoc}
`;

export function useAddEventToSeriesMutation() {
  return Urql.useMutation<
    AddEventToSeriesMutation,
    AddEventToSeriesMutationVariables
  >(AddEventToSeriesDocument);
}
export const DeleteEventFromSeriesDocument = /*#__PURE__*/ gql`
  mutation DeleteEventFromSeries($input: EventSeriesRemoveEventInput!) {
    eventSeriesRemoveEvent(input: $input) {
      eventSeries {
        ...EventSeriesRow
      }
    }
  }
  ${EventSeriesRowFragmentDoc}
`;

export function useDeleteEventFromSeriesMutation() {
  return Urql.useMutation<
    DeleteEventFromSeriesMutation,
    DeleteEventFromSeriesMutationVariables
  >(DeleteEventFromSeriesDocument);
}
export const UpdateEventFromSeriesDocument = /*#__PURE__*/ gql`
  mutation UpdateEventFromSeries(
    $input: EventSeriesUpdateEventFromAllSeriesInput!
  ) {
    eventSeriesUpdateEventFromAllSeries(input: $input) {
      event {
        ...EventRow
        eventSeries {
          edges {
            node {
              id
              registrants
              eventsCount
              seriesImage {
                url(imgixParams: { width: 96, height: 56, fit: crop })
              }
            }
          }
        }
      }
    }
  }
  ${EventRowFragmentDoc}
`;

export function useUpdateEventFromSeriesMutation() {
  return Urql.useMutation<
    UpdateEventFromSeriesMutation,
    UpdateEventFromSeriesMutationVariables
  >(UpdateEventFromSeriesDocument);
}
export const DeleteEventFromAllSeriesDocument = /*#__PURE__*/ gql`
  mutation DeleteEventFromAllSeries(
    $input: EventSeriesRemoveEventFromAllSeriesInput!
  ) {
    eventSeriesRemoveEventFromAllSeries(input: $input) {
      clientMutationId
      event {
        ...EventRow
      }
    }
  }
  ${EventRowFragmentDoc}
`;

export function useDeleteEventFromAllSeriesMutation() {
  return Urql.useMutation<
    DeleteEventFromAllSeriesMutation,
    DeleteEventFromAllSeriesMutationVariables
  >(DeleteEventFromAllSeriesDocument);
}
